import React, { useEffect, useRef, useState } from 'react';
import * as d3 from "d3";
import { Button, ButtonGroup, Col, Dropdown, Form, InputGroup, Overlay, Row, Tooltip, Image } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard'; //copy text to clipboard
import FeatherIcon from 'feather-icons-react';

import { v4 as uuidv4 } from 'uuid'; //unique id
// import { roundOffDecimal, measureConverter } from '../../../../../_services/common.service';
import i18n from "../../../../../_translations/i18n"; 
// import { checkSimulateSnapAllow } from '../../../AddMethods';
import { elmAccordingtoXY, GetContainingProdsByBox, getSnappingLocation } from '../mpsimCommenMethods';
import { convertUomtoSym, measureConverter, numOfDecimalsLimit, roundOffDecimal, stringtrim } from '../../../../../_services/common.service';
import { CodeSquareIcon, DiffAddedIcon, ListUnorderedIcon, SearchIcon, XIcon } from '@primer/octicons-react';

import { notSimulatedReason, catRuleEnums, catRectEnums, displayGroupName  } from '../../../../../enums/masterPlanogramEnums';
import { ReplaceProdIconArrow, FilterIconNew } from '../../../../../assets/icons/icons';
import { alertService } from '../../../../../_services/alert.service';
import Select from 'react-select';
import { PopoverWrapper, TooltipWrapper } from '../../../AddMethods';
import SalesCycleIcon from '../../../../../assets/img/icons/sale_cycle.png';
import ThreeDQtyIcon from '../../../../../assets/img/icons/3d_qty.png';
import SaleQtyIcon from '../../../../../assets/img/icons/sale_qty.png';
import DayCountIcon from '../../../../../assets/img/icons/day_count.png';
import MiniThreeDQtyIcon from '../../../../../assets/img/icons/mini_3d_qty.png';
import MiniSaleQtyIcon from '../../../../../assets/img/icons/mini_sale_qty.png';
import MiniDayCountIcon from '../../../../../assets/img/icons/mini_day_count.png';
import WarnIcon from '../../../../../assets/img/icons/warn_full.png';
import DefaultProdImg from '../../../../../assets/img/icons/default_W100_100.jpg';

  export class BlockRectangle extends React.Component {
    constructor(props){
        super(props);

        this._guideTimeout = null;
        this._dragStartXY = {x: 0, y: 0};

        this.state = {
            selectBlockObj: null, bkpBlockObj: null,
            droppingShelveIdx: -1, droppingShelveObj: null,
            isviewcmenu: false, contxtmenu: {xpos:0, ypos: 0, xidx: 0, scatidx: 0},
            spaceValidation: {isAllowToDrop: false, totalProductWidth: 0, totalShelfWidth: 0, restSpace: 0, movingProductBlockWidth: 0, selectedInlineShelfSet: []},
            // PEG CR - 2025 March
        }
    }
  
    componentDidMount() {
      let isInsidePeg = false;
      let droppedPegBoard = null;
      let insideHalfPegBoard = false;
      let halfOverlapCount = 0; // number of distinct pegs the product partially overlaps

      //#PDU-SM07 - d3 init
      const handleDrag = d3.drag()
        .subject(() => {
          const me = d3.select(this["LM01"]);
          return { x: me.attr('x'), y: me.attr('y') }
        })
        .on('start', (event) => {
          // console.log("START")
          this._dragStartXY = { x: event.x, y: event.y };
          this.props.dragStart(event, this.props.curitem.prod.productInfo, true);
        })
        .on('drag', (event) => {
          const me = d3.select(this["LM01"]);
          me.attr('x', event.x);
          me.attr('y', event.y);

          //scroll parent div with d3 drag
          let parent = document.getElementById(this.props.wrapperId);
          let zoomXRatio = this.props.zoomXRatio;

          let w = parent.offsetWidth; 
          let h = parent.offsetHeight;
          let sL = parent.scrollLeft;
          let sT = parent.scrollTop;

          // For peg board detection, use SVG viewBox coordinates (event.x/y are already in SVG coords)
          let movewidth = this.state.selectBlockObj?.drawWidth || 0;
          // For hanged products with a price tag, include the price tag height + gap in the total height.
          const _firstProd = this.state.selectBlockObj?.drawingProducts?.[0];
          const _priceTagHeightPx = (_firstProd?.isHanged && _firstProd?.hasPriceTag)
              ? (_firstProd?.priceTagHeight || 0) * this.props.displayratio : 0;
          const _priceTagGapPx = (_firstProd?.isHanged && _firstProd?.hasPriceTag)
              ? (_firstProd?.priceTagGap || 0) * this.props.displayratio : 0;
          let moveheight = (this.state.selectBlockObj?.drawHeight || 0) + _priceTagHeightPx + _priceTagGapPx;
          //let moveheight = (this.state.selectBlockObj?.drawHeight || 0);

          // For peg board boundary check - use original SVG coordinates
          let x = event.x;
          let x2 = event.x + movewidth;
          let y = event.y;
          let y2 = event.y + moveheight;

          // For scroll calculation - need screen/zoomed coordinates
          let scrollX = (event.x * (zoomXRatio > 0?(zoomXRatio + 1):1));
          let scrollX2 = scrollX + (movewidth * (zoomXRatio > 0?(zoomXRatio + 1):1));
          let scrollY = (event.y * (zoomXRatio > 0?(zoomXRatio + 1):1));
          let scrollY2 = scrollY + (moveheight * (zoomXRatio > 0?(zoomXRatio + 1):1));
          // PEG CR - 2025 March
          // check is it inside the peg boards
          // PEG CR Enhancement - when product overlaps multiple pegboards, pick the one
          // that contains the largest % of the product (largest overlap area).
          isInsidePeg = false;
          insideHalfPegBoard = false;
          droppedPegBoard = null;
          halfOverlapCount = 0;
          if(this.props.pegList){
            let bestFullInside = null;        // { pegBoard }
            let bestHalfOverlap = null;       // { pegBoard, area }
            // Prefer the pegboard whose Y range contains the product's top edge.
            // Why: for stacked pegboards a hanging product hangs from its top peg,
            // so the pegboard under the product's top is the correct owner.
            let bestTopOwner = null;          // { pegBoard, area }
            for (let i = 0; i < this.props.pegList.length; i++) {
              const {pegDrawingRect} = this.props.pegList[i];

              let pegBoardStartX = pegDrawingRect.drawX;
              let pegBoardStartY = pegDrawingRect.drawY;

              let pegBoardEndX = pegDrawingRect.drawX + pegDrawingRect.drawRectWidth;
              let pegBoardEndY = pegDrawingRect.drawY + pegDrawingRect.drawRectHeight;

              // Check if the product is fully inside the peg board
              if(pegBoardStartX < x && pegBoardEndX > x2 && pegBoardStartY < y && pegBoardEndY > y2){
                bestFullInside = this.props.pegList[i];
                break; // fully-inside is unambiguous, take it
              }
              // Check overlap area against current best half-overlap candidate
              else if (
                (x < pegBoardEndX && x2 > pegBoardStartX) && // Horizontally overlapping
                (y < pegBoardEndY && y2 > pegBoardStartY) // Vertically overlapping
              ) {
                let productWidth = movewidth;
                let productHeight = moveheight;

                let overlapWidth = Math.min(x2, pegBoardEndX) - Math.max(x, pegBoardStartX);
                let overlapHeight = Math.min(y2, pegBoardEndY) - Math.max(y, pegBoardStartY);
                let overlapArea = overlapWidth * overlapHeight;

                // Calculate percentage of product width and height overlapping with peg board
                let widthOverlapPercent = (overlapWidth / productWidth) * 100;
                let heightOverlapPercent = (overlapHeight / productHeight) * 100;

                // If at least 3% of the width or height is inside the peg board, consider as candidate
                if (widthOverlapPercent >= 3 || heightOverlapPercent >= 3) {
                  halfOverlapCount++;
                  if(!bestHalfOverlap || overlapArea > bestHalfOverlap.area){
                    bestHalfOverlap = { pegBoard: this.props.pegList[i], area: overlapArea };
                  }
                  // Pegboard owns the product's top edge -> preferred candidate
                  if(pegBoardStartY <= y && y <= pegBoardEndY){
                    if(!bestTopOwner || overlapArea > bestTopOwner.area){
                      bestTopOwner = { pegBoard: this.props.pegList[i], area: overlapArea };
                    }
                  }
                }
              }
            }

            if(bestFullInside){
              isInsidePeg = true;
              insideHalfPegBoard = false;
              droppedPegBoard = bestFullInside;
            }else if(bestHalfOverlap){
              isInsidePeg = false;
              insideHalfPegBoard = true;
              if(this.props.isDropToPegBoard === true){
                // Prefer the pegboard that contains the product's top edge,
                // otherwise fall back to the largest-overlap pegboard.
                droppedPegBoard = (bestTopOwner ? bestTopOwner.pegBoard : bestHalfOverlap.pegBoard);
              }else{
                droppedPegBoard = null;
              }
            }
          }

          //if dragging horizontal - use zoomed coordinates for scroll
          if (scrollX2 > w + sL) {
            parent.scrollLeft = (scrollX2 - w);
          } else if (scrollX < sL) {
            parent.scrollLeft = (scrollX);
          }

          //if dragging vertical - use zoomed coordinates for scroll
          if (scrollY2 > h + sT) {
            parent.scrollTop = (scrollY2 - h);
          } else if (scrollY < sT) {
            parent.scrollTop = (scrollY);
          }
          // PEG CR Enhancement - show guidelines when not fully inside pegboard
          // Half-overlap products may be placed on shelf, so guidelines are needed
          if(!isInsidePeg){
            this.onDragGuidline(event,event.x,event.y);
          }
        })
        .on('end', (event) => {
          // PEG CR Enhancement - allow hanging products to be placed partially inside pegboard
          // Also allow already-hanged products to be moved within the peg board even when isDropToPegBoard is false
          const isMovingHangedProduct = this.state.selectBlockObj?.drawingProducts?.some(p => p.isHanged);

          if(isInsidePeg && (this.props.isDropToPegBoard || isMovingHangedProduct)){
            this.handleProductsDropInsidePegBoard(event, event.x, event.y, droppedPegBoard)
          }else if(insideHalfPegBoard && (this.props.isDropToPegBoard || isMovingHangedProduct)){
            // Check if the product is hangable or already hanged - if so, route to pegboard placement
            let isHangableProduct = this.state.selectBlockObj?.drawingProducts?.some(p => p.isHangable);
            if((isHangableProduct || isMovingHangedProduct) && droppedPegBoard){
              // Hanging product partially overlapping pegboard - allow peg placement (product can extend below)
              this.handleProductsDropInsidePegBoard(event, event.x, event.y, droppedPegBoard)
            }else{
              // Non-hangable product partially overlapping pegboard - allow shelf placement
              this.updateSaveObjV2(event,event.x,event.y , this.props.mapFields);
            }
            //#119
          // }else if(insideHalfPegBoard && !this.props.isDropToPegBoard && !isMovingHangedProduct){
          //   // Shelf mode + partial pegboard overlap.
          //   // If the product clips exactly ONE peg (e.g. hangs slightly below a peg's
          //   // bottom edge) it's a valid shelf placement — allow it.
          //   // If it straddles TWO or more pegs it is crossing a peg boundary — reject
          //   // to preserve the previously-fixed multi-peg straddle behaviour.
          //   if(halfOverlapCount <= 1){
          //     this.updateSaveObjV2(event, event.x, event.y, this.props.mapFields);
          //   }else{
          //     alertService.error(i18n.t('PRODUCT_OVERLAPS_PEGBOARD'), 4000);
          //     this.resetToOriginalState();
          //     clearTimeout(this._guideTimeout);
          //   }
          }else{
            //this.updateSaveObjV2(event,event.x,event.y , this.props.actualFieldStructuresNew); // OLD CODE CHANGE
            this.updateSaveObjV2(event,event.x,event.y , this.props.mapFields); // NEW CODE CHANGE 2025 - OCT
          }
        });

        this.props.groupByProduct();

        let selectedObj = this.props.currentSelectedBlock;
        let isDel = false;
        selectedObj?.drawingProducts?.forEach((item) => {
          if (item.isProductDelete) {
            isDel = true;
          }
        })

        if (!isDel) {
          handleDrag(d3.select(this["LM01"]));
        }
      
      //#PDU-SM08
      var handleResizeXLeft = d3.drag()
        .subject(() => {
          const me = d3.select(this["rsx_left"]);
          return { x: me.attr('x'), y: me.attr('y') }
        })
        .on('drag', (event) => {
          let isallowresize = this.checkAllowMoveResize(event, false);
          if(isallowresize.isallow){
            const me = d3.select(this["rsx_left"]);
            me.attr('x', event.x);
          }
        })
        .on('end', (event) => {
          this.checkAllowMoveResize(event, false, true);
        });
      handleResizeXLeft(d3.select(this["rsx_left"]));
  
      var handleResizeXRight = d3.drag()
        .subject(() => {
          const me = d3.select(this["rsx_right"]);
          return { x: me.attr('x'), y: me.attr('y') }
        })
        .on('drag', (event) => {
          let isallowresize = this.checkAllowMoveResize(event, true);
          if(isallowresize.isallow){
            const me = d3.select(this["rsx_right"]);
            me.attr('x', event.x);
          }
        })
        .on('end', (event) => {
          this.checkAllowMoveResize(event, true, true);
        });
      handleResizeXRight(d3.select(this["rsx_right"]));
  
      //#PDU-SM09 - calc new product block
      let prodinfo = this.props.curitem.prod;
      let blockobj = this.props.currentSelectedBlock;
      //recalc
      if(blockobj){
        var firsttime=true
        let startx = 0; let starty = 0; 
        let endx = 0, endy = 0;
        let maximx = 0;
        let sortlowYprods = blockobj.drawingProducts.sort((a,b) => a.y - b.y);
        starty = sortlowYprods[0].y
        for (let i = 0; i < blockobj.drawingProducts.length; i++) {
          const locitem = blockobj.drawingProducts[i];
          
          if(!locitem.isDelete){
            //set lowest x
            if(firsttime){
              startx = locitem.x;
            }else{
              if( startx > locitem.x){
                startx = locitem.x;
              }
            }
            //set highest x
            if(endx === 0 || endx < (locitem.x + locitem.drawWidth)){
              endx = (locitem.x + locitem.drawWidth);
            }
            //set highest y
            if(endy === 0 || endy < (locitem.y + locitem.drawHeight)){
              endy = (locitem.y + locitem.drawHeight);
            }
  
            if(locitem.x > maximx){
              maximx = locitem.x;
            }
          }
          firsttime=false
        }
        
        let drawwidth = (endx - startx);
        let drawheight = (endy - starty);
        let blocktotalwidth = (drawwidth / this.props.displayratio);
        let blocktotalheight = (drawheight / this.props.displayratio);
        
        blockobj.x = startx;
        blockobj.OrigX = startx
        blockobj.y = starty;
        blockobj.width = blocktotalwidth;
        blockobj.height = blocktotalheight;
        blockobj.uom = prodinfo.uom;
        blockobj.drawWidth = drawwidth;
        blockobj.drawHeight = drawheight;
        blockobj.newDrawingProducts = JSON.parse(JSON.stringify(blockobj.drawingProducts));
        var movingObj=this.setmovingObj( blockobj.newDrawingProducts);
        blockobj.selectedshelves=movingObj
        this.setState({ selectBlockObj: blockobj, bkpBlockObj: JSON.parse(JSON.stringify(blockobj)) },()=>{});
      }
  
    }

    componentDidUpdate(){
      if(this.props.removeGhost){
        this.setState({selectBlockObj:null})
        this.props.resetSelectBlockObj();
      }
    }
    
    componentWillUnmount(){
      if(this._guideTimeout){
        clearTimeout(this._guideTimeout);
      }
    }

    setmovingObj=(drawingprods)=>{
      // Group the selected products into visual rows (one entry per physical level).
      //
      // This used to group by `shelfrank`, but a product's shelfrank is relative to
      // its own field. Two products sitting on the SAME physical level can have
      // different shelfranks when they belong to different fields placed side by side
      // (e.g. shelfrank 5 of field 27093 and shelfrank 3 of field 27094 both at y=280.5).
      // Grouping by shelfrank then split a single visual row into several "shelves",
      // so the drag preview/drop drew the block across multiple shelves with the wrong
      // width. Group by the product's bottom edge (y + drawHeight) instead - that is the
      // shelf surface every product on a row is bottom-aligned to (see drop logic where
      // y = containshelf.y + containshelf.drawHeight - drawHeight).
      const LEVEL_TOLERANCE = 2; // px - bottom edges within this gap are the same row

      // Cluster products by level, preserving first-appearance order so the index-based
      // selectedshelves[m] -> containshelfs[m] mapping keeps its existing behaviour for
      // genuine multi-shelf selections.
      var levelGroups = [];
      for (let i = 0; i < drawingprods.length; i++) {
        const prod = drawingprods[i];
        const bottom = (prod.y + prod.drawHeight);
        let group = levelGroups.find(g => Math.abs(g.bottom - bottom) <= LEVEL_TOLERANCE);
        if(group === undefined){
          group = { bottom: bottom, products: [] };
          levelGroups.push(group);
        }
        group.products.push(prod);
      }

      var slevtedShelves=[]
      for (let g = 0; g < levelGroups.length; g++) {
        var ele = levelGroups[g].products
        var heightsetProd=0
        for (let i = 0; i < ele.length; i++) {
          const prod = ele[i];
          if(heightsetProd<prod.drawHeight){
            heightsetProd=prod.drawHeight
          }
        }

        let sortlowxprods = ele.sort((a,b) => a.x - b.x);
        let lowprodx = roundOffDecimal(sortlowxprods[0].x,2);
        let highprodx = roundOffDecimal((sortlowxprods[(sortlowxprods.length - 1)].x + sortlowxprods[(sortlowxprods.length - 1)].drawWidth),2);

        var obj = {
          rank: ele[0].shelfrank,
          heighestdrawingProduct: heightsetProd,
          selectedProducts: ele,
          lowProdX: lowprodx,
          highProdX: highprodx,
        }
        slevtedShelves.push(obj)
      }
      return slevtedShelves
    }
    
    //#PDU-SM10 - check if allow to resize or move rect
    checkAllowMoveResize = (event, isoppside, isend, isychange) => {
      
      let oriblockobj = this.state.bkpBlockObj;
      const blockobj = this.state.selectBlockObj;
  
      //if resize/move allowed
      let isallowchange = {isallow: false};
  
      if(!isoppside){
        if(event.x > oriblockobj.x && event.x < ((oriblockobj.x + oriblockobj.drawWidth) - 10)){
          isallowchange.isallow = true;
        }
      } else{
        if(event.x < (oriblockobj.x + oriblockobj.drawWidth) && event.x > (oriblockobj.x + 10)){
          isallowchange.isallow = true;
        }
      }
      
      if(isend && isallowchange.isallow){
        //adjust x
        for (let i = 0; i < oriblockobj.drawingProducts.length; i++) {
          const prodlocation = oriblockobj.drawingProducts[i];
          
          if(isychange){
            
            if(prodlocation.y <= event.y && (prodlocation.y + prodlocation.drawHeight) >= event.y){
              if(!isoppside){
                let ygap = (prodlocation.y - blockobj.y);
                blockobj.drawHeight = (blockobj.drawHeight - ygap);
                blockobj.height = (blockobj.drawHeight / this.props.displayratio);
  
                blockobj.y = prodlocation.y;
              } else{
                blockobj.drawHeight = ((prodlocation.y + prodlocation.drawHeight) - oriblockobj.y);
                blockobj.height = (blockobj.drawHeight / this.props.displayratio);
              }
            }
          } else{
            if(prodlocation.x <= event.x && (prodlocation.x + prodlocation.drawWidth) >= event.x){
              if(!isoppside){
                //left
                let xgap = (prodlocation.x - blockobj.x);
                blockobj.drawWidth = (blockobj.drawWidth - xgap);
                blockobj.width = (blockobj.drawWidth / this.props.displayratio);
  
                blockobj.x = prodlocation.x;
              } else{
                blockobj.drawWidth = ((prodlocation.x + prodlocation.drawWidth) - this.state.selectBlockObj.x);
                blockobj.width = (blockobj.drawWidth / this.props.displayratio);
              }
            }
          }
        }
        //filter inside blockobj product locations
        blockobj.newDrawingProducts = oriblockobj.drawingProducts.filter( xitem => 
          xitem.x >= blockobj.x && (xitem.x + xitem.drawWidth) <= (blockobj.x + blockobj.drawWidth) &&
          xitem.y >= blockobj.y && (xitem.y + xitem.drawHeight) <= (blockobj.y + blockobj.drawHeight)
        );
        
        if(!isoppside){
          if(isychange){
            const me = d3.select(this["rsy_top"]);
            me.attr('y', blockobj.y);
          } else{
            const me = d3.select(this["rsx_left"]);
            me.attr('x', blockobj.x);
          }
          
        } else{
          if(isychange){
            const me = d3.select(this["rsy_bottom"]);
            me.attr('y', (blockobj.y + blockobj.drawHeight));
          } else{
            const me = d3.select(this["rsx_right"]);
            me.attr('x', (blockobj.x + blockobj.drawWidth));
          }
        }
  
        this.setState({ selectBlockObj: blockobj });
      }
  
      //console.log(isallowchange);
      return isallowchange;
    }

    //find which shelve product moving and validate is it can add to shelve
    onDragGuidline = (evt,cx,cy) => {
      
      if(this._guideTimeout){ 
        clearTimeout(this._guideTimeout); 
        if(this.props.isFirstTimeDrawguid){
          this.props.setPreviewGuid(false, null, null, true, []);
        }
      }

      this._guideTimeout = setTimeout(() => {
        this.Setguidline(evt,cx,cy);
      }, 50);
    }

    // set space validation
    setSpaceValidation = (isAllowToDrop, totalProductWidth, totalShelfWidth, restSpace, movingProductBlockWidth, selectedInlineShelfSet) => {
      this.setState({ spaceValidation: { isAllowToDrop, totalProductWidth, totalShelfWidth, restSpace, movingProductBlockWidth, selectedInlineShelfSet } });
    }

    Setguidline=(evt,cx,cy)=>{
      var props={
        evt:evt,
        cx:cx,
        cy:cy,
        selectBlockObj:this.state.selectBlockObj,
        mapFields:this.props.mapFields,
        mapCatRects:this.props.mapCatRects,
        mapproductList:this.props.mapproductList,
        setPreviewGuid:this.props.setPreviewGuid,
        updateGhostObjDetails:this.props.updateGhostObjDetails,
        setSpaceValidation: this.setSpaceValidation,
        actualFieldStructuresNew:this.props.actualFieldStructuresNew,
        pegList:this.props.pegList,
        displayRatio:this.props.displayratio,
      }
      setGuidlineComman(props)
    }

    
    //#PDU-SM11 - update new block changes and save main object
    updateSaveObj = (evt,cx,cy) => {
      let checkSaftyMargin = 3;
      let dragStartXY = this._dragStartXY;

      if(dragStartXY.x !== cx || dragStartXY.y !== cy){
        let historydata = null;
        let movingObj = structuredClone(this.state.selectBlockObj);
        let dropallow = true;

        var MOStartX = roundOffDecimal(cx,2);
        var MOStartY = roundOffDecimal(cy,2);
        var MOEndX = roundOffDecimal((cx + movingObj.drawWidth),2);
        var MOEndY = roundOffDecimal((cy + movingObj.drawHeight),2);
  
        var containElem = elmAccordingtoXY(cx,cy,movingObj.drawWidth,movingObj.drawHeight,this.props.mapFields,this.props.mapCatRects)

        var selectingField = containElem.field;
        
        if(containElem.isInsideShelf&& selectingField){
          var fieldStartX = roundOffDecimal(selectingField.x,2);
          var fieldStartY = roundOffDecimal(selectingField.y,2);
          var fieldEndX = roundOffDecimal((selectingField.x+selectingField.drawWidth),2);
          var fieldEndY = roundOffDecimal((selectingField.x+selectingField.drawHeight),2);
         
          let isinsidefield = false;
          //check moving box is inside field
          if((fieldStartX < MOStartX && fieldEndX > MOEndX) && (fieldStartY < MOStartY && fieldEndY > MOEndY)){
            isinsidefield = true;
          } else{
            if(fieldStartY < MOStartY && fieldEndY > MOEndY){
              //if item x1 is less than field x1 and item x2 not greater than field x2
              
              if(fieldStartX > MOStartX && fieldEndX > MOEndX){
                MOStartX = fieldStartX;
                isinsidefield = true;
              }
              //if item x1 is greater than field x1 and item x2 not less than field x2
              if(fieldStartX < MOStartX && fieldEndX < MOEndX){
                MOStartX = roundOffDecimal((fieldEndX - movingObj.drawWidth),2);
                isinsidefield = true;
              }
            }

            //if block inside field but not from bottom of field
            if((fieldStartX < MOStartX && fieldEndX > MOEndX) && fieldStartY < MOStartY){
              MOStartY = roundOffDecimal((fieldEndY - selectingField.drawHeight),2);
              MOEndY = roundOffDecimal(fieldEndY,2);
              isinsidefield = true;
            }
          }
          
          //if is it inside field
          if(isinsidefield){
            historydata=JSON.parse(JSON.stringify(this.props.mapproductList))

            var existingProducts = JSON.parse(JSON.stringify(this.props.mapproductList));
            let changefield = this.props.mapFields[selectingField.key];
            //console.log("loc2");
            var containProds = GetContainingProdsByBox(MOStartX , MOStartY, MOEndX, MOEndY, existingProducts, changefield, false, null, [], true);

            // console.log("loc12",MOStartX , MOStartY, MOEndX, MOEndY, existingProducts, changefield);
            let lowestprodx = MOStartX;
            let cutshelfs = []; 
            let droppingXProd = null; //to find prod available in dropping x1 position
            let isDropPosBetweenEnd = false;
            let isRightSideDropXProd = false;

            if(containProds.selectedProds&&containProds.selectedProds.length>0){
              var notDeletedContainProds = containProds.selectedProds.filter(f => !f.isDelete);
  
              for (let p = 0; p < notDeletedContainProds.length; p++) {
                const prod = notDeletedContainProds[p];
                // movingObj.selectedshelves.forEach(ele => {
                  for (let j = 0; j < movingObj.selectedshelves.length; j++) {
                    const ele = movingObj.selectedshelves[j];
                    var ishaveinSlectedshleves=ele.selectedProducts.find(x=>x.id===prod.id)
                      //check save moving produtcs not cutting
                      if(ishaveinSlectedshleves === undefined){
                        let prodstartx = (prod.x);
                        
                        let checkprodwidth = (((prod.drawWidth / 3) > 8)?(prod.drawWidth / 3):(prod.drawWidth / 2));
                        let prodmiddlex = (prod.x + checkprodwidth);
                        
                        if(lowestprodx > prodstartx && lowestprodx < prodmiddlex){
                          lowestprodx = prod.x;
                        }
                        
                        //left side
                        let prodendx = roundOffDecimal((prod.x + prod.drawWidth),2);
                        if((prod.x <= MOStartX && MOStartX <= prodendx)){
                          droppingXProd = prod;

                          let lowSaftyStartX = (MOStartX - checkSaftyMargin);
                          let highSaftyStartX = (MOStartX + checkSaftyMargin);

                          if(lowSaftyStartX <= prodendx && highSaftyStartX >= prodendx){
                            isDropPosBetweenEnd = true;
                          }
                        }

                        //right side
                        if(!droppingXProd && (prod.x <= MOEndX && MOEndX <= (prod.x + prod.drawWidth))){
                          droppingXProd = prod;
                          isRightSideDropXProd = true;

                          let lowSaftyEndX = (MOEndX - checkSaftyMargin);
                          let highSaftyEndX = (MOEndX + checkSaftyMargin);

                          if(lowSaftyEndX <= prodstartx && highSaftyEndX >= prodstartx){
                            isDropPosBetweenEnd = true;
                          }
                        }
                      }
                  }
                  
                // });
               
              }
            }
  
            let containshelfs = (selectingField.contain_shelfs?selectingField.contain_shelfs:[]);
            
            //if dropping position x not have product find last left product x to drop
            // commented get snapping location - (automatically magnetizes a product to another product)
            let isRightFieldUpdated = false;
            // if(!droppingXProd){
            //   lowestprodx = getSnappingLocation(lowestprodx, selectingField, existingProducts, movingObj, containshelfs);
            // }

            lowestprodx = (
              droppingXProd && isDropPosBetweenEnd && isRightSideDropXProd?(droppingXProd.x - movingObj.drawWidth):
              droppingXProd && isDropPosBetweenEnd?(droppingXProd.x + droppingXProd.drawWidth):
            lowestprodx);

            //if end x is more than field end x
            let checkheighstx = (lowestprodx + movingObj.drawWidth);
            //left side
            if(lowestprodx <= selectingField.x){
              lowestprodx = selectingField.x;
            }

            //right side
            if(checkheighstx >= (selectingField.x+selectingField.drawWidth)){
              lowestprodx = ((selectingField.x+selectingField.drawWidth) - movingObj.drawWidth);
            }

            var maxEndX = 0; var maxY = 0; var maxEndY = 0;
            for (let m = 0; m < movingObj.selectedshelves.length; m++) {
              const changeshelf = movingObj.selectedshelves[m];
              
              //if found
              if(containshelfs[m]){
                //check shelf is lager than highest product in shelve line
                if((containshelfs[m].drawHeight<changeshelf.heighestdrawingProduct
                  // ||containshelfs[m].drawHeight===changeshelf.heighestdrawingProduct
                  )
                  ){
                  dropallow = false
                  //dont drop 
                  break
                }
                let curshelfitemy = (containshelfs[m]?(containshelfs[m].y + containshelfs[m].drawHeight):0);
                //dragfromcat
                this.props.TouchedCatListUpdate(changeshelf.selectedProducts?.[0]?.categoryRectId)
                for (let k = 0; k < changeshelf.selectedProducts.length; k++) {
                  const changeproditem = changeshelf.selectedProducts[k];
                  
                  let gapbetweenoribox = (changeproditem.x - movingObj.x);

                  changeproditem["x"] = (lowestprodx + gapbetweenoribox);
                  changeproditem["y"] = (curshelfitemy - changeproditem.drawHeight);
                  changeproditem["shelfrank"] = containshelfs[m].rank;
                  changeproditem["field_custom_id"] = containshelfs[m].field_custom_id;
                  changeproditem["categoryRectId"] = containElem.catrect.catrectId;
                  
                  existingProducts[changeproditem.prodidx] = changeproditem;
                  existingProducts[changeproditem.prodidx]["isDelete"] = false;
                  
                  if(maxY<changeproditem.y){
                    maxY=changeproditem.y
                    maxEndY=changeproditem.y+changeproditem.drawHeight;
                  }
  
                  let curprodendx = (changeproditem.x + changeproditem.drawWidth);
                  if(curprodendx > maxEndX){
                    maxEndX = curprodendx
                  }
                } 
               
              }
              
            }
            
            var newMOEndY = roundOffDecimal(maxEndY - this.props.checkSaftyMargin,2);
            // var saftyMargintoStart=1
            
            //console.log("loc3"); +saftyMargintoStart)
            var ccontainProds = GetContainingProdsByBox(lowestprodx, MOStartY, maxEndX, newMOEndY, this.props.mapproductList, changefield, true, movingObj, containshelfs);
            // console.log(ccontainProds);

            // console.log("loc14",(lowestprodx+saftyMargintoStart), MOStartY, maxEndX, newMOEndY, this.props.mapproductList, changefield, true, movingObj, containshelfs);
            if(dropallow){
              if(historydata!==null){
                this.props.fieldHistoryAdd(historydata,1);
              }
              let isruleupdating = false;
              //removingcutting prod
              if(ccontainProds.selectedProds&&ccontainProds.selectedProds.length>0){
                var cnotDeletedContainProds = ccontainProds.selectedProds.filter(f => !f.isDelete);
                
                for (let p = 0; p < cnotDeletedContainProds.length; p++) {
                  const prod = cnotDeletedContainProds[p];
                  // console.log(prod.x);
                  prod["startingPointDraw"]=prod.x
                  prod["startingPoint"]=prod.x/this.props.displayratio
                  prod.isNew= true
                  prod.isDelete= false
                  let isincontainshelfs = containshelfs.findIndex(l => l.rank === prod.shelfrank);
  
                  if(isincontainshelfs > -1){
                    var ishaveinSelectedshleves = movingObj.newDrawingProducts.find(x => x.id === prod.id);
                    //check save moving produtcs not cutting
                    if(ishaveinSelectedshleves === undefined){
                      let findshelfitemidx = cutshelfs.findIndex(x => x.shelfrank === prod.shelfrank);
  
                      if(findshelfitemidx > -1){
                        cutshelfs[findshelfitemidx].products.push(prod);
                      } else{
                        cutshelfs.push({ shelfrank: prod.shelfrank, products: [prod] });
                      }
                      
                      existingProducts[prod.prodidx]["isDelete"] = true;
                      
                      if(existingProducts[prod.prodidx].subcategory && existingProducts[prod.prodidx].subcategory.type === catRectEnums.rule){
                          isruleupdating = true;
                      }
                    } 
                  }
                }
              }
  
              const arrayHashmap = cutshelfs.reduce((obj, item) => {
                obj[item.shelfrank] ? obj[item.shelfrank].products.push(...item.products) : (obj[item.shelfrank] = { ...item });
                return obj;
              }, {});
              
              const mergedArray = Object.values(arrayHashmap);
              var selcutlist={
                groupUUID: uuidv4(),isNew:true, isDelete: false, mode:"cut" ,uom:containshelfs[0].uom,shelf:mergedArray
              }
              //drop to cat update touchedcat list
              this.props.TouchedCatListUpdate(containElem.catrect.catrectId)
  
              this.props.updateProductList(existingProducts, isruleupdating);
              this.props.updateCutList(selcutlist);
              // console.log(cutshelfs);
              this.setState({selectBlockObj:null})
            }else{
              alertService.error(i18n.t("SOME_PRoD_HEIGHT_EXCEED_SELECTED_SHELF_HEIGHT"),4000);
              this.resetToOriginalState()
              clearTimeout(this._guideTimeout); 
            }
            
  
          }else{
            this.resetToOriginalState()
          }
        }else{
          this.resetToOriginalState()
        }
        
        this.props.setPreviewGuid(true,null,selectingField)
      }
    }


    // Version 2 changes in here
    updateSaveObjV2 = (evt,cx,cy,actualFieldStructuresNew) => {
      console.log('____', this.state.spaceValidation);
      const {isAllowToDrop, movingProductBlockWidth, totalProductWidth} = this.state.spaceValidation;
      if(!isAllowToDrop){
        // when product block double click prevent show below error msg.
        if (movingProductBlockWidth !== 0 && movingProductBlockWidth !== null && movingProductBlockWidth !== undefined) {
          console.log('No space available for dropped product set');
           alertService.error(i18n.t('NO_SPACE_AVALIBLE_FOR_DROPPED_PRODUCT_SET'), 4000);
        }
        //#119
        //this.resetToOriginalState() // NEW CHANGE IN 2025 - OCT
        this.props.setPreviewGuid(true, null, null, true, []); // #119
        clearTimeout(this._guideTimeout);
        this.setState({
          spaceValidation: {isAllowToDrop: false, totalProductWidth: 0, totalShelfWidth: 0, restSpace: 0, movingProductBlockWidth: 0, selectedInlineShelfSet: []}
        })
        return
      }
      let checkSaftyMargin = 3;
      let dragStartXY = this._dragStartXY;

      if(dragStartXY.x !== cx || dragStartXY.y !== cy){
        let historydata = null;
        let movingObj = structuredClone(this.state.selectBlockObj);
        let dropallow = true;

        var MOStartX = roundOffDecimal(cx,2);
        var MOStartY = roundOffDecimal(cy,2);
        var MOEndX = roundOffDecimal((cx + movingObj.drawWidth),2);
        var MOEndY = roundOffDecimal((cy + movingObj.drawHeight),2);
  
        var containElem = elmAccordingtoXY(cx,cy,movingObj.drawWidth,movingObj.drawHeight,this.props.mapFields,this.props.mapCatRects)

        var selectingField = containElem.field;
        
        if(!selectingField?.masterFieldId) return

        // OLD DEVELOPMENT CODE
        // const matchingField = Object.keys(actualFieldStructuresNew).find(
        //   field => field.masterFieldId === selectingField.masterFieldId
        // );

        // NEW DEVELOPMENT CODE 2025 - OCT
        const matchingFieldKey = Object.keys(actualFieldStructuresNew).find(
          (key) => actualFieldStructuresNew[key].masterFieldId === selectingField.masterFieldId
        );
        //#119
        const matchingField = actualFieldStructuresNew[matchingFieldKey].masterFieldId;

        if(containElem.isInsideShelf&& selectingField){
          var fieldStartX = roundOffDecimal(selectingField.x,2);
          var fieldStartY = roundOffDecimal(selectingField.y,2);
          //var fieldEndX = roundOffDecimal((selectingField.x+selectingField.drawWidth),2);
          //#119
          var fieldEndX = roundOffDecimal((selectingField.x+selectingField.drawWidth+matchingField?.drawWidth),2);
          var fieldEndY = roundOffDecimal((selectingField.y+selectingField.drawHeight),2);

          let isinsidefield = false;
          //check moving box is inside field
          if((fieldStartX < MOStartX && fieldEndX > MOEndX) && (fieldStartY < MOStartY && fieldEndY > MOEndY)){
            isinsidefield = true;
          } else{
            if(fieldStartY < MOStartY && fieldEndY > MOEndY){
              //if item x1 is less than field x1 and item x2 not greater than field x2
              
              if(fieldStartX > MOStartX && fieldEndX > MOEndX){
                MOStartX = fieldStartX;
                isinsidefield = true;
              }
              //if item x1 is greater than field x1 and item x2 not less than field x2
              if(fieldStartX < MOStartX && fieldEndX < MOEndX){
                isinsidefield = true;
              }
            }

            //if block inside field but not from bottom of field
            if((fieldStartX < MOStartX && fieldEndX > MOEndX) && fieldStartY < MOStartY){
              // MOStartY = roundOffDecimal((fieldEndY - selectingField.drawHeight),2);
              // MOEndY = roundOffDecimal(fieldEndY,2);
              isinsidefield = true;
            }
          }

          //if is it inside field
          if(isinsidefield){
            historydata=JSON.parse(JSON.stringify(this.props.mapproductList))

            var existingProducts = JSON.parse(JSON.stringify(this.props.mapproductList));
            let changefield = this.props.mapFields[selectingField.key];
            var containProds = GetContainingProdsByBox(MOStartX , MOStartY, MOEndX, MOEndY, existingProducts, changefield, false, null, [], true);

            let lowestprodx = MOStartX;
            let cutshelfs = []; 
            let droppingXProd = null; //to find prod available in dropping x1 position
            let isDropPosBetweenEnd = false;
            let isRightSideDropXProd = false;

            if(containProds.selectedProds&&containProds.selectedProds.length>0){
              var notDeletedContainProds = containProds.selectedProds.filter(f => !f.isDelete);
  
              for (let p = 0; p < notDeletedContainProds.length; p++) {
                const prod = notDeletedContainProds[p];
                // movingObj.selectedshelves.forEach(ele => {
                  for (let j = 0; j < movingObj.selectedshelves.length; j++) {
                    const ele = movingObj.selectedshelves[j];
                    var ishaveinSlectedshleves=ele.selectedProducts.find(x=>x.id===prod.id)
                      //check save moving produtcs not cutting
                      if(ishaveinSlectedshleves === undefined){
                        let prodstartx = (prod.x);
                        
                        let checkprodwidth = (((prod.drawWidth / 3) > 8)?(prod.drawWidth / 3):(prod.drawWidth / 2));
                        let prodmiddlex = (prod.x + checkprodwidth);
                        
                        if(lowestprodx > prodstartx && lowestprodx < prodmiddlex){
                          lowestprodx = prod.x;
                        }
                        
                        //left side
                        let prodendx = roundOffDecimal((prod.x + prod.drawWidth),2);
                        if((prod.x <= MOStartX && MOStartX <= prodendx)){
                          droppingXProd = prod;

                          let lowSaftyStartX = (MOStartX - checkSaftyMargin);
                          let highSaftyStartX = (MOStartX + checkSaftyMargin);

                          if(lowSaftyStartX <= prodendx && highSaftyStartX >= prodendx){
                            isDropPosBetweenEnd = true;
                          }
                        }

                        //right side
                        if(!droppingXProd && (prod.x <= MOEndX && MOEndX <= (prod.x + prod.drawWidth))){
                          droppingXProd = prod;
                          isRightSideDropXProd = true;

                          let lowSaftyEndX = (MOEndX - checkSaftyMargin);
                          let highSaftyEndX = (MOEndX + checkSaftyMargin);

                          if(lowSaftyEndX <= prodstartx && highSaftyEndX >= prodstartx){
                            isDropPosBetweenEnd = true;
                          }
                        }
                      }
                  }
                  
                // });
               
              }
            }
  
            let containshelfs = (selectingField.contain_shelfs?selectingField.contain_shelfs:[]);
            
            lowestprodx = (
              droppingXProd && isDropPosBetweenEnd && isRightSideDropXProd?(droppingXProd.x - movingObj.drawWidth):
              droppingXProd && isDropPosBetweenEnd?(droppingXProd.x + droppingXProd.drawWidth):
            lowestprodx);

            // if end x is more than field end x
            let checkheighstx = (lowestprodx + movingObj.drawWidth);
            //left side
            if(lowestprodx <= selectingField.x){
              lowestprodx = selectingField.x;
            }

            // right side
            if(checkheighstx >= (selectingField.x+selectingField.drawWidth+matchingField.drawWidth)){
              // lowestprodx = ((selectingField.x+selectingField.drawWidth+matchingField.drawwidth) - movingObj.drawWidth);
            }

            var maxEndX = 0; var maxY = 0; var maxEndY = 0;
            let droppedFiledCustomId = null;
            let droppedFieldMasterFieldId =null;
            for (let m = 0; m < movingObj.selectedshelves.length; m++) {
              const changeshelf = movingObj.selectedshelves[m];
              
              //if found
              if(containshelfs[m]){
                //check shelf is lager than highest product in shelve line
                if((containshelfs[m].drawHeight<changeshelf.heighestdrawingProduct
                  // ||containshelfs[m].drawHeight===changeshelf.heighestdrawingProduct
                  )
                  ){
                  dropallow = false
                  //dont drop 
                  break
                }
                let curshelfitemy = (containshelfs[m]?(containshelfs[m].y + containshelfs[m].drawHeight):0);
                //dragfromcat
                this.props.TouchedCatListUpdate(changeshelf.selectedProducts?.[0]?.categoryRectId)
                for (let k = 0; k < changeshelf.selectedProducts.length; k++) {
                  const changeproditem = changeshelf.selectedProducts[k];
                  
                  let gapbetweenoribox = (changeproditem.x - movingObj.x);
                  changeproditem["x"] = (lowestprodx + gapbetweenoribox);
                  changeproditem["y"] = (curshelfitemy - changeproditem.drawHeight);
                  changeproditem["shelfrank"] = containshelfs[m].rank;
                  changeproditem["field_custom_id"] = containshelfs[m].field_custom_id;
                  changeproditem["masterFieldId"] = selectingField?.masterFieldId;
                  // 2025 OCT NEW CHANGE
                  changeproditem["productPlaceShelfHeight"] = containshelfs[m].height; // update shelf height in product when product moved
                  changeproditem["mark_height_issue"] = containshelfs[m].height < changeproditem.height ? true : false; // mark height issue if shelf height less than product height
                  // changeproditem["isHanged"] = false;
                  // NEW CR
                  // this one use to product re arrange
                  droppedFiledCustomId = containshelfs[m].field_custom_id;
                  droppedFieldMasterFieldId = changefield.masterFieldId;
                  changeproditem["categoryRectId"] = containElem?.catrect?.catrectId;
                  
                  existingProducts[changeproditem.prodidx] = changeproditem;
                  existingProducts[changeproditem.prodidx]["isDelete"] = false;
                  
                  if(maxY<changeproditem.y){
                    maxY=changeproditem.y
                    maxEndY=changeproditem.y+changeproditem.drawHeight;
                  }
  
                  let curprodendx = (changeproditem.x + changeproditem.drawWidth);
                  if(curprodendx > maxEndX){
                    maxEndX = curprodendx
                  }
                } 
               
              }
              
            }
            
            var newMOEndY = roundOffDecimal(maxEndY - this.props.checkSaftyMargin,2);

            var ccontainProds = GetContainingProdsByBox(lowestprodx, MOStartY, maxEndX, newMOEndY, this.props.mapproductList, changefield, true, movingObj, containshelfs);
         
            if(dropallow){
              let isruleupdating = false;
              //removingcutting prod
              if(ccontainProds.selectedProds&&ccontainProds.selectedProds.length>0){
                var cnotDeletedContainProds = ccontainProds.selectedProds.filter(f => !f.isDelete);
                
                for (let p = 0; p < cnotDeletedContainProds.length; p++) {
                  const prod = cnotDeletedContainProds[p];
                  // console.log(prod.x);
                  prod["startingPointDraw"]=prod.x
                  prod["startingPoint"]=prod.x/this.props.displayratio
                  prod.isNew= true
                  prod.isDelete= false
                  let isincontainshelfs = containshelfs.findIndex(l => l.rank === prod.shelfrank);

                  if(isincontainshelfs > -1){
                    const actualFieldStructures = this.props.actualFieldStructures
                    const result = actualFieldStructures.find(item => 
                      item?.mpField?.field_shelves.some(shelf => shelf?.shelf_id === containshelfs[isincontainshelfs]?.id)
                    );

                    const shelf = result?.mpField?.field_shelves.find(shelf => shelf?.shelf_id === containshelfs[isincontainshelfs]?.id);

                    const getDrawWidth = (measureConverter(shelf?.uom ,"cm",shelf?.width)*this.props.displayratio);
                    
                    //draw blockobj for containProds after that move shelf left side   
                    var ishaveinSelectedshleves = movingObj.newDrawingProducts.find(x => x.id === prod.id);
                    //check save moving produtcs not cutting
                    if(ishaveinSelectedshleves === undefined){
                      let findshelfitemidx = cutshelfs.findIndex(x => x.shelfrank === prod.shelfrank);
  
                      if(findshelfitemidx > -1){
                        cutshelfs[findshelfitemidx].products.push(prod);
                      } else{
                        cutshelfs.push({ shelfrank: prod.shelfrank, products: [prod] });
                      }
                      
                    }
                    
                  }
                }
              }
            
              // New CR Updating 
              const {selectedInlineShelfSet} = this.state.spaceValidation
              let movingProductSet = structuredClone(this.state.selectBlockObj)?.drawingProducts;

              // Verify and correct product positions before re-arranging
              movingProductSet = this.verifyAndCorrectProductPositions(movingProductSet);


              // re arrange the group product locations
              let reArrangeProducts = JSON.parse(JSON.stringify(this.props.mapproductList));
              let movingProductObj = structuredClone(this.state.selectBlockObj);

              if((movingObj.selectedshelves || []).length <= 1){
                // SINGLE-ROW (existing behaviour): push existing products aside on the one target row.
                const {needToReArrange, updatedProducts} = this.filterInlineShelfProductSet(cx, cy, selectedInlineShelfSet, reArrangeProducts, movingProductSet, movingProductObj, checkSaftyMargin, droppedFiledCustomId, droppedFieldMasterFieldId);

                // Capture moving products at their correctly-placed drop positions before rearrangement
                // can overwrite them with stale x values from drawingProducts (filterInlineShelfProductSet
                // includes movingProducts in updatedProducts using the original drawingProducts x values).
                //#119
                //const movingIds = new Set(movingProductSet.map(p => p.id));
                //const movingAtNewPos = existingProducts.filter(p => movingIds.has(p.id) && !p.isHanged && !p.isDelete);

                if(needToReArrange){
                  const updatingProductIds = new Set(updatedProducts.map(product => product.id));

                  const filteredUpdatedProducts = existingProducts.filter(
                      product => !updatingProductIds.has(product.id)
                  );

                  existingProducts = [...filteredUpdatedProducts, ...updatedProducts];

                  // Restore correct drop positions for moving products — filterInlineShelfProductSet
                  // returns them with the old drawingProducts x values, so we overwrite them back.
                  //#119
                  // if (movingAtNewPos.length > 0) {
                  //   const movingPosMap = new Map(movingAtNewPos.map(p => [p.id, p]));
                  //   existingProducts = existingProducts.map(p => movingPosMap.has(p.id) ? movingPosMap.get(p.id) : p);
                  // }
                }
              } else {
                // MULTI-ROW: filterInlineShelfProductSet only models one horizontal row, so run it
                // once per selected row against that row's own target shelf level. The placement loop
                // above already moved each row's products (movingObj.selectedshelves[m].selectedProducts)
                // to their final x on containshelfs[m], so derive each row's occupied span from those
                // positions and push that row's existing products aside independently. reArrangeBase
                // carries earlier rows' results forward so two rows sharing a field don't clobber each other.
                let reArrangeBase = reArrangeProducts;
                let accumulatedUpdated = [];
                for (let m = 0; m < movingObj.selectedshelves.length; m++) {
                  const targetShelf = containshelfs[m];
                  const rowProducts = movingObj.selectedshelves[m].selectedProducts || [];
                  if(!targetShelf || rowProducts.length === 0) continue;

                  const rowInlineShelfSet = getSimilarLevelShelves(targetShelf, this.props.mapFields, actualFieldStructuresNew);
                  if(!rowInlineShelfSet || rowInlineShelfSet.length === 0) continue;

                  const rowMinX = Math.min(...rowProducts.map(p => p.x));
                  const rowMaxX = Math.max(...rowProducts.map(p => p.x + p.drawWidth));
                  const rowMovingObj = { drawWidth: (rowMaxX - rowMinX), x: rowMinX };
                  const rowCy = targetShelf.y + 1; // a point inside the target shelf

                  const {needToReArrange, updatedProducts} = this.filterInlineShelfProductSet(
                    rowMinX, rowCy, rowInlineShelfSet, reArrangeBase, rowProducts, rowMovingObj,
                    checkSaftyMargin, containshelfs[m].field_custom_id, changefield.masterFieldId
                  );

                  if(needToReArrange){
                    const ids = new Set(updatedProducts.map(p => p.id));
                    reArrangeBase = [...reArrangeBase.filter(p => !ids.has(p.id)), ...updatedProducts];
                    accumulatedUpdated = [...accumulatedUpdated.filter(p => !ids.has(p.id)), ...updatedProducts];
                  }
                }

                if(accumulatedUpdated.length > 0){
                  const updatingProductIds = new Set(accumulatedUpdated.map(p => p.id));
                  const filteredUpdatedProducts = existingProducts.filter(p => !updatingProductIds.has(p.id));
                  existingProducts = [...filteredUpdatedProducts, ...accumulatedUpdated];
                }
              }

              // // PEG CR - 2025 March
              // // check if any product cross the peg board
              // const {isPegBoardOverlap} = this.productOverlapCheckerWithPegBoard(this.props.pegList, existingProducts)
              // console.log("isPegBoardOverlap",isPegBoardOverlap)
              // if(isPegBoardOverlap){
              //   alertService.error(i18n.t('PEG_BOARD_OVERLAP'),4000);
              //   this.setState({selectBlockObj:null})
              //   this.props.setPreviewGuid(true,null,selectingField)
              //   return;
              // }

              // // PEG CR Enhancement - check if shelf products overlap with hanging products extending below pegboard
              // const {isHangedProductOverlap} = this.shelfProductOverlapWithHangedProducts(existingProducts, this.props.mapproductList);
              // if(isHangedProductOverlap){
              //   alertService.error(i18n.t('PEG_BOARD_OVERLAP'),4000);
              //   this.setState({selectBlockObj:null})
              //   this.props.setPreviewGuid(true,null,selectingField)
              //   return;
              // }

              // Validate: moving shelf products in their new positions cannot overlap hanged (pegboard) products
              if (movingProductSet && movingProductSet.length > 0 && this.props.mapproductList) {
                const hangedProducts = this.props.mapproductList.filter(
                  p => (p.isHanged === true || (p.pegBoardIndex !== undefined && p.pegBoardIndex !== null)) && !p.isDelete
                );
                if (hangedProducts.length > 0) {
                  //#119
                  const movingIds = new Set(movingProductSet.map(p => p.id));
                  const movingAtNewPos = existingProducts.filter(p => movingIds.has(p.id) && !p.isHanged && !p.isDelete);

                  const prodsToCheck = movingAtNewPos.length > 0 ? movingAtNewPos : movingProductSet.filter(p => !p.isHanged && !p.isDelete);
                  let hasHangedOverlap = false;
                  for (const shelfProd of prodsToCheck) {
                    const stackCount  = (shelfProd.isStackable && shelfProd.stackCount > 0) ? shelfProd.stackCount : 0;
                    const shelfLeft   = shelfProd.x;
                    const shelfRight  = shelfProd.x + shelfProd.drawWidth;
                    const shelfBottom = shelfProd.y + shelfProd.drawHeight;
                    const shelfTop    = stackCount > 0
                      ? shelfProd.y - (shelfProd.drawHeight * stackCount)
                      : shelfProd.y;
                    for (const hp of hangedProducts) {
                      const hpLeft = hp.x;
                      const hpRight = hp.x + hp.drawWidth;
                      // Compute effective Y bounds including price tag
                      const hpPriceTagHeightPx = (hp.hasPriceTag) ? (hp.priceTagHeight || 0) * this.props.displayratio : 0;
                      const hpPriceTagGapPx    = (hp.hasPriceTag) ? (hp.priceTagGap    || 0) * this.props.displayratio : 0;
                      const hpTop = (hp.hasPriceTag && hp.pegDrawY !== undefined)
                        ? hp.pegDrawY - hpPriceTagHeightPx / 2
                        : hp.y;
                      const hpBottom = hpTop + (hp.hasPriceTag
                        ? hpPriceTagHeightPx + hpPriceTagGapPx + hp.drawHeight
                        : hp.drawHeight);
                      const isOverlap = shelfLeft < hpRight  && shelfRight  > hpLeft &&
                                        shelfTop  < hpBottom && shelfBottom > hpTop;
                      if (isOverlap) {
                        hasHangedOverlap = true;
                        break;
                      }
                    }
                    if (hasHangedOverlap) break;
                  }
                  if (hasHangedOverlap) {
                    alertService.error(i18n.t('HANGABLE_PRODUCT_OVERLAP'), 4000);
                    this.setState({selectBlockObj: null});
                    this.props.setPreviewGuid(true, null, selectingField);
                    this.props.resetSelectBlockObjData && this.props.resetSelectBlockObjData();
                    return;
                  }
                }
              }

              // Assume isHanged = true product coming from the peg board to shelf
              // When product coming from peg board to shelf, need to check movingProductSet have the same product
              // If yes, then set isHanged = false in existingProducts 
              const updatedProductsWithHanged = existingProducts.map(product => {
                const isHangedProduct = movingProductSet.find(movingProduct => (movingProduct.id === product.id && movingProduct.isHanged));
                if (isHangedProduct) {
                  return {
                    ...product,
                    isHanged: false,
                    id: uuidv4(),
                    isNew: true,
                    isDelete: false
                  };
                }
                return product;
              });

              const avalaibilyShelfSpace = this.shelfSpaceAvalaibiltyChecker(this.props.mapFields, this.props.pegList);
              const errors = this.productPositionChecker(this.props.mapproductList, updatedProductsWithHanged, avalaibilyShelfSpace, this.props.pegList);

              if (errors.hasIssues) {
                const first = errors.invalidProducts[0];
                const primary = i18n.t(first.i18nKey);
                const message = errors.invalidProducts.length > 1
                  ? `${primary} (${i18n.t('PRODUCTS_HAVE_POSITION_ISSUES', { count: errors.invalidProducts.length })})`
                  : primary;
                alertService.error(message, 4000);
                this.setState({selectBlockObj:null})
                this.props.setPreviewGuid(true,null,selectingField);
                this.props.resetSelectBlockObjData && this.props.resetSelectBlockObjData();
                return;
              }

              // History data push
              if(historydata!==null){
                this.props.fieldHistoryAdd(historydata,1);
              }
              this.props.updateProductList(updatedProductsWithHanged, isruleupdating);
              // this.props.updateProductList(updatedProducts, isruleupdating);

              // this.props.updateCutList(selcutlist);
              this.setState({selectBlockObj:null})

              this.props.groupByProduct();
            }else{
              alertService.error(i18n.t("SOME_PRoD_HEIGHT_EXCEED_SELECTED_SHELF_HEIGHT"),4000);
              this.resetToOriginalState()
              clearTimeout(this._guideTimeout); 
            }
            
  
          }else{
            this.resetToOriginalState()
          }
        }else{
          this.resetToOriginalState()
        }
        
        this.props.setPreviewGuid(true,null,selectingField)
      }
    }

    // filter product set which is in selected inline shelf
    filterInlineShelfProductSet(cx, cy, inlineShelfSet, productSet, movingProductSet , movingObj, checkSaftyMargin, droppedFiledCustomId, droppedFieldMasterFieldId){

      let  sortedInlineShelfSet = inlineShelfSet.sort((a, b) => a.x - b.x);
      let  movingProducts = movingProductSet;
      let  changingShelfRank = sortedInlineShelfSet[0]?.rank;
      let  changingShelfHeight = sortedInlineShelfSet[0]?.y + sortedInlineShelfSet[0]?.drawHeight;

      // Create a Set of product IDs from movingProductSet for quick lookup
      const movingProductIds = new Set(movingProductSet.map(product => product.id));

      // Filter productSet based on the conditions
      let existingProductSet =  productSet.filter(product => {
            const matchingShelf = sortedInlineShelfSet.find(
                shelf => shelf.rank === product.shelfrank && shelf.field_custom_id === product.field_custom_id
            );
            // Include only products that match the shelf and are not in movingProductSet
            return matchingShelf && !movingProductIds.has(product.id) && !product.isDelete && !product.isHanged;
      });

      var MOStartX = roundOffDecimal(cx,2);
      var MOEndX = roundOffDecimal((cx + movingObj.drawWidth),2);

      // shelf x position add shelfs full width
      let firstShelfXPosition = sortedInlineShelfSet[0]?.x;
      let shelfFullWidth = 0;
      for (let shelfs of sortedInlineShelfSet) {
        shelfFullWidth += shelfs.drawWidth;
      }
      // add full width to first shelf x coordinat
      let shelfFullWidthShelfX = roundOffDecimal((shelfFullWidth + firstShelfXPosition),2);

      // Check if any product crosses MOStartX to MOEndX
      let needToReArrange = existingProductSet
      .filter(product => !product.isDelete)
      .filter(product => !product.isHanged) // Exclude hanged products
      .some(product => {
        const productStart = product.x;
        const productEnd = product.x + product.drawWidth;
        // Check if the product overlaps with the MOStartX to MOEndX area
        // return productStart-checkSaftyMargin < MOEndX && productEnd+checkSaftyMargin > MOStartX;
        return (productStart < MOEndX && productEnd > MOStartX) || (MOEndX > shelfFullWidthShelfX+checkSaftyMargin);
      });

      // handle if existing product not avaliable and user try to put product outside of the field
      if(existingProductSet.length === 0){
        if(MOEndX > shelfFullWidthShelfX+checkSaftyMargin){
          needToReArrange = true;
        }
      }

      if(needToReArrange){
          // ---------------------------------------------------------------------
          // ---------------------------------------------------------------------
          // AUTO ALIGN WITH MINUMUM PRODUCT MOVEMENT ----------------------------
          // New Version - 2025 Jan 29 -------------------------------------------
          // ---------------------------------------------------------------------

          // Group products by groupId
          const groupedProducts = existingProductSet
              .filter(product => !movingProductIds.has(product.id)) // Remove movingObj products
              .filter(product => !product.isDelete) // Remove products with isDelete = true
              .reduce((acc, product) => {
                  if (!acc[product.groupId]) {
                      acc[product.groupId] = [];
                  }
                  acc[product.groupId].push(product);
                  return acc;
              }, {});

          // Separate products into left and right side sets based on group logic
          let leftSideProductSet = [];
          let rightSideProductSet = [];

          Object.values(groupedProducts).forEach(group => {
              // Check the position of the first product in the group
              if (group.some(product => product.x < MOStartX)) {
                  // If any product in the group goes to the left side, all go to the left side
                  leftSideProductSet.push(...group);
              // } else if (group.some(product => product.x >= MOEndX)) {
              } else if (group.some(product => product.x >= MOStartX)) {
                  // If any product in the group goes to the right side, all go to the right side
                  rightSideProductSet.push(...group);
              }
          });

          let sortedLeftSideProductSet = leftSideProductSet.sort((a, b) => a.x - b.x);
          let sortedRightSideProductSet = rightSideProductSet.sort((a, b) => a.x - b.x);

          // console.log("START sortedLeftSideProductSet - ", sortedLeftSideProductSet)
          // console.log("START movingObj - ", movingObj)
          // console.log("START movingProducts - ", movingProducts)
          // console.log("START sortedRightSideProductSet - ", sortedRightSideProductSet)
          
          let newChangedSpaceAmount = 0;
          let currentX = 0;
          let howMuchSpaceWant = movingObj.drawWidth;
          let getSpacingDirection = 'BOTH';

          // console.log("SPACE 0 -", newChangedSpaceAmount)
          // console.log("WANT 0 -", howMuchSpaceWant)
          // console.log("X 0 -", currentX)

          let shelfStartX = sortedInlineShelfSet[0]?.x;
          let shelfEndX = sortedInlineShelfSet[sortedInlineShelfSet.length - 1]?.x + sortedInlineShelfSet[sortedInlineShelfSet.length - 1]?.drawWidth;
          let shelfTotalWidth = sortedInlineShelfSet.reduce((sum, obj) => sum + obj.drawWidth, 0);

          // this function return the direction and both side avaliable space
          let spacingAmount = this.getDirectionToOptimizedTheGetProductSpacing(cx, movingObj.drawWidth, shelfStartX, shelfTotalWidth, sortedLeftSideProductSet, sortedRightSideProductSet);
          // console.log("SPACING -", spacingAmount)

          if(spacingAmount?.direction === "LEFT"){
            let leftSideLastProductX = sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].x + sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].drawWidth;
            // validation for not over the shelf width
            if(leftSideLastProductX + movingObj.drawWidth <  shelfStartX + shelfTotalWidth ){
              let diff = leftSideLastProductX - cx;
              if(spacingAmount?.leftSpace > diff){
                getSpacingDirection = 'LEFT';
                howMuchSpaceWant =  diff;
              }
              // comment out for prevent inverse side spacing optimazation
              // else if(spacingAmount?.rightSpace > diff){
              //   getSpacingDirection = 'RIGHT';
              //   howMuchSpaceWant =  diff;
              // } 
            }
          }
          if(spacingAmount?.direction === "RIGHT"){
            let movingProductEndX = cx + movingObj.drawWidth;
            let righSideFirstProductX = sortedRightSideProductSet[0].x;
            let diff = movingProductEndX - righSideFirstProductX;

            if(spacingAmount?.rightSpace > diff){
              getSpacingDirection = 'RIGHT';
              howMuchSpaceWant =  diff;
            }
            // comment out for prevent inverse side spacing optimazation
            // else if(spacingAmount?.leftSpace > diff){
            //   getSpacingDirection = 'LEFT';
            //   howMuchSpaceWant =  diff;
            // }
          }

          // console.log("DIRECTION 1 -", getSpacingDirection)
          // console.log("WANT 000000000000 -", howMuchSpaceWant)

          // Handle Both side spacing 
          if(getSpacingDirection === "BOTH"){
              // console.log("SPACE 1 -", newChangedSpaceAmount)
              // console.log("WANT 1 -", howMuchSpaceWant)
              // console.log("X 1 -", currentX)
              let needToAdjustLeftProducts = [];
              if (roundOffDecimal(newChangedSpaceAmount,2) < roundOffDecimal(howMuchSpaceWant,2) && sortedLeftSideProductSet?.length > 0) {
                  for (let i = sortedLeftSideProductSet.length - 1; i >= 0; i--) {
                    let adjustableSpace = 0;
                    const currentProduct = sortedLeftSideProductSet[i];
                    const previousProduct = sortedLeftSideProductSet[i - 1] || null;

                    if(previousProduct){
                      if(i === sortedLeftSideProductSet.length - 1 && sortedRightSideProductSet.length > 0){
                        let righSideProdX = sortedRightSideProductSet[0].x;
                        let avalibleSpace = (righSideProdX - movingObj.drawWidth) - currentProduct.x;
                        let rightSideAllProductsWidth = 0;
                        let leftSideLastProdXandWidth = sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].x + sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].drawWidth;
                        if(sortedRightSideProductSet.length > 0){
                          rightSideAllProductsWidth = sortedRightSideProductSet.reduce((sum, obj) => sum + obj.drawWidth, 0);
                        }
                        if(avalibleSpace + movingObj.drawWidth > howMuchSpaceWant && leftSideLastProdXandWidth + movingObj.drawWidth + rightSideAllProductsWidth <= shelfEndX){
                          break;
                        }else{
                          adjustableSpace = currentProduct.x - (previousProduct.x + previousProduct.drawWidth);
                        }
                      }else{
                        adjustableSpace = currentProduct.x - (previousProduct.x + previousProduct.drawWidth);
                      }
                        // let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                        // handle the space optimization before the assign shelf start x
                        // if(adjustableSpace > howMuchSpaceWant && cx + movingObj.drawWidth < shelfXWithWidth){
                        // handle long space avalible in the left side last product with the moving product
                        // let righSideStartX = sortedRightSideProductSet[0].x;
                        
                        if(newChangedSpaceAmount + adjustableSpace > howMuchSpaceWant){
                          adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount;
                        }
                    }else{
                        // align to shelf x coordnate
                        let shelfX = this.getShelfXPosition(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                        // let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                        if(shelfX <= currentProduct.x){
                          adjustableSpace = currentProduct.x - shelfX;
                          // adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount; 
                          // handle the space optimization before the assign shelf start x
                          // if(adjustableSpace > howMuchSpaceWant && roundOffDecimal(cx + movingObj.drawWidth,2) < roundOffDecimal(shelfXWithWidth,2)){
                          if(adjustableSpace > howMuchSpaceWant){
                            adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount; 
                          }
                        }
                    }

                    // push to updating array
                    needToAdjustLeftProducts.push({product: currentProduct, reduceSpace: adjustableSpace });
                    newChangedSpaceAmount += adjustableSpace;

                    if(newChangedSpaceAmount >= howMuchSpaceWant) break;
                  }

                  // console.log("LEFT ADJUST PRDO - ",needToAdjustLeftProducts)
                  // update the new x values
                  for (let i = 0; i < needToAdjustLeftProducts.length; i++) {
                    const product = needToAdjustLeftProducts[i].product;
            
                    // need to assign total x value to get correct coordinate
                    const sumValue = needToAdjustLeftProducts
                      .slice(i) // Take the current and subsequent objects
                      .reduce((sum, item) => sum + item.reduceSpace, 0);

                    product.x = product.x - sumValue;
                    product.startingPoint = product.x / this.props.displayratio;
                  }

                  // update update product set to sortedLeftSideProductSet
                  const productObjects = needToAdjustLeftProducts.map(item => item.product);
                  // console.log("LEFT productObjects - ", productObjects)
                  const updatingProductIds = new Set(productObjects.map(product => product.id));
                  const filteredUpdatedProducts = sortedLeftSideProductSet.filter(
                      product => !updatingProductIds.has(product.id)
                  );
                  sortedLeftSideProductSet = [...filteredUpdatedProducts, ...productObjects];
                  sortedLeftSideProductSet = sortedLeftSideProductSet.sort((a, b) => a.x - b.x);
              } 

              // console.log("SPACE 2 -", newChangedSpaceAmount)
              // console.log("WANT 2 -", howMuchSpaceWant)
              // console.log("X 2 -", currentX)

              // sort the moving product list by x coordinate
              movingProducts.sort((a, b) => a.x - b.x);

              if(leftSideProductSet.length === 0){
                currentX = this.getShelfXPosition(sortedInlineShelfSet, changingShelfRank, droppedFiledCustomId);
                if(currentX < cx && sortedRightSideProductSet.length > 0){
                  let righSideProdX = sortedRightSideProductSet[0].x;
                  let avalibleSpace = (righSideProdX - movingObj.drawWidth) - currentX;
                  if(avalibleSpace + movingObj.drawWidth > howMuchSpaceWant){
                    currentX = righSideProdX - movingObj.drawWidth;
                  }
                }
              }else{
                // Adjust movingProductSet product set
                let leftSideLastProdXandWidth = sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].x + sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].drawWidth;
                currentX = leftSideLastProdXandWidth;
                if(currentX < cx && sortedRightSideProductSet.length > 0 && needToAdjustLeftProducts.length === 0){
                  let righSideProdX = sortedRightSideProductSet[0].x;
                  let avalibleSpace = (righSideProdX - movingObj.drawWidth) - leftSideLastProdXandWidth;
                  if(avalibleSpace + movingObj.drawWidth > howMuchSpaceWant){
                    currentX = righSideProdX - movingObj.drawWidth;
                  }
                }
              }

              // console.log("SPACE 3 -", newChangedSpaceAmount)
              // console.log("WANT 3 -", howMuchSpaceWant)
              // console.log("X 3 -", currentX)

              // Update the moving product x coordinate
              for (let i = 0; i < movingProducts.length; i++){
                const prod = movingProducts[i];
                prod.x = currentX;
                prod.shelfrank = changingShelfRank;
                prod.field_custom_id = droppedFiledCustomId;
                prod.masterFieldId = droppedFieldMasterFieldId;
                prod.y = changingShelfHeight - prod.drawHeight;
                prod.startingPoint = prod.x / this.props.displayratio;
                // prod.isHanged = false;
                currentX = prod.x + prod.drawWidth; 
                newChangedSpaceAmount = newChangedSpaceAmount + prod.drawWidth;
              }

              // console.log("SPACE 4 -", newChangedSpaceAmount)
              // console.log("WANT 4 -", howMuchSpaceWant)
              // console.log("X 4 -", currentX)

              let needToAdjustRightProducts = [];
              // check the RIGHT side spacing if avaiable
              if (roundOffDecimal(newChangedSpaceAmount,2) < roundOffDecimal(howMuchSpaceWant,2) && sortedRightSideProductSet?.length > 0) {

                for (let i = 0; i < sortedRightSideProductSet.length; i++) {
                  const currentProduct = sortedRightSideProductSet[i];
                  const nextProduct = sortedRightSideProductSet[i + 1] || null;
                  let adjustableSpace = 0;

                  if(nextProduct){
                    adjustableSpace = nextProduct.x - (currentProduct.x + currentProduct.drawWidth);
                  }else{
                    // align to shelf x end coordnate
                    let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, sortedRightSideProductSet[0]?.shelfrank, sortedRightSideProductSet[0]?.field_custom_id);
                    if(shelfXWithWidth > currentProduct.x + currentProduct.drawWidth){
                      adjustableSpace = shelfXWithWidth - (currentProduct.x + currentProduct.drawWidth);
                    }
                  }

                  // push to updating array
                  needToAdjustRightProducts.push({product: currentProduct, plusSpace: adjustableSpace });
                  newChangedSpaceAmount += adjustableSpace;

                  if(newChangedSpaceAmount >= howMuchSpaceWant) break;
                }

                // console.log("RIGTH ADJUST PRDO - ",needToAdjustRightProducts)

                for (let i = 0; i < needToAdjustRightProducts.length; i++) {
                  const product = needToAdjustRightProducts[i].product;
                  const plusSpace = needToAdjustRightProducts[i].plusSpace;

                  // Update product.x and startingPoint
                  product.x = currentX + plusSpace;
                  product.startingPoint = product.x / this.props.displayratio;
                  currentX =  product.x + product.drawWidth;
                }

                // update update product set to sortedRightSideProductSet
                const productObjects = needToAdjustRightProducts.map(item => item.product);

                const updatingProductIds = new Set(productObjects.map(product => product.id));
                const filteredUpdatedProducts = sortedRightSideProductSet.filter(
                    product => !updatingProductIds.has(product.id)
                );
                sortedRightSideProductSet = [...filteredUpdatedProducts, ...productObjects];
                sortedRightSideProductSet = sortedRightSideProductSet.sort((a, b) => a.x - b.x);

                // console.log("SPACE 5 -", newChangedSpaceAmount)
                // console.log("WANT 5 -", howMuchSpaceWant)
                // console.log("X 5 -", currentX)
            }else{
              // console.log("SPACE 6 -", newChangedSpaceAmount)
              // console.log("WANT 6 -", howMuchSpaceWant)
              // console.log("X 6 -", currentX)
              // this condition only apply, moving product last product overlap the right side products
              if( sortedRightSideProductSet?.length > 0){
                sortedRightSideProductSet = sortedRightSideProductSet.sort((a, b) => a.x - b.x);
                if(currentX > sortedRightSideProductSet[0].x){
                  let startingX = currentX;
                  for (let i = 0; i < sortedRightSideProductSet.length; i++) {
                      const prod = sortedRightSideProductSet[i]; 
                      const nextProd = sortedRightSideProductSet[i+1] || null; 
                      prod.x = currentX;
                      prod.startingPoint = prod.x / this.props.displayratio;
                      currentX = prod.x + prod.drawWidth;
                      if(currentX > startingX && nextProd){
                        if(nextProd.x > currentX){
                          // this one prevent all right side products updating
                          break;
                        }
                      }
                  } 
                }
              }
            }
          }

          // Handle Left side spacing
          if(getSpacingDirection === "LEFT"){
            // console.log("SPACE 1 -", newChangedSpaceAmount)
            // console.log("WANT 1 -", howMuchSpaceWant)
            // console.log("X 1 -", currentX)

            if (roundOffDecimal(newChangedSpaceAmount,2) < roundOffDecimal(howMuchSpaceWant,2) && sortedLeftSideProductSet?.length > 0) {
                let needToAdjustProducts = [];
            
                for (let i = sortedLeftSideProductSet.length - 1; i >= 0; i--) {
                  let adjustableSpace = 0;
                  const currentProduct = sortedLeftSideProductSet[i];
                  const previousProduct = sortedLeftSideProductSet[i - 1] || null;

                  if(previousProduct){
                      adjustableSpace = currentProduct.x - (previousProduct.x + previousProduct.drawWidth);
                      // let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                      // handle the space optimization before the assign shelf start x
                      // if(adjustableSpace > howMuchSpaceWant && cx + movingObj.drawWidth < shelfXWithWidth){
                      if(adjustableSpace > howMuchSpaceWant){
                        adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount;
                      }
                  }else{
                      // align to shelf x coordnate
                      let shelfX = this.getShelfXPosition(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                      // let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                      if(shelfX < currentProduct.x){
                        // adjustableSpace = currentProduct.x - shelfX;
                        adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount; 
                        // handle the space optimization before the assign shelf start x
                        // if(adjustableSpace > howMuchSpaceWant && roundOffDecimal(cx + movingObj.drawWidth,2) < roundOffDecimal(shelfXWithWidth,2)){
                        //   adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount; 
                        // }
                      }
                  }

                  // push to updating array
                  needToAdjustProducts.push({product: currentProduct, reduceSpace: adjustableSpace });
                  newChangedSpaceAmount += adjustableSpace;

                  if(newChangedSpaceAmount >= howMuchSpaceWant) break;
                }

                // console.log("LEFT ADJUST PRDO - ",needToAdjustProducts)
                // update the new x values
                for (let i = 0; i < needToAdjustProducts.length; i++) {
                  const product = needToAdjustProducts[i].product;
          
                  // need to assign total x value to get correct coordinate
                  const sumValue = needToAdjustProducts
                    .slice(i) // Take the current and subsequent objects
                    .reduce((sum, item) => sum + item.reduceSpace, 0);

                  product.x = product.x - sumValue;
                  product.startingPoint = product.x / this.props.displayratio;
                }

                // update update product set to sortedLeftSideProductSet
                const productObjects = needToAdjustProducts.map(item => item.product);
                // console.log("LEFT productObjects - ", productObjects)
                const updatingProductIds = new Set(productObjects.map(product => product.id));
                const filteredUpdatedProducts = sortedLeftSideProductSet.filter(
                    product => !updatingProductIds.has(product.id)
                );
                sortedLeftSideProductSet = [...filteredUpdatedProducts, ...productObjects];
                sortedLeftSideProductSet = sortedLeftSideProductSet.sort((a, b) => a.x - b.x);
            } 

            // console.log("SPACE 2 -", newChangedSpaceAmount)
            // console.log("WANT 2 -", howMuchSpaceWant)
            // console.log("X 2 -", currentX)

            // sort the moving product list by x coordinate
            movingProducts.sort((a, b) => a.x - b.x);

            if(leftSideProductSet.length === 0 && movingProducts.length > 0){
              currentX = this.getShelfXPosition(sortedInlineShelfSet, changingShelfRank, droppedFiledCustomId);
            }else{
              // Adjust movingProductSet product set
              currentX = sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].x + sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].drawWidth;
            }

            // console.log("SPACE 3 -", newChangedSpaceAmount)
            // console.log("WANT 3 -", howMuchSpaceWant)
            // console.log("X 3 -", currentX)

            // Update the moving product x coordinate
            for (let i = 0; i < movingProducts.length; i++){
              const prod = movingProducts[i];
              prod.x = currentX;
              prod.shelfrank = changingShelfRank;
              prod.field_custom_id = droppedFiledCustomId;
              prod.masterFieldId = droppedFieldMasterFieldId;
              prod.y = changingShelfHeight - prod.drawHeight;
              prod.startingPoint = prod.x / this.props.displayratio;
              // prod.isHanged = false;
              currentX = prod.x + prod.drawWidth; 
              newChangedSpaceAmount = newChangedSpaceAmount + prod.drawWidth;
            }

            // console.log("SPACE 4 -", newChangedSpaceAmount)
            // console.log("WANT 4 -", howMuchSpaceWant)
            // console.log("X 4 -", currentX)
          }

          // Handle Right side spacing 
          if(getSpacingDirection === "RIGHT"){
            if(sortedLeftSideProductSet.length === 0 && movingProducts.length > 0){
              currentX = cx;
            }else{
              let leftSideLastProduct = sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].x + sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].drawWidth;
              if(cx > leftSideLastProduct){
                currentX = cx;
              }else{
                currentX = leftSideLastProduct;
              }
            }

            // sort the moving product list by x coordinate
            movingProducts.sort((a, b) => a.x - b.x);


            // console.log("RIGHT SPACE 3 -", newChangedSpaceAmount)
            // console.log("RIGHT WANT 3 -", howMuchSpaceWant)
            // console.log("RIGHT X 3 -", currentX)

            // Update the moving product x coordinate
            for (let i = 0; i < movingProducts.length; i++){
              const prod = movingProducts[i];
              prod.x = currentX;
              prod.shelfrank = changingShelfRank;
              prod.field_custom_id = droppedFiledCustomId;
              prod.masterFieldId = droppedFieldMasterFieldId;
              prod.y = changingShelfHeight - prod.drawHeight;
              prod.startingPoint = prod.x / this.props.displayratio;
              // prod.isHanged = false;
              currentX = prod.x + prod.drawWidth; 
            }

            // console.log("RIGHT SPACE 4 -", newChangedSpaceAmount)
            // console.log("RIGHT WANT 4 -", howMuchSpaceWant)
            // console.log("RIGHT X 4 -", currentX)

            // check the RIGHT side spacing if avaiable
            if (roundOffDecimal(newChangedSpaceAmount,2) < roundOffDecimal(howMuchSpaceWant,2) && sortedRightSideProductSet?.length > 0) {
                let needToAdjustProducts = [];

                for (let i = 0; i < sortedRightSideProductSet.length; i++) {
                  const currentProduct = sortedRightSideProductSet[i];
                  const nextProduct = sortedRightSideProductSet[i + 1] || null;
                  let adjustableSpace = 0;

                  if(nextProduct){
                    adjustableSpace = nextProduct.x - (currentProduct.x + currentProduct.drawWidth);
                  }else{
                    // align to shelf x end coordnate
                    let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, sortedRightSideProductSet[0]?.shelfrank, sortedRightSideProductSet[0]?.field_custom_id);
                    if(shelfXWithWidth > currentProduct.x + currentProduct.drawWidth){
                      adjustableSpace = shelfXWithWidth - (currentProduct.x + currentProduct.drawWidth);
                    }
                  }

                  // push to updating array
                  needToAdjustProducts.push({product: currentProduct, plusSpace: adjustableSpace });
                  newChangedSpaceAmount += adjustableSpace;

                  if(newChangedSpaceAmount >= howMuchSpaceWant) break;
                }

                // console.log("RIGTH ADJUST PRDO - ",needToAdjustProducts)

                for (let i = 0; i < needToAdjustProducts.length; i++) {
                  const product = needToAdjustProducts[i].product;
                  const plusSpace = needToAdjustProducts[i].plusSpace;

                  // Update product.x and startingPoint
                  product.x = currentX;
                  product.startingPoint = product.x / this.props.displayratio;
                  currentX = product.x  +  product.drawWidth;
                }

                // update update product set to sortedRightSideProductSet
                const productObjects = needToAdjustProducts.map(item => item.product);

                const updatingProductIds = new Set(productObjects.map(product => product.id));
                const filteredUpdatedProducts = sortedRightSideProductSet.filter(
                    product => !updatingProductIds.has(product.id)
                );
                sortedRightSideProductSet = [...filteredUpdatedProducts, ...productObjects];
                sortedRightSideProductSet = sortedRightSideProductSet.sort((a, b) => a.x - b.x);

                // console.log("RIGHT SPACE 5 -", newChangedSpaceAmount)
                // console.log("RIGHT WANT 5 -", howMuchSpaceWant)
                // console.log("RIGHT X 5 -", currentX)
            }

          }


        // console.log("FINAL - sortedLeftSideProductSet - ",sortedLeftSideProductSet)
        // console.log("FINAL - sortedRightSideProductSet - ",sortedRightSideProductSet)
        let updatedArray = sortedLeftSideProductSet.concat(sortedRightSideProductSet);
        updatedArray = updatedArray.concat(movingProducts);
        // console.log("FINAL - updatedArray - ", updatedArray)
        return {needToReArrange, updatedProducts:updatedArray};


        // ---------------------------------------------------------------------
        // ---------------------------------------------------------------------
        // AUTO LEFT ALIGN ALL PRODUCTS ----------------------------------------
        // OLD Version ---------------------------------------------------------
        // ---------------------------------------------------------------------
       
        // // Group products by groupId
        // const groupedProducts = existingProductSet
        // .filter(product => !movingProductIds.has(product.id)) // Remove movingObj products
        // .filter(product => !product.isDelete) // Remove products with isDelete = true
        // .reduce((acc, product) => {
        //     if (!acc[product.groupId]) {
        //         acc[product.groupId] = [];
        //     }
        //     acc[product.groupId].push(product);
        //     return acc;
        // }, {});

        // // Separate products into left and right side sets based on group logic
        // let leftSideProductSet = [];
        // let rightSideProductSet = [];

        // Object.values(groupedProducts).forEach(group => {
        //     // Check the position of the first product in the group
        //     if (group.some(product => product.x < MOStartX)) {
        //         // If any product in the group goes to the left side, all go to the left side
        //         leftSideProductSet.push(...group);
        //     // } else if (group.some(product => product.x >= MOEndX)) {
        //     } else if (group.some(product => product.x >= MOStartX)) {
        //         // If any product in the group goes to the right side, all go to the right side
        //         rightSideProductSet.push(...group);
        //     }
        // });

        // // Sort left side products by x
        // leftSideProductSet.sort((a, b) => a.x - b.x);

        // // Adjust left side products
        // let currentX = 0;

        // if(leftSideProductSet.length > 0){
        //   currentX = this.getShelfXPosition(sortedInlineShelfSet, leftSideProductSet[0]?.shelfrank, leftSideProductSet[0]?.field_custom_id)
        // }

        // for (let i = 0; i < leftSideProductSet.length; i++) {
        //     const prod = leftSideProductSet[i]; 
        //     prod.x = currentX; // Adjust x to start after MOEndX 
        //     currentX = prod.x + prod.drawWidth; // Update for next product
        //     prod.startingPoint = prod.x / this.props.displayratio; // Update startingPoint
        // }

        // // Set currentX to the last product's x + drawWidth in the left array
        // if (leftSideProductSet.length > 0) {
        //   currentX = leftSideProductSet[leftSideProductSet.length - 1].x + 
        //             leftSideProductSet[leftSideProductSet.length - 1].drawWidth;
        // } else {
        //   currentX = MOStartX; // Fallback to MOStartX if left array is empty
        // }

        // if(leftSideProductSet.length === 0 && movingProducts.length > 0){
        //   currentX = this.getShelfXPosition(sortedInlineShelfSet, changingShelfRank, droppedFiledCustomId)
        // }

        // // Sort right side products by x
        // movingProducts.sort((a, b) => a.x - b.x);
        // // Adjust movingProductSet product set
        // for (let i = 0; i < movingProducts.length; i++){
        //   const prod = movingProducts[i];
        //   prod.x = currentX;
        //   prod.shelfrank = changingShelfRank;
        //   prod.field_custom_id = droppedFiledCustomId;
        //   prod.masterFieldId = droppedFieldMasterFieldId;
        //   prod.y = changingShelfHeight - prod.drawHeight;
        //   prod.startingPoint = prod.x / this.props.displayratio;
        //   currentX = prod.x + prod.drawWidth; 
        // }

        // // Set currentX to the last product's x + drawWidth in movingProducts
        // if (movingProducts.length > 0) {
        //   currentX = movingProducts[movingProducts.length - 1].x + 
        //             movingProducts[movingProducts.length - 1].drawWidth;
        // } else {
        //   currentX = MOEndX; // Fallback to MOEndX if movingProducts is empty
        // }

        // // Sort right side products by x
        // rightSideProductSet.sort((a, b) => a.x - b.x);

        // for (let i = 0; i < rightSideProductSet.length; i++) {
        //     const prod = rightSideProductSet[i]; 
        //     prod.x = currentX; // Adjust x to start after MOEndX 
        //     currentX = prod.x + prod.drawWidth; // Update for next product
        //     prod.startingPoint = prod.x / this.props.displayratio; // Update startingPoint
        // }

        // let updatedArray = leftSideProductSet.concat(rightSideProductSet);
        // updatedArray = updatedArray.concat(movingProducts);
        // return {needToReArrange, updatedProducts:updatedArray};

        // ---------------------------------------------------------------------
        // ---------------------------------------------------------------------
        // AUTO LEFT ALIGN ALL PRODUCTS ----------------------------------------
        // ---------------------------------------------------------------------
        // ---------------------------------------------------------------------
      }
      return {needToReArrange};
    }

    getShelfXPosition(inlineShelfSet, prodShelfRank, prodFiledCustomId) {
      // Find the matching shelf in the inlineShelfSet
      // const matchingShelf = inlineShelfSet.find(shelf => 
      //     shelf.rank === prodShelfRank &&
      //     shelf.field_custom_id === prodFiledCustomId
      // );
      const matchingShelf = inlineShelfSet.find(shelf => 
          shelf.rank === prodShelfRank 
      );
      return matchingShelf ? matchingShelf.x : 0;
    }

    getShelfXPositionWithShelfWidth(inlineShelfSet, prodShelfRank, prodFiledCustomId) {
      const matchingShelf = inlineShelfSet.find(shelf => 
          shelf.rank === prodShelfRank &&
          shelf.field_custom_id === prodFiledCustomId
      );
      return matchingShelf ? (matchingShelf.x + matchingShelf.drawWidth) : 0;
    }

    // Verify and correct product x positions to ensure proper alignment
    // Each product's (x + drawWidth) should equal the next product's x value
    verifyAndCorrectProductPositions = (movingProductSet) => {
      if (!movingProductSet || movingProductSet.length === 0) {
        return movingProductSet;
      }

      // Sort products by their x position to ensure correct order
      let sortedProducts = [...movingProductSet].sort((a, b) => a.x - b.x);

      // Verify and correct each product's position
      for (let i = 0; i < sortedProducts.length - 1; i++) {
        const currentProduct = sortedProducts[i];
        const nextProduct = sortedProducts[i + 1];

        // Calculate where the next product should start
        const expectedNextX = roundOffDecimal(currentProduct.x + currentProduct.drawWidth, 2);
        const actualNextX = roundOffDecimal(nextProduct.x, 2);

        // If there's a mismatch, correct the next product's x position
        if (expectedNextX !== actualNextX) {
          nextProduct.x = expectedNextX;
          nextProduct.startingPoint = nextProduct.x / this.props.displayratio;
        }
      }

      return sortedProducts;
    }

    // find the direction to optimized the spacing
    getDirectionToOptimizedTheGetProductSpacing(cx, movingObjectWidth, shelfStartX, shelfTotalWidth, leftProducts, rightProducts){
      // console.log("CHECKING - cx", cx);
      // console.log("CHECKING - movingObjectWidth", movingObjectWidth);
      // console.log("CHECKING - shelfStartX", shelfStartX);
      // console.log("CHECKING - shelfTotalWidth", shelfTotalWidth);
      // console.log("CHECKING - leftProducts", leftProducts);
      // console.log("CHECKING - rightProducts", rightProducts);

      const movingEndX = cx + movingObjectWidth;
      let crossesLeft = false;
      let crossesRight = false;
  
      // Check if it crosses left products
      for (const product of leftProducts) {
          const productStartX = product.x;
          const productEndX = product.x + product.drawWidth;
          if (movingEndX > productStartX && cx < productEndX) {
              crossesLeft = true;
              break;
          }
      }
  
      // Check if it crosses right products
      for (const product of rightProducts) {
          const productStartX = product.x;
          const productEndX = product.x + product.drawWidth;
          if (movingEndX > productStartX && cx < productEndX) {
              crossesRight = true;
              break;
          }
      }
  
      let leftSpace = 0;
      let rightSpace = 0;
  
      let totalLeftProductWidth = 0;
      for (const product of leftProducts) {
        totalLeftProductWidth += product.drawWidth;
      }
      // console.log("LEFT PROD", totalLeftProductWidth)
      leftSpace = (cx - shelfStartX) - totalLeftProductWidth;
      if (leftSpace < 0) leftSpace = 0;
      // console.log("LEFT REST", leftSpace)
  
      let totalRightProductWidth = 0;
      for (const product of rightProducts) {
        totalRightProductWidth += product.drawWidth;
      }
      // console.log("RIGHT PROD", totalRightProductWidth)
      rightSpace =((shelfStartX + shelfTotalWidth) - (cx + movingObjectWidth)) - totalRightProductWidth;
      if (rightSpace < 0) rightSpace = 0;
      // console.log("RIGHT REST", rightSpace)
  
      let direction = "NONE";
      if (crossesLeft && crossesRight) {
          direction = "BOTH";
      } else if (crossesLeft) {
          direction = "LEFT";
      } else if (crossesRight) {
          direction = "RIGHT";
      }
  
      return { direction, leftSpace, rightSpace };
    }


    findShelfSpacesSVG(shelf, products) {
      const totalShelfWidth = shelf.drawWidth; // Total width of the shelf in SVG units
      const shelfStartX = shelf.x; // Starting X position of the shelf in SVG
      const shelfEndX = shelfStartX + totalShelfWidth; // Ending X position of the shelf
    
      // Filter and sort products by their x position
      const sortedProducts = products
        .filter(product => product.x + product.drawWidth > shelfStartX && product.x < shelfEndX) // Filter products within the shelf bounds
        .sort((a, b) => a.x - b.x); // Sort by starting position
    
      const unusedSpaces = [];
      let lastEnd = shelfStartX; // Initialize with the start of the shelf
    
      for (const product of sortedProducts) {
        const productStart = Math.max(product.x, shelfStartX); // Clamp product start to shelf start
        const productEnd = Math.min(product.x + product.drawWidth, shelfEndX); // Clamp product end to shelf end
    
        // Check if there's a gap before this product
        if (productStart > lastEnd) {
          unusedSpaces.push({ start: lastEnd, end: productStart });
        }
    
        // Update lastEnd to the maximum of its current value or the current product's end
        lastEnd = Math.max(lastEnd, productEnd);
      }
    
      // Check for a gap after the last product
      if (lastEnd < shelfEndX) {
        unusedSpaces.push({ start: lastEnd, end: shelfEndX });
      }
    
      return unusedSpaces;
    }
    
    
    

    //#PDU-SM12
    resetToOriginalState = () => {
      let resetobj = JSON.parse(JSON.stringify(this.state.bkpBlockObj));
      let blockobj = this.state.selectBlockObj;
      const me = d3.select(this["LM01"]);
      me.attr('x', resetobj?.x);
      me.attr('y', resetobj?.y);
  
      blockobj.x = resetobj?.x;
      blockobj.y = resetobj?.y;

      this.setState({ selectBlockObj: blockobj });
    }


    // PEG CR - 2025 March
    //handle the peg product drop from the field
    handleProductsDropInsidePegBoard = (evt,cx,cy, droppedPegBoard) =>{
      // Allow already-hanged products to be repositioned within the peg board even when isDropToPegBoard is false.
      // Only block shelf products from being newly placed on the peg board in that mode.
      const isMovingHangedProduct = this.state.selectBlockObj?.drawingProducts?.some(p => p.isHanged);
      if(!this.props.isDropToPegBoard && !isMovingHangedProduct){
        alertService.error(i18n.t("CANNOT_PLACE_ON_PEGBOARD_DROP_TO_SHELF_ENABLED"), 4000);
        this.setState({selectBlockObj:null});
        this.props.resetSelectBlockObjData();
        return;
      }
      let movingProductObj = structuredClone(this.state.selectBlockObj);
      let mapproductList = this.props.mapproductList; 
      let pegProductList = this.props.pegProductList;
      let pegBoard = droppedPegBoard;
      let deletedProductList = [];
      let newProductList = [];
      let errorMessagesList = [];

      // find the product hanging hole position
      let products = movingProductObj?.drawingProducts;
      // filter is hangged product list which is selected pegboard
      let filteredPegProductList = mapproductList;

      // filtered filteredPegProductList from is delete false products
      filteredPegProductList = filteredPegProductList.filter(prod => !prod.isDelete);

      // remove moving product set from filteredPegProductList
      filteredPegProductList = filteredPegProductList.filter(p => !products.some(prod => prod.id === p.id));

      // drop x & y
      let dropX = cx;
      let dropY = cy;


      products.forEach((prod,i)=>{
        // check if have not hangable product
        if(!prod?.isHangable){
          //  alertService.error(i18n.t("NOT_HANGABLE_PRODUCT"),4000);
          errorMessagesList.push({errorCode: "NOT_HANGABLE_PRODUCT"});
          return;
        }

        const productHoleXPos = (measureConverter(prod?.uom ,"cm",prod?.haggingHorizontal)*this.props.displayratio);
        const productHoleYPos = (measureConverter(prod?.uom ,"cm",prod?.haggingVertical)*this.props.displayratio);

        const convertGapH = pegBoard?.drawGapH;
        const convertGapV = pegBoard?.drawGapW;

        // For products with price tag, calculate hole position from center (price tag center on peg hole)
        // For products without price tag, use hanging hole position
        const productHoleX = dropX + productHoleXPos;
        const productHoleY = dropY + productHoleYPos;

        // check if some product overlap
        const {isOverlap, issueType} =  this.productOverlapChecker(pegBoard, [...filteredPegProductList, ...newProductList], prod, dropX, dropY, null, null, this.props.pegList);
        if(isOverlap){
          if(issueType === "HANGABLE_PRODUCT_OVERLAP"){
            errorMessagesList.push({errorCode: "HANGABLE_PRODUCT_OVERLAP"});
          }else if(issueType ==="PEG_BOARD_OVERLAP"){
            errorMessagesList.push({errorCode: "PEG_BOARD_OVERLAP"});
          }else if(issueType === "HANGABLE_PRODUCT_OUTSIDE_FIELD_BORDER"){
            errorMessagesList.push({errorCode: "HANGABLE_PRODUCT_OUTSIDE_FIELD_BORDER"});
          }else if(issueType === "PRODUCT_CROSSES_SHELF_BELOW_PEG"){
              errorMessagesList.push({errorCode: "PRODUCT_CROSSES_SHELF_BELOW_PEG"});
          }
          return;
        } 
  
        let nearestPeg = null;
        // find the nearest peg within acceptable range (1.5x gap for tolerance)
        const maxThresholdX = convertGapH * 1.5;
        const maxThresholdY = convertGapV * 1.5;
        nearestPeg = this.findNearestPeg(pegBoard?.pegCoordinations, productHoleX, productHoleY, maxThresholdX, maxThresholdY, prod);

        if(nearestPeg === null){
          this.setPreviewGuid(false, null, null, true);
          errorMessagesList.push({errorCode: "CANNOT_FIND_THE_FREE_PEG_HOLE"});
          return;
        }

        if(nearestPeg){
          const updatedProductX = nearestPeg.drawX - productHoleXPos;
          const updatedProductY = nearestPeg.drawY - productHoleYPos;
          // check if product is already available in the pegProductList
          const existingProduct = pegProductList.find(pegprod => pegprod.id === prod.id);

          let prodCopy = JSON.parse(JSON.stringify(prod));  
          let newProduct = structuredClone(prodCopy);  

          // update the product x and y position
          newProduct.x = updatedProductX;
          newProduct.y = updatedProductY;

          // check if some product overlap
          // Pass nearestPeg.drawX and nearestPeg.drawY as the peg center for price tag calculation
          const {isOverlap, issueType} =  this.productOverlapChecker(pegBoard, [...filteredPegProductList, ...newProductList], newProduct, updatedProductX, updatedProductY, nearestPeg.drawY, nearestPeg.drawX, this.props.pegList);
          if(isOverlap){
            if(issueType === "HANGABLE_PRODUCT_OVERLAP"){
              errorMessagesList.push({errorCode: "HANGABLE_PRODUCT_OVERLAP"});
            }else if(issueType ==="PEG_BOARD_OVERLAP"){
              errorMessagesList.push({errorCode: "PEG_BOARD_OVERLAP"});
            }else if(issueType === "HANGABLE_PRODUCT_OUTSIDE_FIELD_BORDER"){
              errorMessagesList.push({errorCode: "HANGABLE_PRODUCT_OUTSIDE_FIELD_BORDER"});
            }else if(issueType === "PRODUCT_CROSSES_SHELF_BELOW_PEG"){
              errorMessagesList.push({errorCode: "PRODUCT_CROSSES_SHELF_BELOW_PEG"});
            }
            return;
          }

          // Validate: block if the product's full area (incl. price tag) overlaps any shelf's
          // gap zone (the "purple line"): [shelf.y + drawHeight, shelf.y + drawHeight + drawGap].
          // Skip shelves that are covered by a pegboard — products legitimately hang past those.
          const productBoardLine = 1; //2px for product boarder
          const priceTagHeightPx = prod?.hasPriceTag ? (prod?.priceTagHeight * this.props.displayratio) : 0;
          const priceTagGapPx = prod?.hasPriceTag ? (prod?.priceTagGap * this.props.displayratio) : 0;
          const priceTagTotalHeight = prod?.hasPriceTag ? priceTagGapPx + priceTagHeightPx : 0;

          // When the product has a price tag, the peg hole sits at the price-tag center,
          // so the product itself displays centered on the peg X and below the price tag.
          // Use those display coords for collision bounds — otherwise the validation
          // checks the wrong rectangle (the hanging-hole offset instead of the visible body).
          const productDisplayX = prod?.hasPriceTag
            ? (nearestPeg.drawX - (prod.drawWidth / 2))
            : updatedProductX;
          const productDisplayY = prod?.hasPriceTag
            ? (nearestPeg.drawY + (priceTagHeightPx / 2) + priceTagGapPx)
            : updatedProductY;

          const productLeft = productDisplayX - productBoardLine;
          const productRight = productDisplayX + prod.drawWidth + productBoardLine;
          // Price tag sits ABOVE the product on a peg, so extend top upward by its area
          const productTop = productDisplayY - priceTagTotalHeight - productBoardLine;
          const productBottom = productDisplayY + prod.drawHeight + productBoardLine;

          // Validate: block hangable product placement if its bottom goes below
          // the field's bottom shelf drawGap area.
          if(this.props.mapFields){
              const pegFieldId = droppedPegBoard?.pegDrawingRect?.fieldIDs?.[0];
              const fieldobj = pegFieldId !== undefined
                  ? Object.values(this.props.mapFields).find(f => f.actualFieldId === pegFieldId)
                  : null;
              if(fieldobj && fieldobj.shelf && fieldobj.shelf.length > 0){
                  const bottomShelf = fieldobj.shelf.reduce((max, s) =>
                      (s.y + s.drawHeight + (s.drawGap || 0)) > (max.y + max.drawHeight + (max.drawGap || 0)) ? s : max
                  );
                  const fieldBottomLimit = bottomShelf.y + bottomShelf.drawHeight + (bottomShelf.drawGap || 0);
                  if(productBottom > fieldBottomLimit){
                      errorMessagesList.push({errorCode: "HANGABLE_PRODUCT_BELOW_FIELD_BOTTOM"});
                      return;
                  }
              }
          }

          let crossesShelf = false;
          if(this.props.mapFields){
            const { coveredShelves, availableShelves } = this.shelfSpaceAvalaibiltyChecker(this.props.mapFields, this.props.pegList) || {};

            const coveredShelfIds = new Set((coveredShelves || []).map(s => s.shelfId));
            const pegBoards = (this.props.pegList || []).filter(p => p && p.pegDrawingRect);
            const fieldValues = Object.values(this.props.mapFields);
        
            for(let fi = 0; fi < fieldValues.length && !crossesShelf; fi++){
                const field = fieldValues[fi];
                if(!field?.shelf) continue;
                for(let si = 0; si < field.shelf.length; si++){
                    const shelf = field.shelf[si];
                    if(!shelf?.drawGap) continue;
                    const purpleTop = shelf.y + shelf.drawHeight;
                    const purpleBottom = purpleTop + shelf.drawGap;
                    const purpleLeft = shelf.x;
                    const purpleRight = shelf.x + shelf.drawWidth;
                    // Skip only when the entire purple zone is enclosed by a pegboard rect.
                    // If a pegboard ends inside the purple bar, the protruding portion is
                    // still a real constraint and must be validated.
                    let purpleFullyCovered = false;
                    if(coveredShelfIds.has(shelf.id)){
                      purpleFullyCovered = pegBoards.some(peg => {
                          const rect = peg.pegDrawingRect;
                          const pegStartX = rect.drawX;
                          const pegEndX = rect.drawX + rect.drawRectWidth;
                          const pegStartY = rect.drawY;
                          const pegEndY = rect.drawY + rect.drawRectHeight;
                          // 0.5px tolerance: drawRectWidth and shelf.drawWidth are computed
                          // via different arithmetic paths and can differ by ~1e-13px due to
                          // floating-point rounding, causing a visually identical pegboard to
                          // fail the strict >= check and falsely trigger PRODUCT_CROSSES_SHELF_BELOW_PEG.
                          const eps = 0.5;
                          //FIX BUG ADDING purpleBottom INSTED OF purpleTop (&& pegStartY <= purpleTop + eps && pegEndY >= purpleBottom - eps;)
                          return pegStartX <= purpleLeft + eps && pegEndX >= purpleRight - eps && pegStartY <= purpleTop + eps && pegEndY >= purpleBottom - eps;
                      });
                      if(purpleFullyCovered) continue;
                    }
                    const horizontalOverlap = productLeft <= purpleRight && productRight >= purpleLeft;
                    const verticalOverlap = productTop <= purpleBottom && productBottom >= purpleTop;
                    if(horizontalOverlap && verticalOverlap){
                        crossesShelf = true;
                        break;
                    }
                }
            }
          }
          if(crossesShelf){
              errorMessagesList.push({errorCode: "PRODUCT_CROSSES_SHELF_BELOW_PEG"});
              this.props.setPreviewGuid(true,null,null);
              return;
          }

          if(existingProduct == null || existingProduct == undefined){
            newProduct.id = uuidv4();
            newProduct.pegProductId = uuidv4();
          }
          newProduct.startingPoint = updatedProductX / this.props.displayratio;
          // peg details
          newProduct.pegBoardId = pegBoard.id;
          newProduct.pegBoardIndex = pegBoard.pegBoardIndex,
          newProduct.pegBoardName = pegBoard.name;
          newProduct.isHanged = true;
          newProduct.pegRefCode = nearestPeg.refCode;
          newProduct.pegX = nearestPeg.x;
          newProduct.pegDrawX = nearestPeg.drawX;
          newProduct.pegY = nearestPeg.y;
          newProduct.pegDrawY = nearestPeg.drawY;
          newProduct.categoryId    = newProduct.categoryId    || newProduct.category?.id || '';
          newProduct.subCategoryId = newProduct.subCategoryId || newProduct.subcategory?.sub_category?.subCategoryId || newProduct.subcategory?.id || '';
          newProduct.brandId       = newProduct.brandId       || newProduct.brand?.brand?.brandId || newProduct.brand?.id || newProduct.productBrand?.brandId || '';
          newProduct.qty           = newProduct.qty           ?? newProduct.facing ?? 1;

          // update is delete to moved products
          prod.isDelete = true;

          deletedProductList.push(prod);
          newProductList.push(newProduct);
          // update drop x & y
          // dropX = nearestPeg.drawX + productHoleXPos + convertGapV/2; // OLD METHOD
          dropX = nearestPeg.drawX + prod.drawWidth;
          dropY = cy;
        }

      })

      // check if have some error messages 
      if(errorMessagesList.length > 0){
          // remove duplicate error codes
          errorMessagesList = errorMessagesList.filter((value, index, self) =>
              index === self.findIndex((t) => (
                  t.errorCode === value.errorCode
              ))
          );
          
          // show error messages
          let errorMessage = errorMessagesList.map((error) => {
              if(error.errorCode === "NOT_HANGABLE_PRODUCT"){
                  return i18n.t("NOT_HANGABLE_PRODUCT");
              }else if(error.errorCode === "HANGABLE_PRODUCT_OVERLAP"){
                  return i18n.t("HANGABLE_PRODUCT_OVERLAP");
              }else if(error.errorCode === "CANNOT_FIND_THE_FREE_PEG_HOLE"){
                  return i18n.t("CANNOT_FIND_THE_FREE_PEG_HOLE");
              }else if(error.errorCode === "PEG_BOARD_OVERLAP"){
                  return i18n.t("PEG_BOARD_OVERLAP");
              }else if(error.errorCode === "PRODUCT_CROSSES_SHELF_BELOW_PEG"){
                  return i18n.t("PRODUCT_CROSSES_SHELF_BELOW_PEG");
              }else if(error.errorCode === "HANGABLE_SHELF_PRODUCT_OVERLAP"){
                  return i18n.t("HANGABLE_SHELF_PRODUCT_OVERLAP");
              }else if(error.errorCode === "HANGABLE_PRODUCT_OUTSIDE_FIELD_BORDER"){
                  return i18n.t("HANGABLE_PRODUCT_OUTSIDE_FIELD_BORDER");
              }else if(error.errorCode === "HANGABLE_PRODUCT_BELOW_FIELD_BOTTOM"){
                  return i18n.t("HANGABLE_PRODUCT_BELOW_FIELD_BOTTOM");
              }

              
          });
          alertService.error(errorMessage,4000);
          this.setState({selectBlockObj:null});
          this.props.resetSelectBlockObjData();
          return;
      };

      // set product to mapproductList
      let existingProductsCopy = JSON.parse(JSON.stringify(mapproductList));
      let existingProducts = structuredClone(existingProductsCopy);
      let existingPegProductsCopy = JSON.parse(JSON.stringify(pegProductList));
      let existingPegProducts = structuredClone(existingPegProductsCopy);

      // remove product object from mapproductList
      const restProductList = existingProducts.filter(prod => !deletedProductList.some(deletedProd => deletedProd.id === prod.id));

      // remove peg product from essiting array
      const restPegProductList = existingPegProducts.filter(prod => !deletedProductList.some(deletedProd => deletedProd.id === prod.id));

      let historydata=JSON.parse(JSON.stringify(this.props.mapproductList))
      this.props.fieldHistoryAdd(historydata,1);
      this.props.handlePegProductAdd([...restPegProductList, ...newProductList]);
      this.props.updateProductList([...restProductList, ...deletedProductList, ...newProductList],false);
      this.props.setPreviewGuid(true,null,null);
    }

    // PEG CR - 2025 March
    // this function will return the nearest peg hole
    // prod is optional - for price tag products, converts hanging hole position to price tag center
    findNearestPeg = (pegCoordinations, productHoleX, productHoleY, thresholdX, thresholdY, prod = null) => {
      let nearestPeg = null;
      let minDistance = Infinity;

      let searchX = productHoleX;
      let searchY = productHoleY;
      const hasPriceTag = prod?.hasPriceTag;
      if (hasPriceTag) {
          const productHoleXPos = measureConverter(prod?.uom, "cm", prod?.haggingHorizontal) * this.props.displayratio;
          const productHoleYPos = measureConverter(prod?.uom, "cm", prod?.haggingVertical) * this.props.displayratio;
          const productDrawWidth = measureConverter(prod?.uom, this.props.displayuom, prod?.width) * this.props.displayratio;
          const priceTagHeightPx = (prod?.product?.priceTagHeightLatest || prod?.priceTagHeightLatest || prod?.priceTagHeight || 0) * this.props.displayratio;
          // Replace hanging hole offset with price tag center offset
          searchX = productHoleX - productHoleXPos + (productDrawWidth / 2);
          searchY = productHoleY - productHoleYPos + (priceTagHeightPx / 2);
      }

      for (const peg of pegCoordinations) {
        const deltaX = Math.abs(peg.drawX - searchX);
        const deltaY = Math.abs(peg.drawY - searchY);

        // Check if peg is within threshold
        if (deltaX <= thresholdX && deltaY <= thresholdY) {
          // Calculate Euclidean distance
          const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

          // Update if this is the nearest peg so far
          if (distance < minDistance) {
            minDistance = distance;
            nearestPeg = peg;
          }
        }
      }

      return nearestPeg;
    }

    // PEG CR - 2025 March
    // This function will return if product overlap in the exiting product set int peg board
    // newPegDrawY is the peg center Y for the new product being dropped (optional, used for price tag calculation)
    // newPegDrawX is the peg center X for the new product being dropped (optional, used for price tag X calculation)
    productOverlapChecker = (pegBoard, existingProductList, newProduct, cx, cy, newPegDrawY = null, newPegDrawX = null, pegBoardList = null) => {

      // remove the dropping product if avaliable the
      let existingPegProducts = existingProductList.filter((prod)=>prod?.id != newProduct?.id);
      const productWidth = newProduct?.drawWidth;
      // Calculate total height including price tag if hasPriceTag is true for new product
      const newPriceTagHeightPx = newProduct?.hasPriceTag ? (newProduct?.priceTagHeight * this.props.displayratio) : 0;
      const newGapPx = newProduct?.hasPriceTag ? (newProduct?.priceTagGap * this.props.displayratio) : 0;
      const productHeight = (newProduct?.isHanged && newProduct?.hasPriceTag)
          ? newPriceTagHeightPx + newGapPx + newProduct?.drawHeight
          : newProduct?.drawHeight;
      // For new product with price tag, Y starts at pegDrawY - (priceTagHeight/2)
      // Use newPegDrawY if provided, otherwise fall back to cy
      const newProductY = (newProduct?.isHanged && newProduct?.hasPriceTag && newPegDrawY)
          ? newPegDrawY - (newPriceTagHeightPx / 2)
          : cy;
      // For new product with price tag, X is centered on peg hole: pegDrawX - (drawWidth/2)
      const newProductX = (newProduct?.isHanged && newProduct?.hasPriceTag && newPegDrawX)
          ? newPegDrawX - (productWidth / 2)
          : cx;

      // Check for overlap with any existing products on the peg board
      for (let existingProduct of existingPegProducts) {
          // For existing products with price tag, X is centered on peg hole: pegDrawX - (drawWidth/2)
          const existingWidth = existingProduct?.drawWidth;
          const existingX = (existingProduct?.isHanged && existingProduct?.hasPriceTag && existingProduct?.pegDrawX !== undefined)
              ? existingProduct.pegDrawX - (existingWidth / 2)
              : existingProduct?.x;
          // Calculate price tag dimensions for existing product
          const existingPriceTagHeightPx = existingProduct?.hasPriceTag ? (existingProduct?.priceTagHeight * this.props.displayratio) : 0;
          const existingGapPx = existingProduct?.hasPriceTag ? (existingProduct?.priceTagGap * this.props.displayratio) : 0;
          // For products with price tag, Y starts at pegDrawY - (priceTagHeight/2)
          // pegDrawY is the peg hole center, price tag is centered on it
          const existingY = (existingProduct?.isHanged && existingProduct?.hasPriceTag && existingProduct?.pegDrawY !== undefined)
              ? existingProduct.pegDrawY - (existingPriceTagHeightPx / 2)
              : existingProduct?.y;
          // Calculate total height including price tag if hasPriceTag is true for existing product
          const existingHeight = (existingProduct?.isHanged && existingProduct?.hasPriceTag)
              ? existingPriceTagHeightPx + existingGapPx + existingProduct?.drawHeight
              : existingProduct?.drawHeight;

          // check if the products is delete ture then skip the products
          if(existingProduct?.isDelete){
            continue;
          }

          const isOverlap = !(
              newProductX + productWidth <= existingX || // New product is entirely left of the existing product
              newProductX >= existingX + existingWidth || // New product is entirely right of the existing product
              newProductY + productHeight <= existingY || // New product is entirely above the existing product
              newProductY >= existingY + existingHeight // New product is entirely below the existing product
          );

          if (isOverlap) {
              return {isOverlap:true, issueType: "HANGABLE_PRODUCT_OVERLAP"};
              // need to make the function to move exisitng product and get space
          }

      }

      // check if product is in outside the peg board
      const pegBoardStartX = pegBoard?.pegDrawingRect?.drawX;
      const pegBoardStartY = pegBoard?.pegDrawingRect?.drawY;
      const pegBoardEndX = pegBoard?.pegDrawingRect?.drawX + pegBoard?.pegDrawingRect?.drawRectWidth;

      // PEG CR Enhancement - allow hanging products to extend below pegboard boundary,
      // and to extend horizontally past their own pegboard's left/right edges
      // (e.g. into a neighbouring field's area). The top edge of the pegboard is
      // still a hard limit. Horizontally the product must stay inside the
      // simulation canvas (outermost field edges) and must not overlap any shelf
      // in the area it crosses into.
      if (newProductY < pegBoardStartY) {
          return {isOverlap:true, issueType: "PEG_BOARD_OVERLAP"};
      }

      // Compute simulation canvas left/right edges from all fields
      const mapFieldsForBounds = this.props.mapFields || {};
      const fieldValuesForBounds = Object.values(mapFieldsForBounds);
      let canvasLeft = Infinity;
      let canvasRight = -Infinity;
      for (const field of fieldValuesForBounds) {
          if (field?.x === undefined || field?.drawWidth === undefined) continue;
          if (field.x < canvasLeft) canvasLeft = field.x;
          const fieldRight = field.x + field.drawWidth;
          if (fieldRight > canvasRight) canvasRight = fieldRight;
      }
      if (canvasLeft !== Infinity && canvasRight !== -Infinity) {
          if (newProductX < canvasLeft || newProductX + productWidth > canvasRight) {
              return {isOverlap:true, issueType: "HANGABLE_PRODUCT_OUTSIDE_FIELD_BORDER"};
          }
      }

      // If the hanging product extends past its own pegboard horizontally,
      // make sure it does not overlap any shelf rect. Shelves that are
      // already covered by the current pegboard are excluded — those are
      // the "covering shelves" the product can hang freely above.
      const extendsLeft = newProductX < pegBoardStartX;
      const extendsRight = (newProductX + productWidth) > pegBoardEndX;
      if (extendsLeft || extendsRight) {
          // Build a map of fieldID -> Set of shelf ranks covered by ANY pegboard
          // (current pegboard + every other pegboard in pegBoardList). A product
          // hanging across pegboards can freely cover shelves that any pegboard
          // already covers.
          const allPegBoards = Array.isArray(pegBoardList) && pegBoardList.length
              ? pegBoardList
              : [pegBoard];
          const coveredShelvesByField = new Map();
          for (const pb of allPegBoards) {
              const fieldIDs = pb?.pegDrawingRect?.fieldIDs || [];
              const shelfRanks = pb?.pegDrawingRect?.shelfIDs || [];
              for (const fId of fieldIDs) {
                  if (!coveredShelvesByField.has(fId)) {
                      coveredShelvesByField.set(fId, new Set());
                  }
                  const rankSet = coveredShelvesByField.get(fId);
                  for (const r of shelfRanks) rankSet.add(r);
              }
          }
          const newProductBottomY = newProductY + productHeight;
          for (const field of fieldValuesForBounds) {
              if (!field?.shelf || !field.shelf.length) continue;
              const coveredRanks = coveredShelvesByField.get(field.actualFieldId);
              for (const shelf of field.shelf) {
                  // Skip shelves covered by any pegboard
                  if (coveredRanks && coveredRanks.has(shelf.rank)) continue;

                  const shelfStartX = shelf.x;
                  const shelfStartY = shelf.y + shelf.drawHeight;
                  const shelfEndX = shelf.x + shelf.drawWidth;
                  const shelfEndY = shelf.y + shelf.drawHeight + shelf.drawGap;

                  const isShelfOverlap =
                      newProductX + productWidth > shelfStartX &&
                      newProductX < shelfEndX &&
                      newProductBottomY > shelfStartY &&
                      newProductY < shelfEndY;
                  if (isShelfOverlap) {
                      this.props.setPreviewGuid(true,null,null);
                      return {isOverlap:true, issueType: "PRODUCT_CROSSES_SHELF_BELOW_PEG"};
                  }
              }
          }
      }

         // Check if the incoming hangable product overlaps with products & stacked products already placed on shelves.
        // A hangable product on the peg board must not overlap any non-hanged shelf product.
        if (newProduct?.isHanged) {
            const shelfProducts = (this.props.mapproductList || []).filter(
                p => !p.isDelete && !p.isHanged
            );
            for (const shelfProd of shelfProducts) {
                const stackCount = shelfProd.stackCount ?? 0;

                const sLeft   = shelfProd.x;
                const sRight  = shelfProd.x + shelfProd.drawWidth;
                const effectiveStack = stackCount && stackCount > 0 ? stackCount : 0;
                const sTop    = effectiveStack > 0 ? shelfProd.y - (shelfProd.drawHeight * effectiveStack) : shelfProd.y ; // If stackCount is 0 or undefined, treat as 1 layer (no stacking)
                const sBottom = shelfProd.y + shelfProd.drawHeight;
                const isOverlap = newProductX < sRight  && newProductX + productWidth  > sLeft &&
                                  newProductY < sBottom && newProductY + productHeight > sTop;
                if (isOverlap) {
                    return { isOverlap: true, issueType: "HANGABLE_SHELF_PRODUCT_OVERLAP" };
                }
            }
        }
      // No overlap, product can be dropped at the original position
      return {isOverlap:false};  // No overlap, return null or appropriate result
    };


    // PEG CR - 2025 March
    // This function will return if any product overlap the peg board
    // @pegboard - all peg board data array
    // @productList - all product list
    productOverlapCheckerWithPegBoard = (pegBoard, productList) => {
      // PEG CR Enhancement
      // Pegboard rect itself can now be overlapped by products freely.
      // Validation now blocks only when:
      //   1. The product extends beyond the simulation canvas (outermost field edges).
      //   2. The product overlaps any shelf rect that is not its own shelf
      //      (e.g. crossing into a neighbouring field's shelf area).
      const mapFields = this.props.mapFields || {};
      const fieldValues = Object.values(mapFields);

      // Compute simulation canvas left/right boundaries from all fields
      let canvasLeft = Infinity;
      let canvasRight = -Infinity;
      for (const field of fieldValues) {
        if (field?.x === undefined || field?.drawWidth === undefined) continue;
        if (field.x < canvasLeft) canvasLeft = field.x;
        const fieldRight = field.x + field.drawWidth;
        if (fieldRight > canvasRight) canvasRight = fieldRight;
      }

      for (let j = 0; j < productList.length; j++) {
        const product = productList[j];

        if (product.isDelete || product.isHanged) {
          continue;
        }

        const productStartX = product.x;
        const productStartY = product.y;
        const productEndX = product.x + product.drawWidth;
        const productEndY = product.y + product.drawHeight;

        // 1. Cannot go beyond the simulation canvas (field area)
        if (canvasLeft !== Infinity && canvasRight !== -Infinity) {
          if (productStartX < canvasLeft || productEndX > canvasRight) {
            return { isPegBoardOverlap: true, product: product };
          }
        }

        // 2. Cannot overlap any shelf rect (other than the product's own shelf)
        for (const field of fieldValues) {
          if (!field?.shelf || !field.shelf.length) continue;

          for (const shelf of field.shelf) {
            // Skip the shelf the product belongs to
            if (
              shelf.rank === product.shelfrank &&
              shelf.field_custom_id === product.field_custom_id
            ) {
              continue;
            }

            const shelfStartX = shelf.x;
            const shelfStartY = shelf.y;
            const shelfEndX = shelf.x + shelf.drawWidth;
            const shelfEndY = shelf.y + shelf.drawHeight;

            const isShelfOverlap =
              productEndX > shelfStartX &&
              productStartX < shelfEndX &&
              productEndY > shelfStartY &&
              productStartY < shelfEndY;

            if (isShelfOverlap) {
              return { isPegBoardOverlap: true, product: product };
            }
          }
        }
      }
      return { isPegBoardOverlap: false };
    }

    // PEG CR Enhancement - check if shelf products overlap with hanging products that extend below pegboard
    // @shelfProducts - shelf products being placed
    // @allProducts - all products in the map (includes hanged products)
    shelfProductOverlapWithHangedProducts = (shelfProducts, allProducts) => {
      // get all hanging products that are not deleted
      const hangedProducts = allProducts.filter(p => p.isHanged && !p.isDelete);

      for (let i = 0; i < shelfProducts.length; i++) {
        const shelfProd = shelfProducts[i];
        if (shelfProd.isDelete || shelfProd.isHanged) continue;

        const shelfX1 = shelfProd.x;
        const shelfY1 = shelfProd.y;
        const shelfX2 = shelfProd.x + shelfProd.drawWidth;
        const shelfY2 = shelfProd.y + shelfProd.drawHeight;

        for (let j = 0; j < hangedProducts.length; j++) {
          const hangProd = hangedProducts[j];
          const hangX1 = hangProd.x;
          const hangY1 = hangProd.y;
          const hangX2 = hangProd.x + hangProd.drawWidth;
          const hangY2 = hangProd.y + hangProd.drawHeight;

          // check if shelf product overlaps with hanging product
          if (shelfX1 < hangX2 && shelfX2 > hangX1 && shelfY1 < hangY2 && shelfY2 > hangY1) {
            return { isHangedProductOverlap: true, shelfProduct: shelfProd, hangedProduct: hangProd };
          }
        }
      }
      return { isHangedProductOverlap: false };
    }

    // For each shelf, computes vertical (y) coverage by all overlapping pegboards.
    // Shelves with coverage > COVERAGE_THRESHOLD go to coveredShelves; the rest
    // go to availableShelves (partial coverage up to the threshold is kept there).
    // coveredRanges / freeRanges are [yStart, yEnd] pairs within the shelf height.
    shelfSpaceAvalaibiltyChecker = (filedList, pegBoardList) => {
      const COVERAGE_THRESHOLD = 0.1; // shelves with <=10% overlap are still available
      const eps = 0.5;

      const fields = Object.values(filedList || {});
      const pegBoards = (pegBoardList || []).filter(p => p && p.pegDrawingRect);

      const mergeIntervals = (intervals) => {
        if (intervals.length === 0) return [];
        const sorted = intervals.slice().sort((a, b) => a[0] - b[0]);
        const merged = [sorted[0].slice()];
        for (let i = 1; i < sorted.length; i++) {
          const last = merged[merged.length - 1];
          const [s, e] = sorted[i];
          if (s <= last[1] + eps) { // overlapping or adjacent intervals
            last[1] = Math.max(last[1], e);
          } else {
            merged.push([s, e]);
          }
        }
        return merged;
      };

      const subtractIntervals = (rangeStart, rangeEnd, covered) => {
        const free = [];
        let cursor = rangeStart;
        covered.forEach(([s, e]) => {
          if (s > cursor) free.push([cursor, Math.min(s, rangeEnd)]);
          cursor = Math.max(cursor, e);
        });
        if (cursor < rangeEnd) free.push([cursor, rangeEnd]);
        return free;
      };

      const coveredShelves = [];
      const availableShelves = [];

      fields.forEach(field => {
        const shelves = field?.shelf || [];
        shelves.forEach(shelf => {
          const shelfStartX = shelf.x;
          const shelfEndX = shelf.x + shelf.drawWidth ;
          const shelfStartY = shelf.y;
          const shelfEndY = shelf.y + shelf.drawHeight;
          const shelfFullEndY = shelf.y + shelf.drawHeight + (shelf.drawGap || 0);
          const shelfHeight = shelf.drawHeight || 0;

          // Collect covered y-intervals from every pegboard that horizontally crosses this shelf
          
          const coveredIntervals = [];
          const coveringPegs = [];
          pegBoards.forEach(peg => {
            const rect = peg.pegDrawingRect;
            const pegStartX = rect.drawX;
            const pegEndX = rect.drawX + rect.drawRectWidth;
            const pegStartY = rect.drawY;
            const pegEndY = rect.drawY + rect.drawRectHeight;

            const overlapX = pegStartX < shelfEndX - eps && pegEndX > shelfStartX + eps;
            if (!overlapX) return;

            const yStart = Math.max(pegStartY, shelfStartY);
            const yEnd = Math.min(pegEndY, shelfEndY);
            if (yEnd - yStart <= eps) return;

            coveredIntervals.push([yStart, yEnd]);
            coveringPegs.push(peg);
          });

          const mergedCovered = mergeIntervals(coveredIntervals);
          const coveredHeight = mergedCovered.reduce((sum, [s, e]) => sum + (e - s), 0);
          const coverageRatio = shelfHeight > 0 ? (coveredHeight / shelfHeight) : 0;
          const freeIntervals = subtractIntervals(shelfStartY, shelfEndY, mergedCovered);
          const freeHeight = freeIntervals.reduce((sum, [s, e]) => sum + (e - s), 0);

          const shelfInfo = {
            shelfId: shelf.id,
            rank: shelf.rank,
            reverseRowNumber: shelf.reverseRowNumber,
            field_custom_id: shelf.field_custom_id,
            fieldId: field.fieldId,
            fieldName: field.fieldName,
            masterFieldId: field.masterFieldId,
            x: shelfStartX,
            y: shelfStartY,
            drawWidth: shelf.drawWidth,
            drawHeight: shelf.drawHeight,
            drawGap: shelf.drawGap,
            shelfEndX,
            shelfEndY,
            shelfFullEndY,
            availableFreeSpacing: shelf.availableFreeSpacing,
            coverageRatio,
            coveredHeight,
            freeHeight,
            coveredRanges: mergedCovered,
            freeRanges: freeIntervals,
            coveredBy: coveringPegs.map(p => p.pegBoardIndex),
          };

          if (coverageRatio > COVERAGE_THRESHOLD) {
            coveredShelves.push(shelfInfo);
          } else {
            availableShelves.push(shelfInfo);
          }
        });
      });

      return { coveredShelves, availableShelves };
    }

    // Product position checker
    // Validates only the products whose x / y / shelfrank / field_custom_id changed
    // between originalProductList and updatedFinalProductList. For each changed
    // product, its bottom edge (y + drawHeight) must rest in a free (non-pegboard)
    // y-range of its shelf.
    productPositionChecker = (originalProductList, updatedFinalProductList, shelfSpaceAvaliability, pegBoardList = []) => {
      const EPS = 0.01;
      // Bounds checks tolerate small floating-point drift (e.g. y + drawHeight
      // vs shelfEndY can differ by ~0.02px from accumulated rounding) — keep
      // this looser than EPS so genuinely-aligned drops are not rejected.
      const BOUNDS_EPS = 0.5;
      const POS_EPS = 0.0001; // tolerance when comparing x / y floats

      const originalMap = new Map();
      (originalProductList || []).forEach(p => {
        if (p && p.id != null) originalMap.set(p.id, p);
      });

      const hasPositionChange = (product) => {
        const original = originalMap.get(product.id);
        if (!original) return true; // new product - validate it
        if (String(original.field_custom_id) !== String(product.field_custom_id)) return true;
        if (original.shelfrank !== product.shelfrank) return true;
        if (Math.abs((original.x || 0) - (product.x || 0)) > POS_EPS) return true;
        if (Math.abs((original.y || 0) - (product.y || 0)) > POS_EPS) return true;
        return false;
      };

      const allLive = (updatedFinalProductList || []).filter(p => p && !p.isDelete);
      const products = allLive.filter(hasPositionChange);

      // Pool of "other" products for overlap checks: every live product,
      // including hanging (pegboard) products - their draw rectangles share the
      // same plane as shelf products and must not intersect.
      const otherPool = allLive.filter(p =>
        typeof p.x === 'number' && typeof p.y === 'number' &&
        typeof p.drawWidth === 'number' && typeof p.drawHeight === 'number'
      );

      const allShelves = [
        ...(shelfSpaceAvaliability?.coveredShelves || []),
        ...(shelfSpaceAvaliability?.availableShelves || []),
      ];

      // coveredShelves get heavy peg coverage (>10% Y by shelfSpaceAvalaibiltyChecker)
      // and represent fields that are effectively pegboards at this row. Products
      // cannot land on them as shelf products, so the same-level X chain walk
      // must not bridge through them — otherwise a drop / auto-compaction that
      // mis-places products into a pegged column gets reported as a confusing
      // OVERLAPPING_PEGBOARD instead of an OUT_OF_SHELF_BOUNDS at the column edge.
      const coveredShelfIdSet = new Set(
        (shelfSpaceAvaliability?.coveredShelves || []).map(s => s.shelfId)
      );

      // Peg rectangles - used for direct rect-vs-peg overlap checks. The
      // per-shelf freeRanges in shelfSpaceAvaliability collapses peg coverage
      // to a Y interval, which loses the peg's X extent. When a product
      // straddles a same-level neighbor that happens to host a peg in some
      // other X column, the Y-only check would falsely reject placements
      // whose rectangle actually misses the peg.
      const pegRects = (pegBoardList || [])
        .filter(p => p && p.pegDrawingRect)
        .map(p => ({
          x: p.pegDrawingRect.drawX,
          y: p.pegDrawingRect.drawY,
          endX: p.pegDrawingRect.drawX + p.pegDrawingRect.drawRectWidth,
          endY: p.pegDrawingRect.drawY + p.pegDrawingRect.drawRectHeight,
          pegBoardIndex: p.pegBoardIndex,
        }));

      const rectsOverlap = (a, b) => {
        const aX1 = a.x, aX2 = a.x + a.drawWidth;
        const aY1 = a.y, aY2 = a.y + a.drawHeight;
        const bX1 = b.x, bX2 = b.x + b.drawWidth;
        const bY1 = b.y, bY2 = b.y + b.drawHeight;
        // Touching edges (within EPS) don't count as overlap
        return aX1 + EPS < bX2 && aX2 > bX1 + EPS &&
               aY1 + EPS < bY2 && aY2 > bY1 + EPS;
      };

      const invalidProducts = [];
      const skipped = [];
      products.forEach(product => {
        // A product is only a "true" hanging product when it is actively hanged
        // AND carries a peg product id. A stale pegBoardIndex alone is not enough
        // to skip validation - we've seen shelf products keep stale peg fields.
        const isTrueHanging = product.isHanged === true && !!product.pegProductId;
        if (isTrueHanging) {
          skipped.push({ id: product.id, name: product.name, reason: "HANGING" });
          return;
        }

        // Products without a shelfrank aren't on a shelf - nothing to validate here
        if (product.shelfrank == null) {
          skipped.push({ id: product.id, name: product.name, reason: "NO_SHELFRANK" });
          return;
        }

        const shelf = allShelves.find(s =>
          String(s.field_custom_id) === String(product.field_custom_id) &&
          s.rank === product.shelfrank
        );

        if (!shelf) {
          invalidProducts.push({
            id: product.id,
            name: product.name,
            product,
            reason: "SHELF_NOT_FOUND",
            i18nKey: "PRODUCT_SHELF_NOT_FOUND",
          });
          return;
        }

        const prodStartX = product.x;
        const prodEndX = product.x + product.drawWidth;
        const prodEndY = product.y + product.drawHeight;

        // A product can be dropped straddling two horizontally-adjacent shelves
        // that sit at the same physical level. "Same level" means bottoms align
        // (y + drawHeight == next y + drawHeight) - tops may differ when one
        // field has a taller shelf because a peg removed an inner divider.
        // The product is recorded against one shelf via shelfrank+field_custom_id,
        // so its rectangle may extend past that single shelf's shelfEndX. Walk
        // the chain of same-bottom-aligned neighbors to build the contiguous run
        // and validate X bounds against the run rather than the single shelf.
        const isSameLevel = (a, b) =>
          Math.abs(a.shelfEndY - b.shelfEndY) <= BOUNDS_EPS;

        // Exclude pegboard-covered shelves from the chain so the run cannot
        // bridge across a fully-pegged column. The home shelf itself is kept
        // even if it is in coveredShelves (the bounds check still needs to
        // compare against it).
        const sameLevelShelves = allShelves.filter(s =>
          isSameLevel(s, shelf) && (s === shelf || !coveredShelfIdSet.has(s.shelfId))
        );

        let runStartX = shelf.x;
        let runEndX = shelf.shelfEndX;

        let cursor = shelf;
        while (true) {
          const next = sameLevelShelves.find(s =>
            s !== cursor && Math.abs(s.x - cursor.shelfEndX) <= BOUNDS_EPS
          );
          if (!next || next.shelfEndX <= runEndX + BOUNDS_EPS) break;
          runEndX = next.shelfEndX;
          cursor = next;
        }

        cursor = shelf;
        while (true) {
          const prev = sameLevelShelves.find(s =>
            s !== cursor && Math.abs(s.shelfEndX - cursor.x) <= BOUNDS_EPS
          );
          if (!prev || prev.x >= runStartX - BOUNDS_EPS) break;
          runStartX = prev.x;
          cursor = prev;
        }

        // Sub-fields of the same master field (split fixtures) are separated by a
        // column divider whose gap is wider than BOUNDS_EPS, so the adjacency walk
        // above cannot bridge them. Extend the run to include all same-masterFieldId
        // shelves at the same level so products that straddle the divider are accepted.
        // Use allShelves (not sameLevelShelves) so covered/pegged sub-fields of the
        // same master field are included when computing the fixture's full X range.
        const sameGroupShelves = allShelves.filter(s =>
          s.masterFieldId === shelf.masterFieldId && isSameLevel(s, shelf)
        );
        if (sameGroupShelves.length > 0) {
          runStartX = Math.min(runStartX, ...sameGroupShelves.map(s => s.x));
          runEndX   = Math.max(runEndX,   ...sameGroupShelves.map(s => s.shelfEndX));
        }

        if (
          prodStartX < runStartX - BOUNDS_EPS ||
          prodEndX > runEndX + BOUNDS_EPS ||
          prodEndY < shelf.y - BOUNDS_EPS ||
          prodEndY > shelf.shelfEndY + BOUNDS_EPS
        ) {
          invalidProducts.push({
            id: product.id,
            name: product.name,
            product,
            shelf,
            reason: "OUT_OF_SHELF_BOUNDS",
            i18nKey: "PRODUCT_OUT_OF_SHELF_BOUNDS",
          });
          return;
        }

        // The product rectangle must not intersect any peg rectangle. A
        // direct rect-vs-rect test is more accurate than checking the host
        // shelf's freeRanges: the latter only knows the peg's Y interval, not
        // its X extent, so a product placed at the edge of a field where the
        // peg lives in a different X column was being falsely rejected.
        // const overlappingPeg = pegRects.find(peg =>
        //   prodStartX + BOUNDS_EPS < peg.endX &&
        //   prodEndX > peg.x + BOUNDS_EPS &&
        //   product.y + BOUNDS_EPS < peg.endY &&
        //   prodEndY > peg.y + BOUNDS_EPS
        // );
        // if (overlappingPeg) {
        //   invalidProducts.push({
        //     id: product.id,
        //     name: product.name,
        //     product,
        //     shelf,
        //     reason: "OVERLAPPING_PEGBOARD",
        //     i18nKey: "PRODUCT_OVERLAPS_PEGBOARD",
        //     overlap: overlappingPeg,
        //   });
        //   return;
        // }

        const freeRanges   = shelf.freeRanges || [];
        const bottomInFree = freeRanges.some(([fs, fe]) =>
          prodEndY >= fs - EPS && prodEndY <= fe + EPS
        );

        if (!bottomInFree) {
          const hitCovered = (shelf.coveredRanges || []).find(([cs, ce]) =>
            prodEndY >= cs - EPS && prodEndY <= ce + EPS
          );
          // Only flag a real peg-board overlap. When coveredRanges is empty the
          // product's bottom merely drifted a fraction past shelfEndY due to
          // floating-point accumulation — the bounds check above already accepted
          // it with a looser tolerance, so don't raise a false alarm here.
          if (hitCovered) {
            invalidProducts.push({
              id: product.id,
              name: product.name,
              product,
              shelf,
              reason: "OVERLAPPING_PEGBOARD",
              i18nKey: product?.isHangable? "PRODUCT_OVERLAPS_PEGBOARD" : "NOT_HANGABLE_PRODUCT",//"PRODUCT_OVERLAPS_PEGBOARD",
              overlap: hitCovered,
            });
            return;
          }
        }

        // Intersects another (non-deleted, non-hanging) product?
        const overlappedWith = otherPool.find(other =>
          other.id !== product.id && rectsOverlap(product, other)
        );
        if (overlappedWith) {
          invalidProducts.push({
            id: product.id,
            name: product.name,
            product,
            shelf,
            reason: "OVERLAPPING_PRODUCT",
            i18nKey: "PRODUCT_OVERLAPS_ANOTHER_PRODUCT",
            overlappedWith: {
              id: overlappedWith.id,
              name: overlappedWith.name,
            },
          });
        }
      });

      return {
        hasIssues: invalidProducts.length > 0,
        invalidProducts,
        skipped,
      };
    }

    render() {
        //PEG CR - 2025 - When current selected block is null then set the selectBlockObj to null
        let blockobj   = this.props.currentSelectedBlock != null ? this.props.currentSelectedBlock : this.state.selectBlockObj;
        //let blockobj = this.state.selectBlockObj;
        let ghostobj   = this.props.ghostWrapperObj;

        // Get price tag info from first product in drawingProducts
        const firstProduct = blockobj?.drawingProducts?.[0];
        const hasPriceTag = firstProduct?.hasPriceTag;
        const isHanged = firstProduct?.isHanged;
        const priceTagHeight = firstProduct?.priceTagHeight || 0;
        const priceTagGap = firstProduct?.priceTagGap || 0;

        // Calculate total height including price tag if hasPriceTag is true
        const priceTagHeightPx = hasPriceTag ? (priceTagHeight * this.props.displayratio) : 0;
        const gapPx = hasPriceTag ? (priceTagGap * this.props.displayratio) : 0;
        const totalHeight = isHanged && hasPriceTag
            ? priceTagHeightPx + gapPx + (blockobj?.drawHeight || 0)
            : (blockobj?.drawHeight || 0);

        // For hanged products with price tag, align ghost rect with price tag (centered on peg hole)
        const ghostX = (isHanged && hasPriceTag && firstProduct?.pegDrawX)
            ? blockobj?.x 
            : (blockobj?.x || 0);
        const ghostY = (isHanged && hasPriceTag && firstProduct?.pegDrawY)
            ? firstProduct.pegDrawY - (priceTagHeightPx/2) 
            : (blockobj?.y || 0);

        return <g>
                  <rect onMouseDown={(e)=> this.props.handleBlockContextMenu(e,true,ghostX,ghostY,blockobj?blockobj.drawWidth:0,blockobj?totalHeight:0,blockobj.drawingProducts)}
                   x={ghostX}
                   y={ghostY}
                   width={blockobj?blockobj.drawWidth:0}
                   //height={ghostobj?ghostobj.height:blockobj?blockobj.drawHeight:0}
                   height={totalHeight}
                   pointerEvents="all" fill={this.props.isPegDrawing === true?'':'green'} fillOpacity={this.props.isPegDrawing === true? 0:0.3} ref={(r) => this["LM01"] = r} />

                  {/* <rect x={blockobj?blockobj.x:0} className="resize-controls-y" ref={(r) => this["rsx_left"] = r} y={blockobj?blockobj.y:0} width={"3"} height={blockobj?blockobj.drawHeight:0} fill="green" fillOpacity={"0.6"} />
                  <rect x={blockobj?((blockobj.x + blockobj.drawWidth) - 3):0} className="resize-controls-y" ref={(r) => this["rsx_right"] = r} y={blockobj?blockobj.y:0} width={"3"} height={blockobj?blockobj.drawHeight:0} fill="green" fillOpacity={"0.6"} />
                 */}
              </g>

    }
  }

  export function setGuidlineComman(props){
    // var evt=props.evt
    var cx = structuredClone(props.cx);
    var cy = structuredClone(props.cy);
    
    var selectBlockObj = structuredClone(props.selectBlockObj);
    var mapCatRects = props.mapCatRects;
    var mapFields = props.mapFields;
    var mapproductList = props.mapproductList;

    // Space-availability check done in real-world units (cm) instead of draw pixels, so the
    // result does not depend on the browser's DOM-measured displayRatio. The pixel-grid
    // comparison this replaced rounded a nearly-full shelf to opposite sides of the boundary
    // depending on the browser's pixel scale - accepted in Chrome, rejected ("No space
    // available") in Edge. See EditSimulateCategory.fitsInDropSpace for the full explanation.
    var displayRatio = props.displayRatio || 1;
    const fitsInDropSpace = (freeSpaceDrawWidth, requiredDrawWidth) => {
      const SPACE_TOLERANCE_CM = 0.1;
      const freeCm     = (Number(freeSpaceDrawWidth) || 0) / displayRatio;
      const requiredCm = (Number(requiredDrawWidth)  || 0) / displayRatio;
      return requiredCm <= freeCm + SPACE_TOLERANCE_CM;
    };

    var previewShelves = [];
    let movingObj = JSON.parse(JSON.stringify(selectBlockObj));

    if(!movingObj){
      return;
    }
    
    var MOStartX = roundOffDecimal(cx,2);
    var MOStartY = roundOffDecimal(cy,2);
    var MOEndX = roundOffDecimal((cx + movingObj?.drawWidth),2);
    var MOEndY = roundOffDecimal((cy + movingObj?.drawHeight),2);

    var containElem = elmAccordingtoXY(cx,cy,movingObj?.drawWidth,movingObj?.drawHeight,mapFields,mapCatRects);
    
    let ghostobj = { width: 0, height: 0, selectedShelfSet: [] };
    
    var selectingField = containElem?.field;

    //console.log('selectingField_1=>', selectingField);

    const matchingField = props?.actualFieldStructuresNew?.find(
      field => field.field_id === selectingField?.masterFieldId
    );

    if(selectingField){
      var fieldStartX = roundOffDecimal(selectingField.x);
      var fieldStartY = roundOffDecimal(selectingField.y,2);
      var fieldEndX = roundOffDecimal((selectingField.x+selectingField.drawWidth+matchingField?.drawWidth),2);
      var fieldEndY = roundOffDecimal((selectingField.x+selectingField.drawHeight),2);
      
      let isinsidefield = false;
      //check inside field
      if((fieldStartX < MOStartX && fieldEndX > MOEndX) && (fieldStartY < MOStartY && fieldEndY > MOEndY)){
        isinsidefield = true;
      } else{
        if(fieldStartY < MOStartY && fieldEndY > MOEndY){
          //if item x1 is less than field x1 and item x2 not greater than field x2
          
          if(fieldStartX > MOStartX && fieldEndX > MOEndX){
            MOStartX = fieldStartX;
            isinsidefield = true;
          }
          //if item x1 is greater than field x1 and item x2 not less than field x2
          if(fieldStartX < MOStartX && fieldEndX < MOEndX){
            // MOStartX = roundOffDecimal((fieldEndX - movingObj.drawWidth),2);
            isinsidefield = true;
          }
        }

        //if block inside field but not from bottom of field
        if((fieldStartX < MOStartX && fieldEndX > MOEndX) && fieldStartY < MOStartY){
          //cy = roundOffDecimal((fieldEndY - selectingField.drawHeight),2);
          // MOStartY = roundOffDecimal((fieldEndY - selectingField.drawHeight),2);
          // MOEndY = roundOffDecimal(fieldEndY,2);
          isinsidefield = true;
        }
      }

      let previewprodlist = [];
      let anchorIdx = 0;
      if(isinsidefield){
        var existingProducts = JSON.parse(JSON.stringify(mapproductList));
        let changefield = mapFields[selectingField.key];
        // console.log("loc1");
        let containProds = GetContainingProdsByBox(MOStartX , MOStartY, MOEndX, MOEndY, existingProducts, changefield, false, null, [], true);
        
        let lowestprodx = MOStartX;
        let highestprodx2 = roundOffDecimal((lowestprodx + movingObj.drawWidth),2);
        
        // let cutshelfs = []; 
        let droppingXProd = null; //to find prod available in dropping x1 position
        if(containProds && containProds.selectedProds && containProds.selectedProds.length>0){
          var notDeletedContainProds = containProds.selectedProds.filter(f => !f.isDelete);
          for (let p = 0; p < notDeletedContainProds.length; p++) {
            const prod = notDeletedContainProds[p];
            
              for (let j = 0; j < movingObj.selectedshelves.length; j++) {
                const ele = movingObj.selectedshelves[j];
                var ishaveinSlectedshleves = ele.selectedProducts.find(x=>x.id===prod.id)
                //check save moving produtcs not cutting
                if(ishaveinSlectedshleves === undefined){
                  let prodstartx = (prod.x);
                  let checkprodwidth = (((prod.drawWidth / 3) > 8)?(prod.drawWidth / 3):(prod.drawWidth / 2));
                  let prodmiddlex = (prod.x + checkprodwidth);
                  
                  if(lowestprodx > prodstartx && lowestprodx < prodmiddlex){
                    lowestprodx = prod.x;
                    highestprodx2 = roundOffDecimal((lowestprodx + movingObj.drawWidth),2);
                  }
                  

                  //left side
                  if(prod.x <= MOStartX && MOStartX <= roundOffDecimal((prod.x + prod.drawWidth),2)){
                    droppingXProd = prod;
                  }

                  //right side
                  if(!droppingXProd && (prod.x <= MOEndX && MOEndX <= roundOffDecimal((prod.x + prod.drawWidth),2))){
                    droppingXProd = prod;
                  }

                  //add lower than max dropping x2 products
                  let prodx2 = roundOffDecimal((prod.x + prod.drawWidth),2);
                  if(prodx2 <= highestprodx2){
                    previewprodlist.push(prod);
                  }
                }
              }
          }
        }
        
        let containshelfs = (selectingField.contain_shelfs?selectingField.contain_shelfs:[]);

        //if dropping position x not have product find last left product x to drop
        // commented get snapping location - (automatically magnetizes a product to another product)
        // if(!droppingXProd){
        //   lowestprodx = getSnappingLocation(lowestprodx, selectingField, existingProducts, movingObj, containshelfs);
        // }

        //reset guidlines
        containshelfs.forEach(conshlf => {
          conshlf.previewguid={startX:-1,endX:-1}
        });

        // Pick the field shelf with the highest overlap against the moving
        // object's bounding box and use it as the anchor row. Without this,
        // the guide loop maps row m → containshelfs[m] positionally, so the
        // green dotted preview always sticks to the field's top shelves even
        // when the user is dragging over a lower shelf.
        const moBoxStartX = MOStartX;
        const moBoxStartY = MOStartY;
        const moBoxEndX = MOEndX;
        const moBoxEndY = MOEndY;
        const moBoxArea = Math.max(0, moBoxEndX - moBoxStartX) * Math.max(0, moBoxEndY - moBoxStartY);
        let bestAnchorRatio = 0;
        let anchorPickedByOverlap = false;
        for (let i = 0; i < containshelfs.length; i++) {
          const s = containshelfs[i];
          const sStartX = s.x;
          const sEndX = s.x + s.drawWidth;
          const sStartY = s.y;
          const sEndY = s.y + s.drawHeight;
          const oW = Math.max(0, Math.min(moBoxEndX, sEndX) - Math.max(moBoxStartX, sStartX));
          const oH = Math.max(0, Math.min(moBoxEndY, sEndY) - Math.max(moBoxStartY, sStartY));
          const oArea = oW * oH;
          if (oArea <= 0) continue;
          const sArea = Math.max(0, sEndX - sStartX) * Math.max(0, sEndY - sStartY);
          const denom = Math.min(moBoxArea || Infinity, sArea || Infinity);
          const ratio = denom > 0 ? oArea / denom : 0;
          if (ratio > bestAnchorRatio) {
            bestAnchorRatio = ratio;
            anchorIdx = i;
            anchorPickedByOverlap = true;
          }
        }
        // Fallback: when the cursor sits in the gap between shelves the
        // overlap is zero for every shelf, so the loop above can't pick. In
        // that case pick the shelf whose vertical center is closest to the
        // moving object's vertical center — that's the shelf the user is
        // visually aiming at.
        if (!anchorPickedByOverlap && containshelfs.length > 0) {
          const moCenterY = (moBoxStartY + moBoxEndY) / 2;
          let bestDistance = Infinity;
          for (let i = 0; i < containshelfs.length; i++) {
            const s = containshelfs[i];
            const sCenterY = s.y + s.drawHeight / 2;
            const distance = Math.abs(sCenterY - moCenterY);
            if (distance < bestDistance) {
              bestDistance = distance;
              anchorIdx = i;
            }
          }
        }
        // Keep the whole moving block inside the available shelves.
        const movingRowCount = movingObj.selectedshelves.length;
        if (anchorIdx + movingRowCount > containshelfs.length) {
          anchorIdx = Math.max(0, containshelfs.length - movingRowCount);
        }

        for (let m = 0; m < movingObj.selectedshelves.length; m++) {
          const changeshelf = movingObj.selectedshelves[m];
          var maxEndX = 0; var maxY = 0; //var maxEndY = 0;
          var stratingXofshelvf=0
          const targetShelfIdx = anchorIdx + m;
          const targetShelf = containshelfs[targetShelfIdx];
          //if found
          if(targetShelf){

            let curshelfitemy = (targetShelf?(targetShelf.y + targetShelf.drawHeight):0);
            for (let k = 0; k < changeshelf.selectedProducts.length; k++) {
              const changeproditem = changeshelf.selectedProducts[k];
              let gapbetweenoribox = (changeproditem.x - movingObj.x);
              //only first time

              if(k===0){
                stratingXofshelvf=(lowestprodx + gapbetweenoribox);
              }

              changeproditem["x"] = (lowestprodx + gapbetweenoribox);
              changeproditem["y"] = (curshelfitemy - changeproditem.drawHeight);
              changeproditem["shelfrank"] = targetShelf.rank;

              existingProducts[changeproditem.prodidx] = changeproditem;
              existingProducts[changeproditem.prodidx]["isDelete"] = false;
              if(maxY<changeproditem.y){
                maxY=changeproditem.y
                // maxEndY=changeproditem.y+changeproditem.drawHeight;
              }

              let curprodendx = (changeproditem.x + changeproditem.drawWidth);
              if(curprodendx > maxEndX){
                maxEndX = curprodendx
              }
              
            } 

            
            targetShelf["previewguid"] = { startX: stratingXofshelvf, endX: maxEndX };

            // console.log(structuredClone(containshelfs[m]));

            if(targetShelf.previewguid.startX > -1){
              let gapbetweenguidelines = (targetShelf.previewguid.endX - targetShelf.previewguid.startX);

              ghostobj.width = (gapbetweenguidelines > ghostobj.width?gapbetweenguidelines:ghostobj.width);
              ghostobj.height += (targetShelf.drawHeight + targetShelf.drawGap);
            }
          }
        }
        //checking inside shelf or not
        if(containElem.isInsideShelf){
          previewShelves = structuredClone(containshelfs);
        }

      } else{
        props.setPreviewGuid(true);
      }

      // New CR - 2025 Jan 13
      let selectedProductBlock = movingObj?.drawingProducts;
     
      if(selectedProductBlock && selectedProductBlock.length > 0){
        // Run space-validation/enable-drop when all selected products sit on the SAME
        // visual level (one row). This used to require an identical `shelfrank` for every
        // product, but shelfrank is relative to each field - a single row spanning two
        // fields has different shelfranks at the same level, so that check failed and
        // setSpaceValidation() never ran, leaving isAllowToDrop=false and blocking the drop.
        // getSimilarLevelShelves() below already matches shelves by level (y + drawHeight),
        // so a same-level gate is the correct (and field-agnostic) condition.
        const LEVEL_TOLERANCE = 2; // px - bottom edges within this gap are the same row
        let firstBottom = selectedProductBlock[0].y + selectedProductBlock[0].drawHeight;
        let allProductsSameLevel = selectedProductBlock.every(
          (p) => Math.abs((p.y + p.drawHeight) - firstBottom) <= LEVEL_TOLERANCE
        );

        if(allProductsSameLevel){
          let currentMovingSelectedShelf = null;
          for (const shelf of previewShelves) {

            const startX = shelf.x;
            const endX = shelf.x+shelf.drawWidth;
            const startY = shelf.y;
            const endY = shelf.y + shelf.drawHeight;
           
            
            // Check if cx and cy fall within the shelf boundaries
            if (cx >= startX && cx <= endX && cy >= startY && cy <= endY) {
              currentMovingSelectedShelf = shelf
            }
          // get similer shelf from selected shelf y+drawheight
          let similarLevelShelves = getSimilarLevelShelves(currentMovingSelectedShelf, mapFields , props?.actualFieldStructuresNew);

          // Trim the chain at any pegboard-blocked neighbor so the auto-
          // compaction that runs after drop cannot pack products into a column
          // a peg occupies. Without this, a right-to-left drag whose nearest
          // free space happens to be on the far side of a pegged field gets
          // compacted into the peg's column, which the validator then rejects.
          const pegRectsForGuide = (props?.pegList || [])
            .map(p => p?.pegDrawingRect)
            .filter(Boolean)
            .map(r => ({
              x1: r.drawX,
              x2: r.drawX + r.drawRectWidth,
              y1: r.drawY,
              y2: r.drawY + r.drawRectHeight,
            }));
          const isShelfBlockedByPeg = (s) => pegRectsForGuide.some(p =>
            s.x + 0.5 < p.x2 && s.x + s.drawWidth > p.x1 + 0.5 &&
            s.y + 0.5 < p.y2 && s.y + s.drawHeight > p.y1 + 0.5
          );
          if (currentMovingSelectedShelf && pegRectsForGuide.length > 0 && similarLevelShelves.length > 0) {
            const anchorIdx = similarLevelShelves.findIndex(s =>
              s.x === currentMovingSelectedShelf.x &&
              s.drawWidth === currentMovingSelectedShelf.drawWidth
            );
            if (anchorIdx >= 0) {
              let lo = anchorIdx;
              while (lo > 0 && !isShelfBlockedByPeg(similarLevelShelves[lo - 1])) lo--;
              let hi = anchorIdx;
              while (hi < similarLevelShelves.length - 1 && !isShelfBlockedByPeg(similarLevelShelves[hi + 1])) hi++;
              similarLevelShelves = similarLevelShelves.slice(lo, hi + 1);
            }
          }
          // concat similarLevelShelves with currentMovingSelectedShelf arrays
          let selectedShelfSet = [];
          // selectedShelfSet.push(currentMovingSelectedShelf);
          selectedShelfSet = selectedShelfSet.concat(similarLevelShelves);

          let productList = JSON.parse(JSON.stringify(mapproductList));
          let exisitingProductList = getSelectedProducts(productList, selectedShelfSet, selectedProductBlock);
          // get exiting product total width
          let totalProductWidth = 0;
          exisitingProductList.forEach(product => {
            totalProductWidth += product?.drawWidth;
          });

          // get total width of selected shelf
          let totalShelfWidth = 0;
          selectedShelfSet.forEach(shelf => {
            totalShelfWidth += shelf?.drawWidth;
          });
          let restSpace = totalShelfWidth - totalProductWidth;
          // get moving product block width
          let movingProductBlockWidth = 0;
          selectedProductBlock.forEach(product => {
            movingProductBlockWidth += product?.drawWidth;
          });
          props.setSpaceValidation(
            fitsInDropSpace(restSpace, movingProductBlockWidth),
            roundOffDecimal(totalProductWidth,2),
            roundOffDecimal(totalShelfWidth,2),
            roundOffDecimal(restSpace,2),
            roundOffDecimal(movingProductBlockWidth,2),
            selectedShelfSet
          )
          ghostobj.selectedShelfSet = selectedShelfSet;
          }
        } else {
          // MULTI-LEVEL selection (block spans more than one shelf row). The single-row
          // validation above can't model this, so validate each selected row against the
          // target shelf it will land on. previewShelves mirrors contain_shelfs (drop shelf
          // first, then each shelf below), and movingObj.selectedshelves is ordered the same
          // way, so selectedshelves[i] lands on previewShelves[i] - exactly the mapping the
          // drop placement loop uses. The drop is allowed only when every row fits its target.
          const movingShelves = movingObj.selectedshelves || [];
          let allRowsFit = movingShelves.length > 0;
          let combinedShelfSet = [];
          for (let i = 0; i < movingShelves.length; i++) {
            const targetShelf = previewShelves[i];
            if (!targetShelf) { allRowsFit = false; break; }
            const rowShelfSet = getSimilarLevelShelves(targetShelf, mapFields, props?.actualFieldStructuresNew);
            if (!rowShelfSet || rowShelfSet.length === 0) { allRowsFit = false; break; }

            const rowProductList = JSON.parse(JSON.stringify(mapproductList));
            const existingOnRow = getSelectedProducts(rowProductList, rowShelfSet, selectedProductBlock);
            const existingWidth = existingOnRow.reduce((sum, p) => sum + (p?.drawWidth || 0), 0);
            const rowShelfWidth = rowShelfSet.reduce((sum, s) => sum + (s?.drawWidth || 0), 0);
            const rowRestSpace = rowShelfWidth - existingWidth;
            const rowMovingWidth = (movingShelves[i].selectedProducts || [])
              .reduce((sum, p) => sum + (p?.drawWidth || 0), 0);

            if (!fitsInDropSpace(rowRestSpace, rowMovingWidth)) {
              allRowsFit = false;
            }
            combinedShelfSet = combinedShelfSet.concat(rowShelfSet);
          }
          props.setSpaceValidation(allRowsFit, 0, 0, 0, 0, combinedShelfSet);
          ghostobj.selectedShelfSet = combinedShelfSet;
        }
      }
      props.updateGhostObjDetails(ghostobj);
      props.setPreviewGuid(false, previewShelves, selectingField, false, previewprodlist);

    } else{
      props.setPreviewGuid(true);
    }

  }


  // This function returns the similar level shelves
  export function getSimilarLevelShelves(currentMovingSelectedShelf, mapFields) {
      // const result = [];
      // if(!currentMovingSelectedShelf) return result;
      // const currentFieldCustomId = currentMovingSelectedShelf.field_custom_id;
      // const currentY = currentMovingSelectedShelf.y;
      // const currentHeight = currentMovingSelectedShelf.drawHeight;
      // const currentX = currentMovingSelectedShelf.x;
      // const currentDrawWidth = currentMovingSelectedShelf.drawWidth;

      // for (const fieldId in mapFields) {
      //     // Skip the same field_custom_id
      //     if (fieldId === currentFieldCustomId) continue;

      //     const field = mapFields[fieldId];
      //     const shelves = field.shelf;

      //     for (const shelf of shelves) {
      //         const shelfY = shelf.y;
      //         const shelfHeight = shelf.drawHeight;

      //         // Check if the shelf is at a similar level
      //         if (roundOffDecimal(shelfY + shelfHeight, 2) === roundOffDecimal(currentY + currentHeight, 2)) {
      //         // if ((shelfY + shelfHeight > currentY && shelfY < currentY + currentHeight)) {
      //             result.push(shelf);
      //         }
      //     }
      // }

      // return result;

      // Version 2 - Added x nearest x coordination shelf picking changes
      //const currentFieldCustomId = currentMovingSelectedShelf.field_custom_id;
      const currentY = currentMovingSelectedShelf?.y;
      const currentHeight = currentMovingSelectedShelf?.drawHeight;
      const currentX = currentMovingSelectedShelf?.x;
      const currentDrawWidth = currentMovingSelectedShelf?.drawWidth;
      const currentShelf = currentMovingSelectedShelf?.rank;
      const currentDrawGap = currentMovingSelectedShelf?.drawGap;
  
      let shelvesAtSameLevel = [];

      // Collect shelves that are at the same Y level
      for (const fieldId in mapFields) {
          // if (fieldId === currentFieldCustomId) continue;
          //if(mapFields[fieldId].shelf === currentShelf) continue;
          
          const field = mapFields[fieldId];
          const shelves = field.shelf;

          for (const shelf of shelves) {
              
              const shelfY = shelf.y;
              const shelfHeight = shelf.drawHeight;

              // Check if the shelf is at the same level (y + height match).
              // Use a small pixel tolerance instead of exact (rounded) equality. shelfY/shelfHeight
              // are accumulated pixel values (cm * displayRatio), and float accumulation makes
              // physically-same-level shelves differ by ~0.01px. displayRatio differs slightly
              // between browser engines (Edge vs Chrome), so the old exact match split one shelf
              // out of its level in Edge only, shrinking the usable level (e.g. to a single shelf)
              // and triggering a false "No space available". PLAN-1355.
              if (Math.abs((shelfY + shelfHeight) - (currentY + currentHeight)) <= 0.5) {
                  shelvesAtSameLevel.push(shelf);
              }
          }
      }

      // Sort shelves by x position
      shelvesAtSameLevel.sort((a, b) => a.x - b.x);

      // Find the selected shelf in the sorted list
      let selectedShelf = shelvesAtSameLevel.find(shelf => shelf.x === currentX && shelf.drawWidth === currentDrawWidth);
      if (!selectedShelf) {
          return [];
      }

      // Initialize merged shelves with the selected shelf
      let mergedShelves = [selectedShelf];

      // Check backward for connected shelves
      for (let i = shelvesAtSameLevel.indexOf(selectedShelf) - 1; i >= 0; i--) {
          if (shelvesAtSameLevel[i].x + shelvesAtSameLevel[i].drawWidth === mergedShelves[0].x) {
              mergedShelves.unshift(shelvesAtSameLevel[i]); // Add to the beginning
          } else {
              break;
          }
      }

      // Check forward for connected shelves
      for (let i = shelvesAtSameLevel.indexOf(selectedShelf) + 1; i < shelvesAtSameLevel.length; i++) {
          if (shelvesAtSameLevel[i].x === mergedShelves[mergedShelves.length - 1].x + mergedShelves[mergedShelves.length - 1].drawWidth) {
              mergedShelves.push(shelvesAtSameLevel[i]); // Add to the end
          } else {
              break;
          }
      }
      return mergedShelves;
  }

  // this function return the product list which is in the selected shelfs and similar level shelfs
  export function getSelectedProducts(existingProducts, selectedShelfSet, selectedProductBlock) {
    // Create a Set of IDs from selectedProductBlock for quick lookup
    const selectedProductIds = new Set(selectedProductBlock.map(product => product.id));
    
    // Filter products based on the conditions and exclude products in selectedProductBlock
    return existingProducts.filter(product => {
      const isInSelectedShelf = selectedShelfSet.some(shelf =>
          product?.shelfrank == shelf?.rank &&
          product?.field_custom_id == shelf?.field_custom_id &&
          (product?.isDelete === undefined || product?.isDelete === false) &&
          // remove hangged products
          (product?.isHanged === undefined || product?.isHanged === false)
      );

      const isNotInSelectedBlock = !selectedProductIds.has(product.id);

      return isInSelectedShelf && isNotInSelectedBlock;
    });
  }
  


  export function BlockContextMenu(props) {
    var xPos = props.xpos; //x position
    var yPos = props.ypos; //y position

    const popupRef = React.useRef(null);
    const [adjustedXPos, setAdjustedXPos] = React.useState(xPos);
    const [adjustedXposRTL, setAdjustedXposRTL] = React.useState(xPos);
    const [adjustedYPos, setAdjustedYPos] = React.useState(yPos);

    React.useEffect(() => {
      if (popupRef.current) {
        const popupRect = popupRef.current.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const parentRect = props.parentRef.current.getBoundingClientRect();
  
        if(props.isRTL === "rtl") {
          const newXPosRTL = Math.max(xPos, parentRect?.width - popupRect.width);
          //ensure it doesn't go off-screen on the right
          setAdjustedXposRTL(newXPosRTL < 0 ? 0 : newXPosRTL);
        }else{
          // Adjust x position to prevent overflow
          const newXPos = Math.min(xPos, parentRect?.width - popupRect.width);
          setAdjustedXPos(newXPos < 0 ? 0 : newXPos); // Ensure it doesn't go off-screen on the left 
        }
      }
    }, [xPos, yPos , props.isRTL, props.parentRef]);

    
    //handle click a button.  type: 1-delete,2-close,3-cut
    const handleClick = (type,event) => {
        if(type === 1){
            props.handleBlockDelete(false,true);
        } else if(type === 3){
          props.handleBlockCut();
        } else if(type === 5){
          props.handleBlockCut(true);
        } else
        {
            props.handlclose();
        }
    }
    
    return (<div className="rect-context-menu" onContextMenu={(e)=>{ e.preventDefault()}} style={{ top: yPos, left:  props.isRTL === "rtl" ? adjustedXposRTL : adjustedXPos }}>
              <ul className="text-center">
                  <li onClick={() => handleClick(1)}>{i18n.t("btnnames.delete")}</li><hr/>
                  <li onClick={() => handleClick(5)}>{i18n.t("COPY")}</li><hr/>
                  <li onClick={() => handleClick(3)}>{i18n.t("CUT")}</li><hr/>
                  <li onClick={() => handleClick(2)}>{i18n.t("btnnames.close")}</li>
              </ul>
            </div>
            );
  }
  
  export class NoSimProductsComp extends React.Component{
    constructor(props){
      super(props);

      this.state = {
        isListViewActive: "LIST",
        isdropdownopen:false,
      }
    }

    setisListViewActive = (ctype) =>{
      this.setState({ isListViewActive: ctype });
    }
    showWhyNotEligible=(prod)=>{
      //check reson not undifine
      var icon =<></>
      var nonsimreson=prod.notSimulatedReason
      // nonsimreson="none"
      if(nonsimreson){
        if(nonsimreson===notSimulatedReason.none){
          icon =<span title={this.props.t("NO_REASON")}><FeatherIcon color="red" icon="slash" size={14} /></span>
        }else
        if(nonsimreson===notSimulatedReason.heightIssue){
          icon =<span title={this.props.t("HEIGHT_NOT_ENOUGH")}><FeatherIcon color="red" icon="arrow-up-circle" size={14} /></span>
        }else
        if(nonsimreson===notSimulatedReason.minQtyIssue){
          icon =<span title={this.props.t("MIN_QTY")} style={{color:"red"}}>Qty</span>
        }
        else
        if(nonsimreson===notSimulatedReason.noEnoughSpace){
          icon =<span title={this.props.t("NOT_ENOGH_SPACE")} style={{color:"red"}}><CodeSquareIcon size={14} /></span>
        }else
        if(nonsimreson===notSimulatedReason.noTagMatching){
          icon =<span title={this.props.t("NO_TAG_MATCHING")}><FeatherIcon color="red" icon="tag" size={14} /></span>
        }else
        if(nonsimreson===notSimulatedReason.missingDimensions){
          icon =<span title={this.props.t("MISSING_DIMENSIONS")}><FeatherIcon color="red" icon="alert-circle" size={14} /></span>
        } else {
          const formattedReason = nonsimreson.replace(/_/g, ' ').replace(/^./, str => str.toUpperCase());
          icon=<span title={formattedReason}><FeatherIcon color="red" icon="alert-circle" size={14} /></span>
        }
      }
      

      return icon
    }
    onToggleHandler = (isOpen) => {
         this.setState({isdropdownopen:isOpen})
    }
    render(){
      // Generate filter lists from nonfilteredNonEProducts instead of using old API-fetched lists
      const nonfilteredProducts = this.props.nonfilteredNonEProducts || [];

      // Build category list from actual products
      const categoryMap = new Map();
      categoryMap.set(-1, {value: -1, label: this.props.t("NONE")});
      nonfilteredProducts.forEach(prod => {
        const catId = prod?.categoryId || prod?.category?.categoryId;
        const catName = prod?.categoryName || prod?.category?.categoryName;
        if (catId && catName && !categoryMap.has(catId)) {
          categoryMap.set(catId, {value: catId, label: displayGroupName(catName, this.props.t)});
        }
      });
      let filtercategoryList = Array.from(categoryMap.values());

      // Build subcategory list from actual products
      const subcategoryMap = new Map();
      subcategoryMap.set(-1, {value: -1, label: this.props.t("NONE")});
      nonfilteredProducts.forEach(prod => {
        const subCatId = prod?.subCat?.subCategoryid || prod?.subCategoryId;
        const subCatName = prod?.subCat?.subCategoryName || prod?.subCategoryName;
        if (subCatId && subCatName && !subcategoryMap.has(subCatId)) {
          subcategoryMap.set(subCatId, {value: subCatId, label: displayGroupName(subCatName, this.props.t)});
        }
      });
      let filterSubcategoryList = Array.from(subcategoryMap.values());

      // Build brand list from actual products
      const brandMap = new Map();
      brandMap.set(-1, {value: -1, label: this.props.t("NONE")});
      nonfilteredProducts.forEach(prod => {
        const brandId = prod?.brand?.brandid || prod?.brand?.brandId || prod?.brandId;
        const brandName = prod?.brand?.brandName || prod?.brandName;
        if (brandId && brandName && !brandMap.has(brandId)) {
          brandMap.set(brandId, {value: brandId, label: displayGroupName(brandName, this.props.t)});
        }
      });
      let filterBrnadList = Array.from(brandMap.values());

      // Build supplier list from actual products
      const supplierMap = new Map();
      supplierMap.set(-1, {value: -1, label: this.props.t("NONE")});
      nonfilteredProducts.forEach(prod => {
        const supplierId = prod?.supplier?.supplierId || prod?.supplierId;
        const supplierName = prod?.supplier?.supplierName || prod?.supplierName;
        if (supplierId && supplierName && !supplierMap.has(supplierId)) {
           supplierMap.set(supplierId, {value: supplierId, label: displayGroupName(supplierName, this.props.t)});
        }
      });
      let filterSupplierList = Array.from(supplierMap.values());
      const isFiltersApplied = this.props.selectedNonSimFilterCat.value>0 | this.props.selectedNonSimFiltersubCat.value>0 | this.props.selectedNonSimFilterBrand.value>0 | this.props.selectedNonSimFilterSupp.value>0
      return <Col>
        <div className={isFiltersApplied ? 'filter-tags' : ''}>
              {this.props.selectedNonSimFilterCat.value>0?<TooltipWrapper placement="bottom" text=  {this.props.selectedNonSimFilterCat.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                  <span className='lable'>C: {this.props.selectedNonSimFilterCat.label}</span>
                  <span className='close' onClick={()=> this.props.togglenonSimFilter({value:-1, label:this.props.t("NONE")},"cat")}><XIcon size={15} /></span>
                </Col>
              </TooltipWrapper>:<></>}
              {this.props.selectedNonSimFiltersubCat.value>0?<TooltipWrapper placement="bottom" text=  {this.props.selectedNonSimFiltersubCat.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                <span className='lable'>SC: {this.props.selectedNonSimFiltersubCat.label}</span>
                <span className='close' onClick={()=>this.props.togglenonSimFilter({value:-1, label:this.props.t("NONE")},"subcat")}><XIcon size={15} /></span>
                </Col> 
              </TooltipWrapper>:<></>}
              {this.props.selectedNonSimFilterBrand.value>0?<TooltipWrapper placement="bottom" text=  {this.props.selectedNonSimFilterBrand.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                <span className='lable'>B: {this.props.selectedNonSimFilterBrand.label}</span>
                <span className='close' onClick={()=>this.props.togglenonSimFilter({value:-1, label:this.props.t("NONE")},"brand")}><XIcon size={15} /></span>
                </Col> 
              </TooltipWrapper>:<></>}
              {this.props.selectedNonSimFilterSupp.value>0?<TooltipWrapper placement="bottom" text=  {this.props.selectedNonSimFilterSupp.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                <span className='lable'>S: {this.props.selectedNonSimFilterSupp.label}</span>
                <span className='close' onClick={()=>this.props.togglenonSimFilter({value:-1, label:this.props.t("NONE")},"supllier")}><XIcon size={15} /></span>
                </Col> 
              </TooltipWrapper>:<></>}
        </div>
        <Col className='searchprodBox'>
        {/* <div>
          <div id="sim-options"/>
        </div> */}
          {(this.state.isListViewActive!==null&&this.props.nonfilteredNonEProducts&&this.props.nonfilteredNonEProducts.length>0&&(this.props.nonfilteredNonEProducts.filter(p=>p.isAdded!==true).length>0)?<>
            <div className='filter-sec'>
              <InputGroup size="sm" className="mb-3 input-search">
                  <InputGroup.Text id="inputGroup-sizing-sm"><SearchIcon size={18}/></InputGroup.Text>
                  <Form.Control id="filterprodtxt" aria-label="Small" value={this.props.noSim_filter} placeholder={this.props.t('srchproduct')} aria-describedby="inputGroup-sizing-sm" onChange={e => this.props.handleFilterNoEProducts(e.target.value)}/>
              </InputGroup>
              <Dropdown className='morefilterbtn nonfim-filter' show={this.state.isdropdownopen} onToggle={(isOpen, e, metadata) => this.onToggleHandler(isOpen, e, metadata)}>
                <Dropdown.Toggle variant="outline-primary" size='sm'>
                    <div className='Fbutton' ><FilterIconNew  dmode={this.props.dmode}/></div>
                    {(parseInt(this.props.selectedNonSimFilterCat.value)>0||parseInt(this.props.selectedNonSimFiltersubCat.value)>0||parseInt(this.props.selectedNonSimFilterBrand.value)>0||parseInt(this.props.selectedNonSimFilterSupp.value)>0)?
                    <div className='red-dot-more-filterscomman'></div>
                    :<></>}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Col className='prodlist-container nonsimfilter-container' style={{width: 358}}>
                    <Row>
                      <Col className="form-subcontent">
                          <label>{this.props.t('category')}</label>
                          <Select 
                              placeholder={this.props.t("category")} 
                              options={filtercategoryList} 
                              onChange={(e) => this.props.togglenonSimFilter(e,"cat")} 
                              value={filtercategoryList.filter(option => option.value === this.props.selectedNonSimFilterCat.value)} 
                              className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                              maxMenuHeight={200}    
                              />
                      </Col>
                      <Col className="form-subcontent">
                          <label>{this.props.t('subcategory')}</label>
                          <Select 
                          placeholder={this.props.t("subcategory")} 
                          options={filterSubcategoryList} 
                          onChange={(e) => this.props.togglenonSimFilter(e,"subcat")} 
                          value={filterSubcategoryList.filter(option => option.value === this.props.selectedNonSimFiltersubCat.value)} 
                          className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                          maxMenuHeight={200}    
                                      />
                      </Col>
                    </Row>
                    <Row>
                    <Col className="form-subcontent">
                      <label>{this.props.t('brand')}</label>
                          <Select 
                          placeholder={this.props.t("brand")} 
                          options={filterBrnadList} 
                          onChange={(e) =>  this.props.togglenonSimFilter(e,"brand")} 
                          value={filterBrnadList.filter(option => option.value ===this.props.selectedNonSimFilterBrand.value)} 
                          className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                          maxMenuHeight={200}    
                          />
                      </Col>
                      <Col className="form-subcontent">
                          <label>{this.props.t('suplable')}</label>
                          <Select 
                          placeholder={this.props.t("suplable")} 
                          options={filterSupplierList} 
                          onChange={(e) => this.props.togglenonSimFilter(e,"supllier")} 
                          value={filterSupplierList.filter(option => option.value === this.props.selectedNonSimFilterSupp.value)} 
                          className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                          maxMenuHeight={200}    
                                      />
                      </Col>
                    </Row>
                  </Col>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            
      
            <ButtonGroup style={{direction:"ltr"}} className={"pviewchange-list "+(this.props.isRTL=== "rtl"?"float-left":"float-right")}>
                {this.props.isRTL === "rtl" ? (
                    <>
                        <Button variant="secondary" onClick={() => this.setisListViewActive("GRID")} className={(this.state.isListViewActive==="GRID"?"active":"")}><DiffAddedIcon size={14}/></Button>
                        <Button variant="secondary" onClick={() => this.setisListViewActive("LIST")} className={(this.state.isListViewActive==="LIST"?"active":"")}><ListUnorderedIcon size={14} /></Button>
                    </>
                ) : (
                    <>
                        <Button variant="secondary" onClick={() => this.setisListViewActive("LIST")} className={(this.state.isListViewActive==="LIST"?"active":"")}><ListUnorderedIcon size={14} /></Button>
                        <Button variant="secondary" onClick={() => this.setisListViewActive("GRID")} className={(this.state.isListViewActive==="GRID"?"active":"")}><DiffAddedIcon size={14}/></Button>
                    </>
                )}
            </ButtonGroup>

              <Col className="col-xs-12 div-con">
                  <h5>{this.props.t('productslist')}
                  ({this.props.nonfilteredNonEProducts.filter(x=>x.isAdded!==true && x.isFilterd!==true && x.barcode && x.productName).length})
                  </h5>
                  <Col xs={12}  className="div-con subprod-list" style={{height: this.props.simType === 'AUI' ? isFiltersApplied ? this.props.catDivHeight - 120 : this.props.catDivHeight - 85 : isFiltersApplied ? this.props.catDivHeight + 120 : this.props.catDivHeight + 150}}>
                    <Row style={this.props.isRTL === "rtl"?{marginRight:"0px",width:"100%"}:{marginLeft:"0px",width:"100%"}}>
                      {/* {
                        // console.log(this.props.nonfilteredNonEProducts,"_________PRINT");
                      } */}
                        {(this.props.nonfilteredNonEProducts ? this.props.nonfilteredNonEProducts.map((prod, i) =>
                        {
                        const productShowLogic = (!prod.isAdded && !prod.isFilterd && prod.barcode && 'prod.productName || prod.name')
                        return  productShowLogic ?
                          <Col key={i} className={"sub-item"+(this.state.isListViewActive==="LIST"?"":" rectview")} xs={this.state.isListViewActive==="LIST"?12:4}><Col style={{ margin: 5}}>
                            {/* <span className={"editlink "+(prod.rotatetype&&(prod.rotatetype!=="default"&&prod.rotatetype!=="front"?"highred":""))} title={prod.rotatetype?(prod.rotatetype.replace("_"," ")):"default"} onClick={() => this.toggleRotateProd(prod,true)} style={(this.props.isRTL==="rtl"?{left:"35px"}:{right:"35px"})}><IssueReopenedIcon size={14}/></span>
                            <span className="editlink" onClick={() => this.handlePEMView(true,prod,false)}><ArrowSwitchIcon size={14}/></span> */}
                            <ProdRectView t={this.props.t} isRTL={this.props.isRTL} viewtype={this.state.isListViewActive} prod={prod}>
                                <div className="thumb-div" draggable id={prod.id} onClick={()=>this.props.handlePreviewModal(prod,true)} onMouseDown={(e) => {this.props.drawRectCanvas(prod)}} onDragStart={(e) => this.props.dragStart(e, prod)} onDrag={e => this.props.dragProdView(e, prod)} onDragEnd={() => this.props.prodDragEnd()}>
                                  <img key={i} src={prod?.imageUrl}
                                  style={{maxWidth: '100%', maxHeight: '100%', objectFit: 'contain'}}
                                   alt=""/>
                                </div>
                              </ProdRectView>
                              {(this.state.isListViewActive==="LIST"?
                                  <>
                                  <CopyToClipboard text={(prod.barcode?prod.barcode:"-")} onCopy={() => this.props.copyToClipboard()}><small style={{fontSize:"0.75rem"}}>{(prod.barcode?prod.barcode:"-")}</small></CopyToClipboard>
                                  <small className="nonesimReeson">{this.showWhyNotEligible(prod)}</small>
                                  {prod.isDimensionsChange?<small className="dimention-chnged"> <TooltipWrapper text={this.props.t("DIMENSION_CHNGES_NOT_AFFECTED")}><FeatherIcon icon="alert-triangle" size={16} /></TooltipWrapper></small>:<></>}
                                  <br/>
                                  <div style={{cursor:"pointer"}} onClick={()=>this.props.handleopenDetailmodal(prod)}>
                                  {(prod.productName?prod.productName:"-")}<br/>
                                  <small>{this.props.t("brand")+": "}{(prod.brandName && prod.brandName !== "" && prod.brandName !== "-")?(displayGroupName(prod.brandName, this.props.t)+" "):(this.props.t("notavailable")+" ")}</small><br/>
                                  <small style={{fontSize:"0.75rem"}}><i>
                                    {this.props.t('width')}: {(prod.width > 0?(roundOffDecimal(prod.width,numOfDecimalsLimit)+""+convertUomtoSym(prod.uom)):"0cm")},
                                    {this.props.t('height')}: {prod.height > 0?(roundOffDecimal(prod.height,numOfDecimalsLimit)+""+convertUomtoSym(prod.uom)):"0cm"}</i></small>
                                    </div>
                                  </>:
                              <></>)}
                          </Col></Col>
                          :<div key={i}></div>}
                          ):(<></>)
                        )}
                        {/* {this.state.srchprodsloading?<Col xs={12} className="text-center" style={{marginBottom: "5px"}}><img src={loadinggif} className="img-fluid" style={{height:"20px"}} alt="" /></Col>:<></>} */}
                    </Row>
                    {/* {props.filteredNonEProducts.length < this.state.ptotalresults?
                    <Col xs={12} className="ploadmore-link text-center" onClick={() => {this.loadMoreProds()}}>{this.props.t('btnnames.loadmore')}</Col>:<></>} */}
                  </Col>
                </Col>
              </>:
              <Col style={{paddingTop:"10px"}}><h4 className='text-center' style={{color: "#ccc", marginTop:"2rem"}}>{this.props.t("NO_PRODUCTS_AVAILABLE")}</h4></Col>)}
            </Col>
              
        </Col>;
    }
  }

  function ProdRectView(props) {
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const prod = props.prod;
    const isshowview = (props.viewtype === "LIST"?false:true);
    const trans = props.t;
    return (
      <>
        <div ref={target} onMouseOver={() => setShow(isshowview)} onMouseOut={() => setShow(false)}>
          {props.children}
        </div>
        <Overlay target={target.current} transition={false} show={show} 
        // placement={props.isRTL==="rtl"?"left":"right"}
        placement='top'
        >
          {(props) => (
            <Tooltip {...props}>
              <><small style={{fontSize:"0.75rem"}}>{prod.barcode&&prod.barcode}</small><br/>{(prod.brandName&&prod.brandName!==""&&prod.brandName!=="-"?(displayGroupName(prod.brandName, (k) => i18n.t(k))+" "):(i18n.t("notavailable")+" "))+prod.productName}<br/>
              <small style={{fontSize:"0.75rem"}}><i>{trans?trans('WIDTH'):"Width"} {prod.width+""+convertUomtoSym(prod.uom)}, {trans?trans('HEIGHT'):"Height"} {prod.height+""+convertUomtoSym(prod.uom)}</i></small></>
            </Tooltip>
          )}
        </Overlay>
      </>
    );
  }

  export function DimensionChangedProdComp (props){
    const [productEditWarningsList,setproductEditWarningsList] = useState([]);
    
    useEffect(() => { 
      setproductEditWarningsList(props.productEditWarningsList)
    }, [props.productEditWarningsList]);
    
    const handleFilterProducts = (evt) => { 
      let updList=structuredClone(props.productEditWarningsList)
      let newlist=[]
      let searchTxt = (evt.target.value && evt.target.value.length > 0?evt.target.value:"");
            for (let i = 0; i < updList.length; i++) {
                const nonladprod = updList[i];
                let nonSearchQuery = ((nonladprod.barcode?nonladprod.barcode.toLowerCase():"")+" "+(nonladprod.productName?nonladprod.productName.toLowerCase():""));
                let isnotfiltered=(nonSearchQuery.includes(searchTxt.toLowerCase())  );
                if(isnotfiltered){
                  newlist.push(nonladprod)
                }
            }
            setproductEditWarningsList(newlist)
    }
    return <Col >
      <Col className='searchprodBox'>                    
        {props.productEditWarningsList.length>0?<InputGroup size="sm" className="mb-3 input-search">
            <Form.Control id="filterprodtxt" aria-label="Small" placeholder={props.t('srchproduct')} aria-describedby="inputGroup-sizing-sm" onKeyUp={e => handleFilterProducts(e)}/>
            {/* <InputGroup.Prepend> */}
                <InputGroup.Text id="inputGroup-sizing-sm"><SearchIcon size={18}/></InputGroup.Text>
            {/* </InputGroup.Prepend> */}
        </InputGroup>:<></>}
        {(productEditWarningsList.length>0?<>
              <Col className="col-xs-12 div-con">
                  <h5>{props.t('productslist')} <span className='clearall-dim-prod' onClick={()=>props.handleacknowledgeSimulationWarning()}>{props.t("btnnames.clearall")}</span>
                  </h5>
                 
                  <Col xs={12}  className="div-con subprod-list" style={{height: props.simType === 'AUI' ? props.catDivHeight - 85 : props.catDivHeight + 150}}>
                    <Row style={props.isRTL === "rtl"?{marginRight:"0px",width:"100%"}:{marginLeft:"0px",width:"100%"}}>
                        {(productEditWarningsList ?productEditWarningsList.map((prod, i) =>
                        
                          { return  (!prod.isAdded && !prod.isFilterd && prod.barcode && prod.productName)?
                          <Col key={i} className="sub-item" xs={12}><Col style={{ margin: 5}}>
                            {/* <span className={"editlink "+(prod.rotatetype&&(prod.rotatetype!=="default"&&prod.rotatetype!=="front"?"highred":""))} title={prod.rotatetype?(prod.rotatetype.replace("_"," ")):"default"} onClick={() => this.toggleRotateProd(prod,true)} style={(this.props.isRTL==="rtl"?{left:"35px"}:{right:"35px"})}><IssueReopenedIcon size={14}/></span>
                            <span className="editlink" onClick={() => this.handlePEMView(true,prod,false)}><ArrowSwitchIcon size={14}/></span> */}
                            <ProdRectView t={props.t} isRTL={props.isRTL} viewtype={"LIST"} prod={prod}>
                                {/* onMouseDown={(e) => {props.drawRectCanvas(prod)}} onDragStart={(e) => props.dragStart(e, prod)} onDrag={e => props.dragProdView(e, prod)} onDragEnd={() => props.prodDragEnd()} */}
                                <div className="thumb-div" draggable id={prod.id} onClick={()=>props.handlePreviewModal(prod,true)}>
                                  <img key={i} src={prod.imageUrl} className={(prod.width >= prod.height)?"img-resize-ver":"img-resize-hor"} alt=""/>
                                </div>
                              </ProdRectView>
                                  <>
                                  <CopyToClipboard text={(prod.barcode?prod.barcode:"-")} onCopy={() => props.copyToClipboard()}><small style={{fontSize:"0.75rem"}}>{(prod.barcode?prod.barcode:"-")}</small></CopyToClipboard>
                                  <TooltipWrapper placement="bottom" text=  {props.t("REMOVE")}><small onClick={()=>props.handleacknowledgeSimulationWarning(prod)} className="nonesimReeson aknowladge"><FeatherIcon icon="delete" size={16} /></small></TooltipWrapper>
                                  <br/>
                                  <div style={{cursor:"pointer"}} onClick={()=>props.handleopenDetailmodal(prod)}>
                                    {(prod.productName?prod.productName:"-")}<br/>
                                    <small>{props.t("brand")+": "}{(prod.brandName && prod.brandName !== "" && prod.brandName !== "-")?(displayGroupName(prod.brandName, props.t)+" "):(props.t("notavailable")+" ")}</small><br/>
                                    <small style={{fontSize:"0.75rem"}}><i>{props.t('width')}: {(prod.width > 0?(prod.width+""+convertUomtoSym(prod.uom)):"0cm")}, {props.t('height')}: {prod.height > 0?(prod.height+""+convertUomtoSym(prod.uom)):"0cm"}</i></small>
                                  </div>
                                 </>
                             
                          </Col></Col>
                          :<div key={i}></div>}
                          ):(<></>)
                        )}
                        {/* {this.state.srchprodsloading?<Col xs={12} className="text-center" style={{marginBottom: "5px"}}><img src={loadinggif} className="img-fluid" style={{height:"20px"}} alt="" /></Col>:<></>} */}
                    </Row>
                    {/* {props.filteredNonEProducts.length < this.state.ptotalresults?
                    <Col xs={12} className="ploadmore-link text-center" onClick={() => {this.loadMoreProds()}}>{this.props.t('btnnames.loadmore')}</Col>:<></>} */}
                  </Col>
                </Col>
              </>:
              <Col style={{paddingTop:"10px"}}><h4 className='text-center' style={{color: "#ccc", marginTop:"2rem"}}>{props.t("NO_PRODUCTS_AVAILABLE")}</h4></Col>)}
        {/* <Col className="col-xs-12 div-con">
          <h5>{i18n.t('productslist')}</h5>
          <><CopyToClipboard text={(prod.barcode?prod.barcode:"-")} onCopy={() => this.props.copyToClipboard()}><small style={{fontSize:"0.75rem"}}>{(prod.barcode?prod.barcode:"-")}</small></CopyToClipboard>
                                  <small className="nonesimReeson">{this.showWhyNotEligible(prod)}</small>
                                  <br/>
                                  {(prod.productName?prod.productName:"-")}<br/>
                                  <small>{this.props.t("brand")+": "}{(prod.brandName && prod.brandName !== "" && prod.brandName !== "-")?(prod.brandName+" "):(this.props.t("notavailable")+" ")}</small><br/>
                                  <small style={{fontSize:"0.75rem"}}><i>{this.props.t('width')}: {(prod.width > 0?(prod.width+""+convertUomtoSym(prod.uom)):"0cm")}, {this.props.t('height')}: {prod.height > 0?(prod.height+""+convertUomtoSym(prod.uom)):"0cm"}</i></small></>
        </Col> */}
      </Col>
    </Col>
  }

  export class SaleCycleComp extends React.Component{
    constructor(props){
      super(props);

      this.state = {
        isdropdownopen:false,
      }
    }

    onToggleHandler = (isOpen) => {
         this.setState({isdropdownopen:isOpen})
    }
    
    render(){
      let filtercategoryList = JSON.parse(JSON.stringify(this.props.scFilter_categoryList));
      filtercategoryList[0] = {value:-1, label:this.props.t("Any")};
      let filterBrnadList = JSON.parse(JSON.stringify(this.props.scFilter_brandsList));
      filterBrnadList[0] = {value:-1, label:this.props.t("Any")};
      let filterSupplierList = JSON.parse(JSON.stringify(this.props.scFilter_supplierList));
      filterSupplierList[0] = {value:-1, label:this.props.t("Any")};
      let filterSubcategoryList = JSON.parse(JSON.stringify(this.props.scFilter_subcategoryList));
      filterSubcategoryList[0] = {value:-1, label:this.props.t("Any")};
      let filterStatusList = JSON.parse(JSON.stringify(this.props.scFilter_statusList));
      filterStatusList[0] = {value:-1, label:this.props.t("Any")};
      const isFiltersApplied = this.props.selectedScFilterCat.value>0 | this.props.selectedScFiltersubcat.value>0 | this.props.selectedScFilterBrand.value>0 | this.props.selectedScFilterSupp.value>0 | parseInt(this.props.selectedScFilterStat.value)!==-1
      return <Col>
        <Col className={isFiltersApplied ? 'filter-tags' : ''}>
              {this.props.selectedScFilterCat.value>0?<TooltipWrapper placement="bottom" text=  {this.props.selectedScFilterCat.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                  <span className='lable'>C: {this.props.selectedScFilterCat.label}</span>
                  <span className='close' onClick={()=> this.props.toggleSCFilter({value:-1, label:this.props.t("NONE")},"cat")}><XIcon size={15} /></span>
                </Col>
              </TooltipWrapper>:<></>}
              {this.props.selectedScFiltersubcat.value>0?<TooltipWrapper placement="bottom" text=  {this.props.selectedScFiltersubcat.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                <span className='lable'>SC: {this.props.selectedScFiltersubcat.label}</span>
                <span className='close' onClick={()=>this.props.toggleSCFilter({value:-1, label:this.props.t("NONE")},"subcat")}><XIcon size={15} /></span>
                </Col> 
              </TooltipWrapper>:<></>}
              {this.props.selectedScFilterBrand.value>0?<TooltipWrapper placement="bottom" text=  {this.props.selectedScFilterBrand.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                <span className='lable'>B: {this.props.selectedScFilterBrand.label}</span>
                <span className='close' onClick={()=>this.props.toggleSCFilter({value:-1, label:this.props.t("NONE")},"brand")}><XIcon size={15} /></span>
                </Col> 
              </TooltipWrapper>:<></>}
              {this.props.selectedScFilterSupp.value>0?<TooltipWrapper placement="bottom" text=  {this.props.selectedScFilterSupp.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                <span className='lable'>S: {this.props.selectedScFilterSupp.label}</span>
                <span className='close' onClick={()=>this.props.toggleSCFilter({value:-1, label:this.props.t("NONE")},"supllier")}><XIcon size={15} /></span>
                </Col> 
              </TooltipWrapper>:<></>}
              {parseInt(this.props.selectedScFilterStat.value)!==-1?<TooltipWrapper placement="bottom" text=  {this.props.selectedScFilterStat.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                <span className='lable'>STS: {this.props.selectedScFilterStat.label}</span>
                <span className='close' onClick={()=>this.props.toggleSCFilter({value:-1, label:this.props.t("NONE")},"status")}><XIcon size={15} /></span>
                </Col> 
              </TooltipWrapper>:<></>}
        </Col>

        <Col className='searchprodBox'>
        
          <div className='filter-sec'>
            <InputGroup size="sm" className="mb-3 input-search">
                <Form.Control id="filterprodtxt" aria-label="Small" value={this.props.sc_filter} placeholder={this.props.t('srchproduct')} aria-describedby="inputGroup-sizing-sm" onChange={e => this.props.handleFilterSCProducts(e.target.value)}/>
                <InputGroup.Text id="inputGroup-sizing-sm"><SearchIcon size={18}/></InputGroup.Text>
            </InputGroup>
            <Dropdown className='morefilterbtn nonfim-filter' show={this.state.isdropdownopen} onToggle={(isOpen, e, metadata) => this.onToggleHandler(isOpen, e, metadata)}>
              <Dropdown.Toggle variant="outline-primary" size='sm'>
                  <div className='Fbutton'><FilterIconNew  dmode={this.props.dmode}/></div>
                  {(parseInt(this.props.selectedScFilterCat.value)>0||parseInt(this.props.selectedScFiltersubcat.value)>0||parseInt(this.props.selectedScFilterBrand.value)>0||parseInt(this.props.selectedScFilterSupp.value)>0||parseInt(this.props.selectedScFilterStat.value)>0)?
                  <div className='red-dot-more-filterscomman'></div>
                  :<></>}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Col className='prodlist-container nonsimfilter-container' style={{width: 338}}>
                  <Row>
                    <Col className="form-subcontent">
                        <label>{this.props.t('category')}</label>
                        <Select 
                            placeholder={this.props.t("category")} 
                            options={filtercategoryList} 
                            onChange={(e) => this.props.toggleSCFilter(e,"cat")} 
                            value={filtercategoryList.filter(option => option.value === this.props.selectedScFilterCat.value)} 
                            className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                            maxMenuHeight={200}    
                            />
                    </Col>
                    <Col className="form-subcontent">
                        <label>{this.props.t('subcategory')}</label>
                        <Select 
                        placeholder={this.props.t("subcategory")} 
                        options={filterSubcategoryList} 
                        onChange={(e) => this.props.toggleSCFilter(e,"subcat")} 
                        value={filterSubcategoryList.filter(option => option.value === this.props.selectedScFiltersubcat.value)} 
                        className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                        maxMenuHeight={200}    
                                    />
                    </Col>
                  </Row>
                  <Row>
                  <Col className="form-subcontent">
                    <label style={{margin: '11px 0'}}>{this.props.t('brand')}</label>
                        <Select 
                        placeholder={this.props.t("brand")} 
                        options={filterBrnadList} 
                        onChange={(e) =>  this.props.toggleSCFilter(e,"brand")} 
                        value={filterBrnadList.filter(option => option.value ===this.props.selectedScFilterBrand.value)} 
                        className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                        maxMenuHeight={200}    
                        />
                    </Col>
                    <Col className="form-subcontent">
                        <label style={{margin: '11px 0'}}>{this.props.t('suplable')}</label>
                        <Select 
                        placeholder={this.props.t("suplable")} 
                        options={filterSupplierList} 
                        onChange={(e) => this.props.toggleSCFilter(e,"supllier")} 
                        value={filterSupplierList.filter(option => option.value === this.props.selectedScFilterSupp.value)} 
                        className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                        maxMenuHeight={200}    
                                    />
                    </Col>
                    <Col className="form-subcontent">
                        <label>{this.props.t(`SALE_CYCLE`)+' '+this.props.t(`status`)}</label>
                        <Select 
                        placeholder={this.props.t(`status`)} 
                        options={filterStatusList} 
                        onChange={(e) => this.props.toggleSCFilter(e,"status")} 
                        value={filterStatusList.filter(option => option.value === this.props.selectedScFilterStat.value)} 
                        className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                        maxMenuHeight={200}    
                                    />
                    </Col>
                  </Row>
                </Col>
              </Dropdown.Menu>
            </Dropdown>
            <span className="sim-edit-info-icon">
              <PopoverWrapper cusid="sim-edit-pop" trigger={["hover","focus"]} 
                  text={
                      <div className='popover-cont'>
                            <h6>{this.props.t("SALE_CYCLE_LOGIC")}</h6>
                            <div className="formula">
                                <span className="image">
                                  <Image src={SalesCycleIcon}/>
                                </span>
                                <span className="word">
                                  {this.props.t("SALE_CYCLE")}
                                </span>
                                <span className="signs">
                                  =
                                </span>
                                <span className="image">
                                  <Image src={ThreeDQtyIcon}/>
                                </span>
                                <span className="word">
                                  {this.props.t('THREEDQTY')}
                                </span>
                                <span className="signs">
                                  {this.props.isRTL === "rtl" ?')/' : '/('}
                                </span>
                                <span className="image">
                                  <Image src={SaleQtyIcon}/>
                                </span>
                                <span className="word">
                                  {this.props.t('SALEQTY')}
                                </span>
                                <span className="signs">
                                  /
                                </span>
                                <span className="image">
                                  <Image src={DayCountIcon}/>
                                </span>
                                <span className="word">
                                  {this.props.t('DAYCOUNT')}
                                </span>
                                <span className="signs">
                                  {this.props.isRTL === "rtl" ? '(' : ')'}
                                </span>
                            </div>
                      </div>
                  } placement="top">
                  <FeatherIcon icon="info" size={20}/>
              </PopoverWrapper>
            </span>
          </div>
          { this.props.isChainSaleCycle ?
          <div className="chain-level-warn">
            <span className="chain-warn-icon">
                  <Image src={WarnIcon} />
            </span>
            <span className="chain-warn-text">
                  {this.props.t('CAL_CHAIN')} 
            </span>
          </div>
          :<></>}
            {(this.props.nonfilteredSCProducts&&this.props.nonfilteredSCProducts.length>0?
            <>
            <Col className="col-xs-12 div-con">
                <Col xs={12}  className="div-con subprod-list sale-cycle-list" style={{height: this.props.simType === 'AUI' ? isFiltersApplied ? this.props.catDivHeight - 120 : this.props.catDivHeight - 80 : isFiltersApplied ? this.props.catDivHeight + 120 : this.props.catDivHeight + 150}}>
                  <Row style={this.props.isRTL === "rtl"?{marginRight:"0px",width:"100%"}:{marginLeft:"0px",width:"100%"}}>
                      {(this.props.nonfilteredSCProducts ? this.props.nonfilteredSCProducts.map((prod, i) => {
                        return (// { return  (!prod.isAdded && !prod.isFilterd && prod.barcode && prod.productName)?
                        <Col key={i} style={{ border: this.props.selectedScProductId === prod.productId ? this.props.dmode ? "2px solid #2CC990" : "2px solid #5128A0" : "none", background: this.props.dmode ? "#374658" : "#F2F1FF"}} className={"sub-item"} xs={12}>
                          <Col style={{ margin: 5}}>
                                <>
                                  <div className={"color-strip-"+(prod.salesAvailable ? prod.anomaly==="no" ? "normal" : prod.anomaly==="high" ? "high" : "low"  :"none")}></div>

                                  <ProdRectView t={this.props.t} isRTL={this.props.isRTL} viewtype={"LIST"} prod={prod}>
                                    <div className="thumb-div-sc" id={prod.productId} onClick={()=>this.props.handlePreviewModal(prod,true)}>
                                      <img key={i} src={prod.imageUrl ? prod.imageUrl : DefaultProdImg} className={(prod.width >= prod.height)?"img-resize-ver":"img-resize-hor"} alt=""/>
                                    </div>
                                  </ProdRectView>
                                  <CopyToClipboard text={(prod.productBarcode?prod.productBarcode:"-")} onCopy={() => this.props.copyToClipboard()}><small style={{fontSize:"0.75rem"}}>{(prod.productBarcode?prod.productBarcode:"-")}</small></CopyToClipboard>
                                  <span className={"anomaly-value-"+(prod.salesAvailable ? prod.anomaly==="no" ? "normal" : prod.anomaly==="high" ? "high" : "low"  :"none")}>{prod.salesCycle ? prod.salesCycle.toFixed(2) : "-"}</span>
                                  <br/>
                                  <div className="sc-prod-name" style={{cursor:"pointer"}} onClick={()=>this.props.showSelectedSCProduct(prod.productId)}>
                                  {(prod.productName?prod.productName:"-")}<br/>
                                  </div>
                                  <div className="metrics">
                                          <span className="single-metric" title={this.props.t('THREEDQTY')}>
                                            <Image src={MiniThreeDQtyIcon}/>
                                            {prod.prodQty ? prod.prodQty : "-"}
                                          </span>

                                          <span className="single-metric" title={this.props.t('SALEQTY')}>
                                            <Image src={MiniSaleQtyIcon}/>
                                            {prod.salesAvailable ? prod.saleQty : "-"}
                                          </span>

                                          <span className="single-metric" title={this.props.t('DAYCOUNT')}>
                                            <Image src={MiniDayCountIcon}/>
                                            {prod.dayCount}
                                          </span>
                                  </div>
                                </>
                          </Col>
                        </Col>
                      )}
                        // :<div key={i}></div>}
                        ):(<></>)
                      )}
                  </Row>
                </Col>
              </Col>    
            </>:
            <Col style={{paddingTop:"10px"}}><h4 className='text-center' style={{color: "#ccc", marginTop:"2rem"}}>{this.props.t("NO_PRODUCTS_AVAILABLE")}</h4></Col>)}
      </Col>

      </Col>
    }
  }

  export function RuleWarningsComp (props){
    return(
      <Row>
        <Col xs={12} className='tab-content-view-v2' style={{height:props.simType === 'AUI' ? props.catDivHeight - 10 : props.catDivHeight + 200, marginTop: 10}}>
          <Col className='ruleswarn-content' >
      
      {props.isRuleWarn && props.isRuleWarn.totalcount > 0?<>
        <Row className='ruletitle-row'>
            <Col xs={8} className="title-col-v2">{props.trans("rules")}</Col>
            <Col xs={2} className="title-col-v2">{props.trans("RULE_PER")}</Col>
            <Col xs={2} className="title-col-v2">{props.trans("SIMULATED_PER")}</Col>
        </Row> 

        {props.mapRulesList.map((citem, cidx) => {
          return <React.Fragment key={cidx}>
            {citem.subCategoryRulePercentageDtos && citem.subCategoryRulePercentageDtos.length > 0?<><Row className="scroll-content">
              {citem.subCategoryRulePercentageDtos.map((subrule, sruledix) => {

                let ruleitemname = ((subrule.level === catRuleEnums.sup && subrule.supplier)?subrule.supplier.supplierName
                  :(subrule.level === catRuleEnums.brand && subrule.brand)?subrule.brand.brandName:"-")
                let mainbarcolor=subrule.ruleState === "danger"?"#bd132a":subrule.ruleState === "warning"?" #F39C12":subrule.ruleState === "default"?"#0eab3a":"none"
                return <React.Fragment key={sruledix}>
                  
                  <Col xs={12} className={'singlerulewarn-contain-v2'+(subrule.ruleState?(" "+subrule.ruleState):"")}>
                    <Row className='rulewarn-wrapper'>
                      <Col xs={8} style={{padding: "0px 5px"}}>
                      <CustomProgressBarForRules text={stringtrim(ruleitemname+" - "+(subrule.level?subrule.level.substring(0,3):""),30)} mainbarcolor={mainbarcolor} mainbarpercentage={subrule.simulatedPercentage} textcolor={"white"} showsubbar="true" subbarpercentage={subrule.rulePercentage} />
                        {/* <div className={'rulewarn-icon'+(subrule.ruleState?(" "+subrule.ruleState):"")}>
                          {subrule.ruleState === "danger"?<FeatherIcon icon="x-square" size={14} />:subrule.ruleState === "warning"?<FeatherIcon icon="alert-octagon" size={14} />:<FeatherIcon icon="check" size={14} />}
                        </div> */}

                        {/* <h6>{ruleitemname}<br/><small>{subrule.level}</small></h6> */}
                      </Col>
                      <Col xs={2} className='simper-wrapper'>
                        <Col className='simper-content-rule'><label style={{color: '#327DED',fontWeight: 'bold'}}>{subrule.rulePercentage}</label></Col>
                      </Col>
                      <Col xs={2} className='simper-wrapper'>
                        <Col className={'simper-content'+(subrule.ruleState?(" "+subrule.ruleState):"")}><label style={{textAlign: 'center'}}>{subrule.simulatedPercentage}</label></Col>  
                      </Col>
                    </Row>
                  </Col>
                </React.Fragment>;
              })}
            </Row></>:<></>}
          </React.Fragment>
        })}
      </>:
      <h5 className='text-center' style={{color: "#ccc", marginTop:"2rem"}}>{props.trans("NO_RULES_AVAILABLE")}</h5>}
          </Col>
        </Col>
      </Row>
      )
  }

  export function CustomProgressBarForRules(props) {
    return(
        <Col xs={12} className={"custom-progress-bar "+(props.isRTL)}>
            <Col className="name" style={{color:(props.subbarpercentage > 10 && props.textcolor?props.textcolor:"white"),textTransform:"uppercase"}}>{(props.text ? props.text:"")}</Col>
            <Col className="main-bar" style={{width:(props.mainbarpercentage+"%"), background:props.mainbarcolor}}></Col>
            {
                props.showsubbar==="true" || props.showsubbar === true ?
                <Col className="sub-bar" style={{width:(props.subbarpercentage+"%"),opacity:"0.5"}}></Col>
                :<></>
            }
            {
                props.showpercentage ?
                <span className='progress-txt'>{(props.mainbarpercentage+"%")}</span>
                :<></> 
            }
        </Col>
    )
  }

  export function ReplaceProductsTab (props){
    const [imgdropdown, setImgdropdown] = useState(null);
    const [contextMargin, setContextMargin] = useState(0);

    var prod={
      imageUrl:"https://d3ginyfiwc1r8i.cloudfront.net/main/8/7290017088693/854800_W100_100.png",height:12.5,width:32,
      barcode:8080808080,productName: "PRODUCT 197"
    }

    const handleMouseEnter = (evt, val) => {
      let elem = document.getElementById(val);
      let rect = elem.getBoundingClientRect();
      setContextMargin(rect.top);
      
      setImgdropdown(val);
    }

    const handleMouseLeave = () => {
      setImgdropdown(null);
    }
    var {replaceProds}=props
    return <Col className='replacedProd-content'>
      {replaceProds.length > 0?
      <>
       <div className='maindiv' style={{maxHeight:(props.catDivHeight+25)}}>
        {replaceProds.map((rprod,r) => {
          let tooltipid = props.viewSimID;

          return <Col key={r} className='card'>
              <Col style={{display:"flex",justifyContent:"space-between"}}>
                <div >
                  <div className="thumb-div" id={("prev"+r+""+tooltipid)} onMouseEnter={(e) => handleMouseEnter(e, ("prev"+r+""+tooltipid))} onMouseLeave={handleMouseLeave}> 
                    <img  src={rprod.currentProducts[0].imageUrl} className={(prod.width >= prod.height)?"img-resize-ver":"img-resize-hor"} alt=""/>
                    {rprod.replacedProducts.length>1&&<span className='MoreNo' 
                      // style={{left: "98px"}}
                      >{"+"+(rprod.currentProducts.length-1)}</span>}
                      {(imgdropdown===("prev"+r+""+tooltipid))&&
                      <div className="dropdown-content prev" style={{ top: (contextMargin+60)}}>
                      {rprod.currentProducts.length>0?rprod.currentProducts.map((prev,p)=> <div key={p} className='insideboxnameboxcard'>
                          <div className="thumb-div"  >
                            <img  src={prev.imageUrl} className={(prod.width >= prod.height)?"img-resize-ver":"img-resize-hor"} alt=""/>
                          </div>
                          <div className='text'><CopyToClipboard text={prev.barcode} onCopy={() => props.copyToClipboard()}><small style={{fontSize:"0.75rem"}}>{prev.barcode}</small></CopyToClipboard>
                          <h2 style={{fontSize:"0.75rem"}}>{prev.productName}</h2>
                          </div>
                        </div>):<></>}
                      </div>
                      }
                  </div>
                </div>
                <div style={{marginTop:"17px"}} className='arrow'><ReplaceProdIconArrow /></div>
                <div >
                  <div className="thumb-div" id={("now"+r+""+tooltipid)} onMouseEnter={(e) => handleMouseEnter(e, ("now"+r+""+tooltipid))} onMouseLeave={handleMouseLeave} >
                    <img  src={rprod.replacedProducts[0].imageUrl} className={(prod.width >= prod.height)?"img-resize-ver":"img-resize-hor"} alt=""/>
                    {rprod.replacedProducts.length>1&&<span className='MoreNo' 
                      // style={{left: "98px"}}
                      >{"+"+(rprod.replacedProducts.length-1)}</span>}
                      {(imgdropdown===("now"+r+""+tooltipid))&&
                      <div className="dropdown-content new" style={{ top: (contextMargin+60)}}>
                        {rprod.replacedProducts.length>0?rprod.replacedProducts.map((now,n)=> <div key={n} className='insideboxnameboxcard'>
                          <div className="thumb-div"  >
                            <img  src={now.imageUrl} className={(now.width >= now.height)?"img-resize-ver":"img-resize-hor"} alt=""/>
                          </div>
                          <div className='text'><CopyToClipboard text={now.barcode} onCopy={() => props.copyToClipboard()}><small style={{fontSize:"0.75rem"}}>{now.barcode}</small></CopyToClipboard>
                          <h2 style={{fontSize:"0.75rem"}}>{now.productName}</h2>
                          </div>
                        </div>):<></>}
                        
                      </div>
                      }
                  </div>
                </div>
              </Col>
            </Col>
          })}
       </div>
      </>
       :
      <h5 className='text-center' style={{color: "#ccc", marginTop:"2rem"}}>{props.trans("NO_REPLACED_PRODS_AVAILABLE")}</h5>} 
      </Col>;
  }

 